import {
  rlJointData,
  rlGridData,
  rlAxisData,
  rlGridArcData,
  rlJointCData,
  rlGridCData,
} from "@/rlMxModules/rlDataClass/index";
import { getRlLayer, getRlInitFloorData } from "@/mixins/LiteModuleDb.js";
import {
  MxCADSelectionSet,
  McCmColor,
  McGePoint3d,
  McDbAlignedDimension,
  McDbLine,
  MxCpp,
  MxCADResbuf,
  McDbArc,
  McDbPolyline,
  MxCADGetPoint,
} from "mxcad";

import { get_entity_by_id } from "@/rlMxModules/operate/index";
import store from "@/store";
import {
  resetRlModules,
  getRlModules,
  getrlFloor,
  getrlStdFlr,
  dealRlModulesData,
  getRlWallHoleDef,
} from "@/mixins/LiteModuleDb.js";
import { saveStepRevokeData } from "@/mixins/initRevokeData.js";
import { revokeRollback } from "@/rlMxModules/operate/revokeRollback.js";
// 接口数据
import { getDwgData, getCalData } from "@/api/cadList";

// 接口
import {
  detection,
  confirmDelete,
  delFloorDetection,
} from "@/api/modelingList";
// 绘制测量
import { rlAlignedDimension } from "@/rlMxModules/index";
import { del_entity_group } from "@/rlMxModules/operate/index";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
import { getArcPoints } from "@/rlMxModules/Opencascad/getModelDrawData.js";
import {
  getSnapPtOnGrid,
  getSnapPtOnGridC,
  removeCurrentCanvas2DObject,
} from "@/rlMxModules/operate/snapCal";

import {
  getInputElement,
  createInputElement,
  setInputElementPosition,
  setCurrDataObj,
  setContainerShow,
} from "@/rlMxModules/operate/inputElement.js";
import {
  calculateArcAngle,
  toDegrees,
  isAngleInArcRange,
  normalizeAngle,
  // calculateArcPoint,
} from "@/rlMxModules/operate/GraphicDataCal.js";
import { isMobileDevice } from "@/utils/matchMedia";
// 导入统一的消息管理工具
import resetMessage from "@/utils/oneMessage";
import { getGridAxisData } from "@/rlMxModules/operate/operateAxisData";
import { getpickstatus } from "@/api/modelingList.js";
import { calculatePointPosition } from "@/rlMxModules/operate/GraphicDataCal.js";
import CreateSlab from "./createSlab";
import { log } from "three";

// 添加缓存对象，用于缓存getEntityById的结果
const entityCache = {
  cache: new Map(),
  maxSize: 100, // 最大缓存数量

  // 获取缓存项
  get(key) {
    return this.cache.get(key);
  },

  // 设置缓存项
  set(key, value) {
    // 如果缓存已满，清除最早添加的项
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value;
      this.cache.delete(firstKey);
    }
    this.cache.set(key, value);
  },

  // 清除缓存
  clear() {
    this.cache.clear();
  },
};

export const addEntityToDatabase = (addEntity) => {
  // 将新增数据更新至indexdb
  if (
    addEntity.classTypeName != "rlText" &&
    addEntity.classTypeName != "rlLine" &&
    addEntity.classTypeName != "rlEntity" &&
    addEntity.classTypeName != "rlCircle" &&
    addEntity.classTypeName != "rlModelNo"
  ) {
    addEntity.m_stdFlrGuid = store.state.globalData.rl_stdFlr_id;
    // 将新增数据添加到数据库存储数组中
    store.commit("globalData/setDatabaseStore", {
      type: "add",
      obj: addEntity,
    });

    // resetRlModules(
    //   addEntity.classTypeName,
    //   store.state.globalData.rl_stdFlr_id,
    //   addEntity.Guid,
    //   addEntity.getDataBase()
    // );
    addRevokeToDatabase(addEntity);
  }
};

export const addRevokeToDatabase = async (addEntity) => {
  // 缓存撤销回退操作
  if (!store.state.globalData.isReDo && store.state.globalData.canAddRawStep) {
    store.commit("globalData/setRevokeDataStore", {
      type: "add",
      obj: addEntity.getDrawData(),
    });
    // await revokeRollback(addEntity, store.state.globalData.drawStep, "add");
  }
};
// 保存数据到画布和indexdb
export const addEntityToDrawing = async (addEntity, bInit = false) => {
  // 撤销回退中不处理关联处理
  if (store.state.globalData.isReDo) {
    if (
      addEntity.classTypeName === "rlAxis" ||
      addEntity.classTypeName === "rlAxisC"
    ) {
      addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbAxis);
      addEntity.draw();
      addEntity.calAxisNameData();
    } else if (addEntity.ModelType) {
      addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(
        addEntity.mcDbPolyline
      );
    } else if (
      addEntity.classTypeName == "rlJoint" ||
      addEntity.classTypeName == "rlJointC"
    ) {
      addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbPoint);
      // addEntity.draw();
      addEntity.drawCircel();
      addEntity.drawTextTest();
    } else if (
      addEntity.classTypeName == "rlGrid" ||
      addEntity.classTypeName == "rlGridC"
    ) {
      addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbGrid);
      addEntity.draw();
      if (addEntity.classTypeName == "rlGridC") {
        addEntity.drawText();
      } else addEntity.drawTextTest();
    } else if (addEntity.classTypeName == "rlUse") {
      addEntity.draw();
    } else {
      addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(
        addEntity.mcDbPolyline
      );
      addEntity.draw();
    }
  } else {
    let isExist = false;
    if (addEntity.classTypeName == "rlJoint") {
      isExist = await addPointEntityToDrawing(addEntity, bInit, false); // 初始化不需要计算
    } else if (addEntity.classTypeName == "rlJointC") {
      isExist = await addPointEntityToDrawingC(addEntity, bInit, false); // 初始化不需要计算
    } else if (addEntity.classTypeName == "rlGrid") {
      isExist = await addGridEntityToDrawing(addEntity, bInit);
      // return; //不能删,如果这里有添加 下面不执行
    } else if (addEntity.classTypeName == "rlGridC") {
      isExist = await addGridCEntityToDrawing(addEntity, bInit);
      // return; //不能删,如果这里有添加 下面不执行
    } else if (
      addEntity.classTypeName == "rlText" ||
      addEntity.classTypeName == "rlLine" ||
      addEntity.classTypeName == "rlEntity" ||
      addEntity.classTypeName == "rlCircle" ||
      addEntity.classTypeName == "rlModelNo"
    ) {
      // rlAppObj.rlMxDrawObject.addMxEntity(addEntity);
    } else {
      // rlAppObj.rlMxDrawObject.addMxEntity(addEntity);
      if (addEntity.classTypeName === "rlAxis") {
        // isExist = await addAxisEntityToDrawing(addEntity, bInit);
        // if (isExist) return isExist; // 存在共线轴线，合并线，不需要新增
        addEntity.mcDbAxis.visible = false;
        addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbAxis);
        addEntity.calAxisNameData();
        addEntity.draw();
        addEntity.drawTextTest();

        // addEntity.setNeedUpdateDisplay(true);
      } else if (addEntity.classTypeName === "rlAxisC") {
        isExist = await addAxisCEntityToDrawing(addEntity, bInit);
        if (isExist) return isExist; // 存在共线轴线，合并线，不需要新增

        addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbAxis);
        addEntity.calAxisNameData();
        addEntity.draw();
        addEntity.drawTextTest();
        // addEntity.setNeedUpdateDisplay(true);
      } else if (addEntity.ModelType) {
        addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(
          addEntity.mcDbPolyline
        );
      }
    }
    // 判断节点是否已经存在，如果已经存在，不需要添加画布
    if (isExist) return isExist;
  }

  // 保存数据到vueX
  if (bInit || store.state.globalData.isReDo) {
    store.commit("rlEntData/addEntityData", addEntity);
  } else if (
    addEntity.classTypeName != "rlGrid" &&
    addEntity.classTypeName != "rlGridC"
  ) {
    store.commit("rlEntData/addEntityData", addEntity); // 新增网格时，已经将数据添加至vueX了，所以此处不能再添加
  }

  if (!bInit) {
    // 维护构件的No_字段---用于后端数据匹配
    if (
      addEntity.Attribute ||
      addEntity.classTypeName == "rlUse" ||
      addEntity.classTypeName == "rlPartitionWallSeg"
    ) {
      store
        .dispatch("globalData/getStructNum", addEntity.classTypeName)
        .then((res) => {
          addEntity.No_ = res;
          // 将新增数据更新至indexdb
          addEntityToDatabase(addEntity);
        });
    } else {
      // 将新增数据更新至indexdb
      if (
        (addEntity.classTypeName != "rlGrid" &&
          addEntity.classTypeName != "rlGridC") ||
        store.state.globalData.isReDo
      ) {
        // 新增网格时，已经将数据添加至数据库了，所以此处不能再添加
        addEntityToDatabase(addEntity);
      }
    }
  }
  if (addEntity.classTypeName == "rlPartitionWallSeg") {
    addEntity.createText();
    addEntity.createModelNoText();
  }
  // 添加构件的文字
  if (addEntity.Attribute) {
    addEntity.createText();
    addEntity.createModelNoText();
  }
  return false;
};

// 绘制节点到画布上
export const addPointEntityToDrawing = async (
  addEntity,
  bInit,
  isOnGrid,
  pushDataBase = false
) => {
  // 判断点是否已经存在，如果已经存在，不需要添加画布
  if (!bInit) {
    const isExist = JointIsExist(addEntity.m_pt);
    if (isExist) {
      return isExist;
    }
    // 如果不知道是否节点在网格上，则判断点是否在网格上，如果在，切分网格
    if (!isOnGrid) {
      const onGrids = JointIsOnGrid(addEntity);
      if (onGrids && onGrids.length) {
        onGrids.forEach(async (item) => {
          if (item) {
            // 切分网格
            await jointCutGrid(addEntity, item);
          }
        });
      }
    }
  }
  addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbPoint);
  // addEntity.draw();
  addEntity.drawCircel();
  addEntity.drawTextTest();

  if (!bInit && pushDataBase) {
    addEntityToDatabase(addEntity);
    // await addRevokeToDatabase(addEntity);
    store.commit("rlEntData/addEntityData", addEntity);
  }
  return false;
};

// 绘制节点到画布上--草图
export const addPointEntityToDrawingC = async (
  addEntity,
  bInit,
  isOnGrid,
  pushDataBase = false
) => {
  // 判断点是否已经存在，如果已经存在，不需要添加画布
  if (!bInit) {
    const isExist = JointIsExistC(addEntity.m_pt);
    if (isExist) {
      return isExist;
    }
    // 如果不知道是否节点在网格上，则判断点是否在网格上，如果在，切分网格
    if (!isOnGrid) {
      const onGrids = JointIsOnGridC(addEntity);
      if (onGrids && onGrids.length) {
        onGrids.forEach(async (item) => {
          if (item) {
            // 切分网格
            await jointCutGridC(addEntity, item);
          }
        });
      }
    }
  }
  addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbPoint);
  // addEntity.draw();
  addEntity.drawCircel();
  addEntity.drawTextTest();

  if (!bInit && pushDataBase) {
    addEntityToDatabase(addEntity);
    // await addRevokeToDatabase(addEntity);
    store.commit("rlEntData/addEntityData", addEntity);
  }
  return false;
};

//添加草图网格实体到画布
export const addGridCEntityToDrawing = async (
  addEntity,
  bInit,
  isInsertGrid,
  pushDataBase = false
) => {
  // 判断网格是否已经存在
  if (!bInit) {
    const isExist = GridCIsExist(addEntity);
    if (isExist) {
      return isExist;
    }
  }
  // 如果没判断网格相交，则计算网格之间是否有交点
  if (!bInit && !isInsertGrid) {
    await gridCLineInsertWith(addEntity);
  } else {
    addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbGrid);
    addEntity.drawText();
    addEntity.draw();
  }
  if (!bInit && pushDataBase) {
    await addEntityToDatabase(addEntity);
    store.commit("rlEntData/addEntityData", addEntity);
  }
};

// 添加网格实体到画布
export const addGridEntityToDrawing = async (
  addEntity,
  bInit,
  isInsertGrid,
  pushDataBase = false
) => {
  // 判断网格是否已经存在
  if (!bInit) {
    const isExist = GridIsExist(addEntity);
    if (isExist) {
      return isExist;
    }
  }
  // 如果没判断网格相交，则计算网格之间是否有交点
  if (!bInit && !isInsertGrid) {
    await gridLineInsertWith(addEntity);
  } else {
    addEntity.mcDbId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbGrid);
    addEntity.drawTextTest();
    addEntity.draw();
  }
  if (!bInit && pushDataBase) {
    await addEntityToDatabase(addEntity);
    store.commit("rlEntData/addEntityData", addEntity);
  }
};

export const addAxisEntityToDrawing = async (addEntity, bInit) => {
  if (!bInit) {
    // 计算当前线上已存在轴线，若存在，更新原有轴线，否则，新增轴线
    // 获取所有轴线
    const rlAxisGroup = store.state.rlEntData.totalEntityData["rlAxis"];
    if (rlAxisGroup) {
      const isExist = false;
      for (let i = 0; i < rlAxisGroup.length; i++) {
        const axis = rlAxisGroup[i];
        if (axis.Guid === addEntity.Guid) continue;

        if (
          (axis.IsMainAxis < 0 && addEntity.IsMainAxis != -1) ||
          (axis.IsMainAxis != -1 && addEntity.IsMainAxis < 0)
        ) {
          continue;
        }

        //判断圆弧轴线是否存在重叠或者重复
        if (addEntity.IsMainAxis < 0) {
          //判断点在圆弧上
          let ptSt = new THREE.Vector3(...axis.m_stArcPoint);
          let ptEd = new THREE.Vector3(...axis.m_edArcPoint);
          let ptCenter = new THREE.Vector3(...axis.m_stJoint.m_pt);
          let redius = ptSt.distanceTo(ptCenter);

          let addEntPtCenter = new THREE.Vector3(...addEntity.m_stJoint.m_pt);
          let addEntPtSt = new THREE.Vector3(...addEntity.m_stArcPoint);
          let addEntPtEd = new THREE.Vector3(...addEntity.m_edArcPoint);
          let addEntRedius = addEntPtCenter.distanceTo(addEntPtSt);

          if (ptCenter.equals(addEntPtCenter) && redius === addEntRedius) {
            if (
              ptOnArc(ptCenter, redius, ptSt, ptEd, addEntPtSt) > 0 &&
              ptOnArc(ptCenter, redius, ptSt, ptEd, addEntPtEd) > 0
            ) {
              return axis;
            } else {
            }
          }

          continue;
        }

        if (
          areLineCollinear(
            new THREE.Vector3(...axis.m_stJoint.m_pt),
            new THREE.Vector3(...axis.m_edJoint.m_pt),
            new THREE.Vector3(...addEntity.m_stJoint.m_pt),
            new THREE.Vector3(...addEntity.m_edJoint.m_pt)
          )
        ) {
          // 存在共线轴线，合并线
          var points = [
            {
              pt: new THREE.Vector3(...axis.m_stJoint.m_pt),
              obj: axis.m_stJoint,
            },
            {
              pt: new THREE.Vector3(...axis.m_edJoint.m_pt),
              obj: axis.m_edJoint,
            },
            {
              pt: new THREE.Vector3(...addEntity.m_stJoint.m_pt),
              obj: addEntity.m_stJoint,
            },
            {
              pt: new THREE.Vector3(...addEntity.m_edJoint.m_pt),
              obj: addEntity.m_edJoint,
            },
          ];

          // 按x、y、z坐标分别排序
          points.sort(function (a, b) {
            if (a.pt.x !== b.pt.x) return a.pt.x - b.pt.x;
            if (a.pt.y !== b.pt.y) return a.pt.y - b.pt.y;
            return a.pt.z - b.pt.z;
          });

          axis.saveEditRevokeData();

          // 取最小、最大的端点
          axis.m_stJoint = points[0].obj;
          axis.m_edJoint = points[points.length - 1].obj;

          // axis.updateThisObj(axis);
          axis.updateThisObj(axis);

          // axis.updateAxisDrawData();
          return axis;
        }
      }
      return isExist;
    }
  }
  return false;
};

//轴线创建-草图
export const addAxisCEntityToDrawing = async (addEntity, bInit) => {
  if (!bInit) {
    // 计算当前线上已存在轴线，若存在，更新原有轴线，否则，新增轴线
    // 获取所有轴线
    const rlAxisGroup = store.state.rlEntData.totalEntityData["rlAxisC"];
    if (rlAxisGroup) {
      const isExist = false;
      for (let i = 0; i < rlAxisGroup.length; i++) {
        const axis = rlAxisGroup[i];
        if (axis.Guid === addEntity.Guid) continue;

        if (
          (axis.IsMainAxis < 0 && addEntity.IsMainAxis != -1) ||
          (axis.IsMainAxis != -1 && addEntity.IsMainAxis < 0)
        ) {
          continue;
        }

        //判断圆弧轴线是否存在重叠或者重复
        if (addEntity.IsMainAxis < 0) {
          //判断点在圆弧上
          let ptSt = new THREE.Vector3(...axis.m_stArcPoint);
          let ptEd = new THREE.Vector3(...axis.m_edArcPoint);
          let ptCenter = new THREE.Vector3(...axis.m_stJoint.m_pt);
          let redius = ptSt.distanceTo(ptCenter);

          let addEntPtCenter = new THREE.Vector3(...addEntity.m_stJoint.m_pt);
          let addEntPtSt = new THREE.Vector3(...addEntity.m_stArcPoint);
          let addEntPtEd = new THREE.Vector3(...addEntity.m_edArcPoint);
          let addEntRedius = addEntPtCenter.distanceTo(addEntPtSt);

          if (ptCenter.equals(addEntPtCenter) && redius === addEntRedius) {
            if (
              ptOnArc(ptCenter, redius, ptSt, ptEd, addEntPtSt) === 1 &&
              ptOnArc(ptCenter, redius, ptSt, ptEd, addEntPtEd) === 1
            ) {
              return axis;
            } else {
            }
          }

          continue;
        }

        if (
          areLineCollinear(
            new THREE.Vector3(...axis.m_stJoint.m_pt),
            new THREE.Vector3(...axis.m_edJoint.m_pt),
            new THREE.Vector3(...addEntity.m_stJoint.m_pt),
            new THREE.Vector3(...addEntity.m_edJoint.m_pt)
          )
        ) {
          // 存在共线轴线，合并线
          var points = [
            {
              pt: new THREE.Vector3(...axis.m_stJoint.m_pt),
              obj: axis.m_stJoint,
            },
            {
              pt: new THREE.Vector3(...axis.m_edJoint.m_pt),
              obj: axis.m_edJoint,
            },
            {
              pt: new THREE.Vector3(...addEntity.m_stJoint.m_pt),
              obj: addEntity.m_stJoint,
            },
            {
              pt: new THREE.Vector3(...addEntity.m_edJoint.m_pt),
              obj: addEntity.m_edJoint,
            },
          ];

          // 按x、y、z坐标分别排序
          points.sort(function (a, b) {
            if (a.pt.x !== b.pt.x) return a.pt.x - b.pt.x;
            if (a.pt.y !== b.pt.y) return a.pt.y - b.pt.y;
            return a.pt.z - b.pt.z;
          });

          axis.saveEditRevokeData();

          // 取最小、最大的端点
          axis.m_stJoint = points[0].obj;
          axis.m_edJoint = points[points.length - 1].obj;

          // axis.updateThisObj(axis);
          axis.updateThisObj(axis);

          // axis.updateAxisDrawData();
          return axis;
        }
      }
      return isExist;
    }
  }
  return false;
};

// 新增节点是否已经存在
export const JointIsExist = (point, ignoreJointArray = []) => {
  const pt = new THREE.Vector3(...point);
  const rlGroup = store.state.rlEntData.totalEntityData["rlJoint"]; // rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.getAll(); //获取当前图纸中的节点数据
  if (rlGroup) {
    for (let i = 0; i < rlGroup.length; i++) {
      if (ignoreJointArray.find((joint) => joint.Guid == rlGroup[i].Guid))
        continue;
      const ptTmp = new THREE.Vector3(...rlGroup[i].m_pt);
      if (ptTmp.distanceTo(pt) < 15) {
        return rlGroup[i];
      }
    }
    return false;
  }
  return false;
};

// 新增节点是否已经存在--草图
export const JointIsExistC = (point) => {
  const pt = new THREE.Vector3(...point);
  const rlGroup = store.state.rlEntData.totalEntityData["rlJointC"]; // rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.getAll(); //获取当前图纸中的节点数据
  if (rlGroup) {
    for (let i = 0; i < rlGroup.length; i++) {
      const ptTmp = new THREE.Vector3(...rlGroup[i].m_pt);
      if (ptTmp.distanceTo(pt) < 15) {
        return rlGroup[i];
      }
    }
    return false;
  }
  return false;
};

// 判断新增草图网格是否已经存在
export const GridCIsExist = (objNew) => {
  if (objNew) {
    let isArc = objNew.m_centerJoint != null;
    const ptSt = new THREE.Vector3(...objNew.m_stJoint.m_pt);
    const ptEd = new THREE.Vector3(...objNew.m_edJoint.m_pt);
    const ptCenter = isArc ? new THREE.Vector3(...objNew.centerPoint) : null;
    let totalGridData = store.state.rlEntData.totalEntityData["rlGridC"];
    for (let i = 0; i < totalGridData.length; i++) {
      const existGrid = totalGridData[i];
      if (isArc && existGrid.m_centerJoint) {
        const ptStTmp = new THREE.Vector3(...existGrid.m_stJoint.m_pt);
        const ptEdTmp = new THREE.Vector3(...existGrid.m_edJoint.m_pt);
        const ptCenterTmp = new THREE.Vector3(...existGrid.centerPoint);

        if (ptIsEqual(ptCenter, ptCenterTmp)) {
          if (
            (ptIsEqual(ptSt, ptStTmp) && ptIsEqual(ptEd, ptEdTmp)) ||
            (ptIsEqual(ptSt, ptEdTmp) && ptIsEqual(ptEd, ptStTmp))
          ) {
            return existGrid;
          }
        }
      } else if (!isArc && !existGrid.m_centerJoint) {
        const ptStTmp = new THREE.Vector3(...existGrid.m_stJoint.m_pt);
        const ptEdTmp = new THREE.Vector3(...existGrid.m_edJoint.m_pt);
        if (
          (ptIsEqual(ptSt, ptStTmp) && ptIsEqual(ptEd, ptEdTmp)) ||
          (ptIsEqual(ptSt, ptEdTmp) && ptIsEqual(ptEd, ptStTmp))
        ) {
          return existGrid;
        }
      }
    }
  }

  return false;
};

// 判断新增网格是否已经存在
export const GridIsExist = (objNew, ignoreGridArray = []) => {
  if (objNew) {
    let isArc = objNew.m_centerJoint != null;
    const ptSt = new THREE.Vector3(...objNew.m_stJoint.m_pt);
    const ptEd = new THREE.Vector3(...objNew.m_edJoint.m_pt);
    const ptCenter = isArc ? new THREE.Vector3(...objNew.centerPoint) : null;
    let totalGridData = store.state.rlEntData.totalEntityData["rlGrid"];
    for (let i = 0; i < totalGridData.length; i++) {
      const existGrid = totalGridData[i];
      if (existGrid.Guid === objNew.Guid) continue;
      if (ignoreGridArray.find((grid) => grid.Guid === existGrid.Guid))
        continue;

      if (isArc && existGrid.m_centerJoint) {
        const ptStTmp = new THREE.Vector3(...existGrid.m_stJoint.m_pt);
        const ptEdTmp = new THREE.Vector3(...existGrid.m_edJoint.m_pt);
        const ptCenterTmp = new THREE.Vector3(...existGrid.centerPoint);

        if (ptIsEqual(ptCenter, ptCenterTmp)) {
          if (
            (ptIsEqual(ptSt, ptStTmp) && ptIsEqual(ptEd, ptEdTmp)) ||
            (ptIsEqual(ptSt, ptEdTmp) && ptIsEqual(ptEd, ptStTmp))
          ) {
            return existGrid;
          }
        }
      } else if (!isArc && !existGrid.m_centerJoint) {
        const ptStTmp = new THREE.Vector3(...existGrid.m_stJoint.m_pt);
        const ptEdTmp = new THREE.Vector3(...existGrid.m_edJoint.m_pt);
        if (
          (ptIsEqual(ptSt, ptStTmp) && ptIsEqual(ptEd, ptEdTmp)) ||
          (ptIsEqual(ptSt, ptEdTmp) && ptIsEqual(ptEd, ptStTmp))
        ) {
          return existGrid;
        }
      }
    }
  }

  return false;
};

// const removeGrids = []; // 用于存储需要删除的网格
// 判断草图网格是否与其他网格相交，若相交，增加节点
export const gridCLineInsertWith = async (objCurrGird) => {
  if (objCurrGird) {
    const pt1 = new THREE.Vector3(
      objCurrGird.m_stJoint.m_pt[0],
      objCurrGird.m_stJoint.m_pt[1],
      objCurrGird.m_stJoint.m_pt[2]
    );
    const pt2 = new THREE.Vector3(
      objCurrGird.m_edJoint.m_pt[0],
      objCurrGird.m_edJoint.m_pt[1],
      objCurrGird.m_edJoint.m_pt[2]
    );

    const insertPtArray = new Array();
    // const rlGroup = store.state.rlEntData.totalEntityData["rlGrid"]; // rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll(); //获取当前图纸中的网格数据
    const rlGroup = [...store.state.rlEntData.totalEntityData["rlGridC"]];
    if (rlGroup) {
      // 从 rlGroup 中删除需要删除的网格
      // rlGroup = rlGroup.filter((grid) => !removeGrids.includes(grid));
      for (let i = 0; i < rlGroup.length; i++) {
        const objTmp = rlGroup[i];
        if (objTmp) {
          const pt1Tmp = new THREE.Vector3(
            objTmp.m_stJoint.m_pt[0],
            objTmp.m_stJoint.m_pt[1],
            objTmp.m_stJoint.m_pt[2]
          );
          const pt2Tmp = new THREE.Vector3(
            objTmp.m_edJoint.m_pt[0],
            objTmp.m_edJoint.m_pt[1],
            objTmp.m_edJoint.m_pt[2]
          );

          const insertRes = lineInsection(pt1, pt2, pt1Tmp, pt2Tmp);

          if (insertRes.insertType == "overlapping") {
            return; //完全重叠
          } else if (insertRes.insertType == "part_overlapping") {
            //若新网格完全在已有网格上
            if (
              ptOnLine(pt1Tmp, pt2Tmp, pt1) > 0 &&
              ptOnLine(pt1Tmp, pt2Tmp, pt2) > 0
            ) {
              return;
            }
          } else if (insertRes.isIntersected && insertRes.intersectionPoint) {
            // 添加一个节点
            const rlPointObj = new rlJointCData();
            rlPointObj.initData({
              m_pt: [
                insertRes.intersectionPoint["x"],
                insertRes.intersectionPoint["y"],
                insertRes.intersectionPoint["z"],
              ],
            });
            const isExist = await addPointEntityToDrawingC(
              rlPointObj,
              false,
              true,
              true
            );
            if (!isExist) await jointCutGridC(rlPointObj, objTmp);

            if (!isExist && rlPointObj && !insertPtArray.includes(rlPointObj)) {
              insertPtArray.push(rlPointObj);
            }
            // removeGrids.push(objTmp); // 将需要删除的网格添加到 removeGrids 数组中
          }
        }
      }
    }

    // 查找网格上的节点
    const rlJointGroup = store.state.rlEntData.totalEntityData["rlJointC"];
    if (rlJointGroup) {
      rlJointGroup.forEach((joint) => {
        const res = ptOnLine(pt1, pt2, new THREE.Vector3(...joint.m_pt));
        if (res === 1 && !insertPtArray.includes(joint)) {
          insertPtArray.push(joint);
        }
      });
    }

    if (insertPtArray && insertPtArray.length) {
      jointArrayCutGridC(insertPtArray, objCurrGird);
      // //清除绑定
      // objCurrGird.m_stJoint.m_gridIds = objCurrGird.m_stJoint.m_gridIds.filter(
      //   (id) => id !== objCurrGird.Guid
      // );
      // objCurrGird.m_edJoint.m_gridIds = objCurrGird.m_edJoint.m_gridIds.filter(
      //   (id) => id !== objCurrGird.Guid
      // );
      return true; // 该段网格被切分了
    } else {
      const beamId = objCurrGird.m_beamId;
      const wallId = objCurrGird.m_wallId;

      await addGridCEntityToDrawing(objCurrGird, false, true, true);

      // 更新构件绑定关系
      objCurrGird.m_beamId = beamId;
      objCurrGird.m_wallId = wallId;
      // 网格移动时，构件也需要移动
      if (beamId) {
        const objtmpBeam = getEntityData({
          Guid: beamId,
          classTypeName: "rlBeamSeg",
        }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);

        if (objtmpBeam) {
          const newBeamObj = objtmpBeam.myClone();
          newBeamObj.m_gridData = objCurrGird;
          newBeamObj.draw();
          await addEntityToDrawing(newBeamObj, false);
          objCurrGird.m_beamId = newBeamObj.Guid;
        }
      }
      if (wallId) {
        const objtmpWall = getEntityData({
          Guid: wallId,
          classTypeName: "rlWallSeg",
        }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
        if (objtmpWall) {
          const newWallObj = objtmpWall.myClone();
          newWallObj.m_gridData = objCurrGird;
          newWallObj.draw();
          await addEntityToDrawing(newWallObj, false);
          objCurrGird.m_wallId = newWallObj.guid;
        }
      }

      return false; // 该段网格没有被切分
    }
  }
};

// 判断网格是否与其他网格相交，若相交，增加节点
export const gridLineInsertWith = async (objCurrGird, addDataBase = true) => {
  if (objCurrGird) {
    const pt1 = new THREE.Vector3(
      objCurrGird.m_stJoint.m_pt[0],
      objCurrGird.m_stJoint.m_pt[1],
      objCurrGird.m_stJoint.m_pt[2]
    );
    const pt2 = new THREE.Vector3(
      objCurrGird.m_edJoint.m_pt[0],
      objCurrGird.m_edJoint.m_pt[1],
      objCurrGird.m_edJoint.m_pt[2]
    );

    let stPtOnOtherGrid = false; //新网格的起点在其他已存在的网格上
    let edPtOnOtherGrid = false; //新网格的终点在其他已存在的网格上

    const insertPtArray = new Array();
    // const rlGroup = store.state.rlEntData.totalEntityData["rlGrid"]; // rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll(); //获取当前图纸中的网格数据
    const rlGroup = [...store.state.rlEntData.totalEntityData["rlGrid"]];
    if (rlGroup) {
      // 从 rlGroup 中删除需要删除的网格
      // rlGroup = rlGroup.filter((grid) => !removeGrids.includes(grid));
      for (let i = 0; i < rlGroup.length; i++) {
        const objTmp = rlGroup[i];
        if (objTmp) {
          const pt1Tmp = new THREE.Vector3(
            objTmp.m_stJoint.m_pt[0],
            objTmp.m_stJoint.m_pt[1],
            objTmp.m_stJoint.m_pt[2]
          );
          const pt2Tmp = new THREE.Vector3(
            objTmp.m_edJoint.m_pt[0],
            objTmp.m_edJoint.m_pt[1],
            objTmp.m_edJoint.m_pt[2]
          );

          if (objCurrGird.m_centerJoint || objTmp.m_centerJoint) {
            // 圆弧轴线与圆弧轴线相交
            if (objCurrGird.m_centerJoint && objTmp.m_centerJoint) {
              const center1 = objCurrGird.m_centerJoint
                ? new THREE.Vector3(...objCurrGird.m_centerJoint.m_pt)
                : new THREE.Vector3(...objCurrGird.m_Axis.m_stJoint.m_pt);

              const redius1 = pt1.distanceTo(center1);
              const startAngle1 = toDegrees(calculateArcAngle(center1, pt1));
              const endAngle1 = toDegrees(calculateArcAngle(center1, pt2));

              const center2 = objTmp.m_centerJoint
                ? new THREE.Vector3(...objTmp.m_centerJoint.m_pt)
                : new THREE.Vector3(...objTmp.m_Axis.m_stJoint.m_pt);
              const redius2 = pt1Tmp.distanceTo(center2);
              const startAngle2 = toDegrees(calculateArcAngle(center2, pt1Tmp));
              const endAngle2 = toDegrees(calculateArcAngle(center2, pt2Tmp));

              const insertRes = arcArcIntersection(
                center1,
                redius1,
                startAngle1,
                endAngle1,
                center2,
                redius2,
                startAngle2,
                endAngle2
              );

              if (insertRes.isIntersected) {
                const insertArcArray = [];
                for (let i = 0; i < insertRes.intersectionPoints.length; i++) {
                  // 添加一个节点
                  const rlPointObj = new rlJointData();
                  rlPointObj.initData({
                    m_pt: [
                      insertRes.intersectionPoints[i]["x"],
                      insertRes.intersectionPoints[i]["y"],
                      insertRes.intersectionPoints[i]["z"],
                    ],
                  });
                  const isExist = await addPointEntityToDrawing(
                    rlPointObj,
                    false,
                    true,
                    true
                  );
                  // await jointCutGrid(rlPointObj, objTmp);
                  if (!isExist) {
                    insertArcArray.push(rlPointObj);
                  }

                  if (
                    !isExist &&
                    rlPointObj &&
                    !insertPtArray.includes(rlPointObj)
                  ) {
                    insertPtArray.push(rlPointObj);
                  }
                }
                await jointArrayCutGrid(insertArcArray, objTmp);
              }
            }
            // 直线轴线与圆弧轴线相交
            else if (objCurrGird.m_centerJoint) {
              const center1 = objCurrGird.m_centerJoint
                ? new THREE.Vector3(...objCurrGird.m_centerJoint.m_pt)
                : new THREE.Vector3(...objCurrGird.m_Axis.m_stJoint.m_pt);

              const redius1 = pt1.distanceTo(center1);
              const startAngle1 = toDegrees(calculateArcAngle(center1, pt1));
              const endAngle1 = toDegrees(calculateArcAngle(center1, pt2));

              const insertRes = lineArcIntersection(
                pt1Tmp,
                pt2Tmp,
                center1,
                redius1,
                startAngle1,
                endAngle1
              );

              if (insertRes.isIntersected) {
                const insertArcArray = [];
                for (let j = 0; j < insertRes.intersectionPoints.length; j++) {
                  // 添加一个节点
                  const rlPointObj = new rlJointData();
                  rlPointObj.initData({
                    m_pt: [
                      insertRes.intersectionPoints[j]["x"],
                      insertRes.intersectionPoints[j]["y"],
                      insertRes.intersectionPoints[j]["z"],
                    ],
                  });
                  const isExist = await addPointEntityToDrawing(
                    rlPointObj,
                    false,
                    true,
                    true
                  );
                  // await jointCutGrid(rlPointObj, objTmp);
                  if (!isExist) {
                    insertArcArray.push(rlPointObj);
                  }
                  if (
                    !isExist &&
                    rlPointObj &&
                    !insertPtArray.includes(rlPointObj)
                  ) {
                    insertPtArray.push(rlPointObj);
                  }
                }

                await jointArrayCutGrid(insertArcArray, objTmp);
              }
            }
            // 直线轴线与圆弧轴线相交
            else if (objTmp.m_centerJoint) {
              const center1 = objTmp.m_centerJoint
                ? new THREE.Vector3(...objTmp.m_centerJoint.m_pt)
                : new THREE.Vector3(...objTmp.m_Axis.m_stJoint.m_pt);

              const redius1 = pt1Tmp.distanceTo(center1);
              const startAngle1 = toDegrees(calculateArcAngle(center1, pt1Tmp));
              const endAngle1 = toDegrees(calculateArcAngle(center1, pt2Tmp));

              const insertRes = lineArcIntersection(
                pt1,
                pt2,
                center1,
                redius1,
                startAngle1,
                endAngle1
              );
              if (insertRes.isIntersected) {
                const insertArcArray = [];
                for (let j = 0; j < insertRes.intersectionPoints.length; j++) {
                  // 添加一个节点
                  const rlPointObj = new rlJointData();
                  rlPointObj.initData({
                    m_pt: [
                      insertRes.intersectionPoints[j]["x"],
                      insertRes.intersectionPoints[j]["y"],
                      insertRes.intersectionPoints[j]["z"],
                    ],
                  });

                  const isExist = await addPointEntityToDrawing(
                    rlPointObj,
                    false,
                    true,
                    true
                  );
                  // await jointCutGrid(rlPointObj, objTmp);
                  if (!isExist) {
                    insertArcArray.push(rlPointObj);
                  }
                  if (
                    !isExist &&
                    rlPointObj &&
                    !insertPtArray.includes(rlPointObj)
                  ) {
                    insertPtArray.push(rlPointObj);
                  }
                }

                await jointArrayCutGrid(insertArcArray, objTmp);
              }
            }

            continue;
          }

          const insertRes = lineInsection(pt1Tmp, pt2Tmp, pt1, pt2);
          if (insertRes.insertType == "overlapping") {
            return; //完全重叠
          } else if (insertRes.insertType == "part_overlapping") {
            //若新网格完全在已有网格上
            if (
              ptOnLine(pt1Tmp, pt2Tmp, pt1) > 0 &&
              ptOnLine(pt1Tmp, pt2Tmp, pt2) > 0
            ) {
              return;
            }

            if (ptOnLine(pt1Tmp, pt2Tmp, pt1) == 1) {
              stPtOnOtherGrid = true;
            }
            if (ptOnLine(pt1Tmp, pt2Tmp, pt2) == 1) {
              edPtOnOtherGrid = true;
            }
          }
          if (insertRes.isIntersected && insertRes.intersectionPoint) {
            // 添加一个节点
            const rlPointObj = new rlJointData();
            rlPointObj.initData({
              m_pt: [
                insertRes.intersectionPoint["x"],
                insertRes.intersectionPoint["y"],
                insertRes.intersectionPoint["z"],
              ],
            });
            const isExist = await addPointEntityToDrawing(
              rlPointObj,
              false,
              true,
              true
            );
            if (!isExist) await jointCutGrid(rlPointObj, objTmp);

            if (!isExist && rlPointObj && !insertPtArray.includes(rlPointObj)) {
              insertPtArray.push(rlPointObj);
            }
            // removeGrids.push(objTmp); // 将需要删除的网格添加到 removeGrids 数组中
          }
        }
      }
    }
    //若起点和终点都在其他网格上且与其他网格共线，则当前网格不需要布置
    if (stPtOnOtherGrid && edPtOnOtherGrid) {
      return;
    }

    // 查找网格上的节点
    const rlJointGroup = store.state.rlEntData.totalEntityData["rlJoint"];
    if (rlJointGroup) {
      rlJointGroup.forEach((joint) => {
        if (
          objCurrGird.m_centerJoint ||
          (objCurrGird.m_Axis && objCurrGird.m_Axis.IsMainAxis < 0)
        ) {
          const center1 = objCurrGird.m_centerJoint
            ? new THREE.Vector3(...objCurrGird.m_centerJoint.m_pt)
            : new THREE.Vector3(...objCurrGird.m_Axis.m_stJoint.m_pt);
          const redius1 = pt1.distanceTo(center1);
          const res = ptOnArc(
            center1,
            redius1,
            pt1,
            pt2,
            new THREE.Vector3(...joint.m_pt)
          );
          // 在圆弧上
          if (res === 1 && !insertPtArray.includes(joint)) {
            insertPtArray.push(joint);
          }
        } else {
          const res = ptOnLine(pt1, pt2, new THREE.Vector3(...joint.m_pt));
          if (res === 1 && !insertPtArray.includes(joint)) {
            insertPtArray.push(joint);
          }
        }
      });
    }

    if (insertPtArray && insertPtArray.length) {
      jointArrayCutGrid(insertPtArray, objCurrGird);
      // //清除绑定
      // objCurrGird.m_stJoint.m_gridIds = objCurrGird.m_stJoint.m_gridIds.filter(
      //   (id) => id !== objCurrGird.Guid
      // );
      // objCurrGird.m_edJoint.m_gridIds = objCurrGird.m_edJoint.m_gridIds.filter(
      //   (id) => id !== objCurrGird.Guid
      // );
      return true; // 该段网格被切分了
    } else if (addDataBase) {
      const beamId = objCurrGird.m_beamId;
      const wallId = objCurrGird.m_wallId;

      await addGridEntityToDrawing(objCurrGird, false, true, true);

      // 更新构件绑定关系
      objCurrGird.m_beamId = beamId;
      objCurrGird.m_wallId = wallId;
      // 网格移动时，构件也需要移动
      if (beamId) {
        const objtmpBeam = getEntityData({
          Guid: beamId,
          classTypeName: "rlBeamSeg",
        }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);

        if (objtmpBeam) {
          const newBeamObj = objtmpBeam.myClone();
          newBeamObj.m_gridData = objCurrGird;
          newBeamObj.draw();
          await addEntityToDrawing(newBeamObj, false);
          objCurrGird.m_beamId = newBeamObj.Guid;
        }
      }
      if (wallId) {
        const objtmpWall = getEntityData({
          Guid: wallId,
          classTypeName: "rlWallSeg",
        }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
        if (objtmpWall) {
          const newWallObj = objtmpWall.myClone();
          newWallObj.m_gridData = objCurrGird;
          newWallObj.draw();
          await addEntityToDrawing(newWallObj, false);
          objCurrGird.m_wallId = newWallObj.guid;
        }
      }

      return false; // 该段网格没有被切分
    }
  }
};

// 节点将网格切分
export const jointCutGrid = async (joint, grid, ignoreGridArray = []) => {
  try {
    // const pointSt = new THREE.Vector3(...grid.m_stJoint.m_pt);
    // const pointEd = new THREE.Vector3(...grid.m_edJoint.m_pt);
    // const pointCenter = new THREE.Vector3(...grid.m_Axis.m_stJoint.m_pt);
    // const stAngle = calculateArcAngle(pointCenter, pointSt);
    // const edAngle = calculateArcAngle(pointCenter, pointEd);
    // const angle = calculateArcAngle(
    //   pointCenter,
    //   new THREE.Vector3(...joint.m_pt)
    // );
    if (joint && grid) {
      let newGrid = null;
      let jointObjs = [];
      if (grid.m_centerJoint || (grid.m_Axis && grid.m_Axis.IsMainAxis < 0)) {
        //网格切分
        newGrid = new rlGridArcData();
        newGrid.initData({
          m_stJoint: joint,
          m_edJoint: grid.m_edJoint,
          m_Axis: grid.m_Axis,
          m_centerJoint: grid.m_centerJoint,
          centerPoint: grid.m_centerJoint.m_pt,
        });
        jointObjs = [grid.m_stJoint, joint, grid.m_edJoint];
      } else {
        // 对网格的两个端点、节点按照从左到右，从下到上的排序
        jointObjs = [grid.m_stJoint, grid.m_edJoint, joint];
        jointObjs.sort((a, b) => {
          // 增加误差判断
          if (Math.abs(a.m_pt[0] - b.m_pt[0]) > 1) {
            return a.m_pt[0] - b.m_pt[0];
          } else if (Math.abs(a.m_pt[1] - b.m_pt[1]) > 1) {
            return a.m_pt[1] - b.m_pt[1];
          } else return 0;
        });

        // 按照排序后的顺序，重新设置网格的端点
        newGrid = new rlGridData();
        newGrid.initData({
          m_stJoint: jointObjs[1],
          m_edJoint: jointObjs[2],
          m_Axis: grid.m_Axis,
        });
      }

      if (!GridIsExist(newGrid, ignoreGridArray)) {
        await addGridEntityToDrawing(newGrid, false, true, true);

        if (grid.m_wallId) {
          const objtmpWall = getEntityData({
            Guid: grid.m_wallId,
            classTypeName: "rlWallSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
          if (objtmpWall) {
            const newWallObj = objtmpWall.myClone();
            newWallObj.m_gridData = newGrid;
            newWallObj.draw();
            await addEntityToDrawing(newWallObj, false);
          }
        }

        if (grid.m_beamId) {
          const objtmpBeam = getEntityData({
            Guid: grid.m_beamId,
            classTypeName: "rlBeamSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
          if (objtmpBeam) {
            const newBeamObj = objtmpBeam.myClone();
            newBeamObj.m_gridData = newGrid;
            newBeamObj.draw();

            await addEntityToDrawing(newBeamObj, false);
          }
        }
        if (grid.m_slabIds) {
          for (let i = 0; i < grid.m_slabIds.length; i++) {
            const objtmpSlab = getEntityData({
              Guid: grid.m_slabIds[i],
              classTypeName: "rlSlab",
            }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_slabIds[i]);
            if (objtmpSlab) {
              objtmpSlab.saveEditRevokeData();
              objtmpSlab.gridsObjs.push(newGrid);
              updateSlabDrawingData(objtmpSlab);
              // //在objtmpSlab.GridsGuid字符串后面拼接newGrid。Guid
              // objtmpSlab.GridsGuid = objtmpSlab.GridsGuid
              //   ? `${objtmpSlab.GridsGuid},${newGrid.Guid}`
              //   : newGrid.Guid;
              objtmpSlab.updateThisObj(objtmpSlab);
            }
          }
        }
        if (grid.m_partitionWallId) {
          const objtmppartitionWall = getEntityData({
            Guid: grid.m_partitionWallId,
            classTypeName: "rlPartitionWallSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
          if (objtmppartitionWall) {
            const newpartitionWallObj = objtmppartitionWall.myClone();
            newpartitionWallObj.m_gridData = newGrid;
            newpartitionWallObj.updateStartAndEndPoint();
            newpartitionWallObj.draw();

            await addEntityToDrawing(newpartitionWallObj, false);
          }
        }
        grid.saveEditRevokeData();

        grid.m_stJoint = jointObjs[0];
        grid.m_edJoint = jointObjs[1];

        grid.updateThisObj(grid);
      }

      // const newGrid1 = new rlGridData();
      // newGrid1.initData({
      //   m_stJoint: joint,
      //   m_edJoint: grid.m_edJoint,
      //   m_Axis: grid.m_Axis,
      // });
      // if (!GridIsExist(newGrid1)) {
      //   await addGridEntityToDrawing(newGrid1, false, true, true);

      //   if (grid.m_wallId) {
      //     const objtmpWall = getEntityData({
      //       Guid: grid.m_wallId,
      //       classTypeName: "rlWallSeg",
      //     }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
      //     if (objtmpWall) {
      //       const newWallObj = objtmpWall.myClone();
      //       newWallObj.m_gridData = newGrid1;
      //       newWallObj.draw();
      //       await addEntityToDrawing(newWallObj, false);

      //       await objtmpWall.erase();
      //     }
      //   }

      //   if (grid.m_beamId) {
      //     const objtmpBeam = getEntityData({
      //       Guid: grid.m_beamId,
      //       classTypeName: "rlBeamSeg",
      //     }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
      //     if (objtmpBeam) {
      //       const newBeamObj = objtmpBeam.myClone();
      //       newBeamObj.m_gridData = newGrid1;
      //       newBeamObj.draw();
      //       await addEntityToDrawing(newBeamObj, false);

      //       await objtmpBeam.erase();
      //     }
      //   }
      // }

      // await grid.erase();
    }
  } catch (error) {
    console.log("jointCutGrid error", error);
  }
};

// 节点将网格切分--草图
async function jointCutGridC(joint, grid) {
  try {
    const pointSt = new THREE.Vector3(...grid.m_stJoint.m_pt);
    const pointEd = new THREE.Vector3(...grid.m_edJoint.m_pt);
    // const pointCenter = new THREE.Vector3(...grid.m_Axis.m_stJoint.m_pt);
    // const stAngle = calculateArcAngle(pointCenter, pointSt);
    // const edAngle = calculateArcAngle(pointCenter, pointEd);
    // const angle = calculateArcAngle(
    //   pointCenter,
    //   new THREE.Vector3(...joint.m_pt)
    // );

    if (joint && grid) {
      let newGrid = null;
      let jointObjs = [];
      // 对网格的两个端点、节点按照从左到右，从下到上的排序
      jointObjs = [grid.m_stJoint, grid.m_edJoint, joint];
      jointObjs.sort((a, b) => {
        // 增加误差判断
        if (Math.abs(a.m_pt[0] - b.m_pt[0]) > 1e-2) {
          return a.m_pt[0] - b.m_pt[0];
        } else if (Math.abs(a.m_pt[1] - b.m_pt[1]) > 1e-2) {
          return a.m_pt[1] - b.m_pt[1];
        } else return 0;
      });
      // 按照排序后的顺序，重新设置网格的端点
      newGrid = new rlGridCData();
      newGrid.initData({
        m_stJoint: jointObjs[1],
        m_edJoint: jointObjs[2],
        m_Axis: null,
      });

      if (!GridCIsExist(newGrid)) {
        await addGridCEntityToDrawing(newGrid, false, true, true);

        if (grid.m_wallId) {
          const objtmpWall = getEntityData({
            Guid: grid.m_wallId,
            classTypeName: "rlWallSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
          if (objtmpWall) {
            const newWallObj = objtmpWall.myClone();
            newWallObj.m_gridData = newGrid;
            newWallObj.draw();
            await addEntityToDrawing(newWallObj, false);
          }
        }

        if (grid.m_beamId) {
          const objtmpBeam = getEntityData({
            Guid: grid.m_beamId,
            classTypeName: "rlBeamSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
          if (objtmpBeam) {
            const newBeamObj = objtmpBeam.myClone();
            newBeamObj.m_gridData = newGrid;
            newBeamObj.draw();

            await addEntityToDrawing(newBeamObj, false);
          }
        }
        if (grid.m_partitionWallId) {
          const objtmppartitionWall = getEntityData({
            Guid: grid.m_partitionWallId,
            classTypeName: "rlPartitionWallSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
          if (objtmppartitionWall) {
            const newpartitionWallObj = objtmppartitionWall.myClone();
            newpartitionWallObj.m_gridData = newGrid;
            newpartitionWallObj.updateStartAndEndPoint();
            newpartitionWallObj.draw();

            await addEntityToDrawing(newpartitionWallObj, false);
          }
        }
        grid.saveEditRevokeData();

        grid.m_stJoint = jointObjs[0];
        grid.m_edJoint = jointObjs[1];
        grid.updateThisObj(grid);
      }

      // const newGrid1 = new rlGridData();
      // newGrid1.initData({
      //   m_stJoint: joint,
      //   m_edJoint: grid.m_edJoint,
      //   m_Axis: grid.m_Axis,
      // });
      // if (!GridIsExist(newGrid1)) {
      //   await addGridCEntityToDrawing(newGrid1, false, true, true);

      //   if (grid.m_wallId) {
      //     const objtmpWall = getEntityData({
      //       Guid: grid.m_wallId,
      //       classTypeName: "rlWallSeg",
      //     }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
      //     if (objtmpWall) {
      //       const newWallObj = objtmpWall.myClone();
      //       newWallObj.m_gridData = newGrid1;
      //       newWallObj.draw();
      //       await addEntityToDrawing(newWallObj, false);

      //       await objtmpWall.erase();
      //     }
      //   }

      //   if (grid.m_beamId) {
      //     const objtmpBeam = getEntityData({
      //       Guid: grid.m_beamId,
      //       classTypeName: "rlBeamSeg",
      //     }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
      //     if (objtmpBeam) {
      //       const newBeamObj = objtmpBeam.myClone();
      //       newBeamObj.m_gridData = newGrid1;
      //       newBeamObj.draw();
      //       await addEntityToDrawing(newBeamObj, false);

      //       await objtmpBeam.erase();
      //     }
      //   }
      // }

      // await grid.erase();
    }
  } catch (error) {
    console.log("jointCutGrid error", error);
  }
}

// 判断节点是否在网格上
export const jointIsOnGrid = async (joint) => {
  if (joint) {
    const pt1 = new THREE.Vector3(...joint.m_pt);
    const grids = store.state.rlEntData.totalEntityData["rlGrid"];
    if (grids) {
      for (let i = 0; i < grids.length; i++) {
        const grid = grids[i];
        const pt1Tmp = new THREE.Vector3(...grid.m_stJoint.m_pt);
        const pt2Tmp = new THREE.Vector3(...grid.m_edJoint.m_pt);
        const res = ptOnLine(pt2Tmp, pt1Tmp, pt1);
        if (res == 1) {
          // 节点在网格上，切分网格
          await jointCutGrid(joint, grid);
          return true;
        }
      }
    }
  }
  return false;
};

async function jointArrayCutGrid(jointArray, grid) {
  // 对网格上的节点排序，依次绘制出分段网格
  if (jointArray && jointArray.length) {
    // grid.m_Axis.m_gridIds = grid.m_Axis.m_gridIds.filter(
    //   (item) => item != grid.Guid
    // );
    console.log("jointArray", jointArray);

    jointArray.unshift(grid.m_stJoint);
    jointArray.push(grid.m_edJoint);
    if (grid.m_centerJoint || (grid.m_Axis && grid.m_Axis.IsMainAxis < 0)) {
      const center = new THREE.Vector3(...grid.centerPoint);
      const ptStart = new THREE.Vector3(...grid.m_stJoint.m_pt);
      const ptEnd = new THREE.Vector3(...grid.m_edJoint.m_pt);
      const startAngle = calculateArcAngle(center, ptStart);
      const endAngle = calculateArcAngle(center, ptEnd);

      const normStartAngle = normalizeAngle(startAngle); // 标准化起始角度const normStartAngle = normalizeAngle(startAngle); // 标准化起始角度
      const normEndAngle = normalizeAngle(endAngle); // 标准化结束角度

      // 计算相对于起始角度的位置（处理弧度）
      function getRelativePosition(angle) {
        const normAngle = normalizeAngle(angle); // 标准化角度
        // 处理顺时针和逆时针两种情况
        if (normStartAngle <= normEndAngle) {
          // 顺时针情况
          return normAngle >= normStartAngle && normAngle <= normEndAngle
            ? normAngle - normStartAngle
            : 2 * Math.PI + normAngle - normStartAngle;
        } else {
          // 逆时针情况（跨过0点）
          return normAngle >= normStartAngle || normAngle <= normEndAngle
            ? normAngle >= normStartAngle
              ? normAngle - normStartAngle
              : normAngle + 2 * Math.PI - normStartAngle
            : normAngle - normStartAngle;
        }
      }

      // 对点进行排序
      jointArray.sort((a, b) => {
        const angleA = calculateArcAngle(
          center,
          new THREE.Vector3(a.m_pt[0], a.m_pt[1], 0)
        );
        const angleB = calculateArcAngle(
          center,
          new THREE.Vector3(b.m_pt[0], b.m_pt[1], 0)
        );
        // return angleA - angleB;

        return getRelativePosition(angleA) - getRelativePosition(angleB);
      });
    } else {
      const st = grid.m_stJoint.m_pt;
      const ptStart = new THREE.Vector3(st[0], st[1], 0);
      jointArray.sort(
        (a, b) =>
          new THREE.Vector3(a.m_pt[0], a.m_pt[1], 0).distanceTo(ptStart) -
          new THREE.Vector3(b.m_pt[0], b.m_pt[1], 0).distanceTo(ptStart)
      );
    }

    // 剔除重复节点--guid
    jointArray = jointArray.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.Guid === item.Guid)
    );
    for (let i = 0; i < jointArray.length - 1; i++) {
      let newGrid = null;
      if (grid.m_centerJoint || (grid.m_Axis && grid.m_Axis.IsMainAxis < 0)) {
        newGrid = new rlGridArcData();
        newGrid.initData({
          m_stJoint: jointArray[i],
          m_edJoint: jointArray[i + 1],
          m_centerJoint: grid.m_centerJoint,
          m_Axis: grid.m_Axis,
          centerPoint: grid.m_centerJoint
            ? grid.m_centerJoint.m_pt
            : grid.m_Axis.m_stJoint.m_pt,
        });
      } else {
        newGrid = new rlGridData();
        newGrid.initData({
          m_stJoint: jointArray[i],
          m_edJoint: jointArray[i + 1],
          m_Axis: grid.m_Axis,
        });
      }

      let isExist = GridIsExist(newGrid);
      if (!isExist) {
        await addGridEntityToDrawing(newGrid, false, true, true);

        if (grid.m_beamId) {
          const objtmpBeam = getEntityData({
            Guid: grid.m_beamId,
            classTypeName: "rlBeamSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
          if (objtmpBeam) {
            const newBeamObj = objtmpBeam.myClone();
            newBeamObj.m_gridData = newGrid;
            newBeamObj.draw();
            await addEntityToDrawing(newBeamObj, false);
          }
        }

        if (grid.m_wallId) {
          const objtmpWall = getEntityData({
            Guid: grid.m_wallId,
            classTypeName: "rlWallSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
          if (objtmpWall) {
            const newWallObj = objtmpWall.myClone();
            newWallObj.m_gridData = newGrid;
            newWallObj.draw();
            await addEntityToDrawing(newWallObj, false);
          }
        }

        if (grid.m_slabIds) {
          for (let i = 0; i < grid.m_slabIds.length; i++) {
            const objtmpSlab = getEntityData({
              Guid: grid.m_slabIds[i],
              classTypeName: "rlSlab",
            }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_slabIds[i]);
            if (objtmpSlab) {
              objtmpSlab.saveEditRevokeData();
              objtmpSlab.gridsObjs.push(newGrid);
              updateSlabDrawingData(objtmpSlab);
              // //在objtmpSlab.GridsGuid字符串后面拼接newGrid。Guid
              // objtmpSlab.GridsGuid = objtmpSlab.GridsGuid
              //   ? `${objtmpSlab.GridsGuid},${newGrid.Guid}`
              //   : newGrid.Guid;
              objtmpSlab.updateThisObj(objtmpSlab);
            }
          }
        }
      }
    }

    // 即将原本的墙梁切分成多段，所以原本的墙梁需要删除
    if (grid.m_beamId) {
      const objtmpBeam = getEntityData({
        Guid: grid.m_beamId,
        classTypeName: "rlBeamSeg",
      }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
      if (objtmpBeam) {
        objtmpBeam.erase();
      }
    }

    if (grid.m_wallId) {
      const objtmpWall = getEntityData({
        Guid: grid.m_wallId,
        classTypeName: "rlWallSeg",
      }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
      if (objtmpWall) {
        objtmpWall.erase();
      }
    }
    // grid.erase();
    // 原数据已被切分，需删除
    if (getEntityData({ Guid: grid.Guid, classTypeName: "rlGrid" })) {
      await grid.erase(); // 已添加到画布
    } else {
      grid.mcDbGrid?.erase();
    }
  }
}

function updateSlabDrawingData(objSlab) {
  let gridObjs = objSlab.gridsObjs;
  const girdData = gridObjs.map((item) => {
    const isArc =
      item.m_centerJoint || (item.m_Axis && item.m_Axis.IsMainAxis < 0);
    if (isArc) {
      const stPoint = new McGePoint3d(...item.m_stJoint.m_pt);
      const edPoint = new McGePoint3d(...item.m_edJoint.m_pt);
      const centerPoint = new McGePoint3d(
        item.centerPoint[0],
        item.centerPoint[1],
        0
      );
      const dRadius = item.mcDbGrid.radius;
      const points = getArcPoints(stPoint, edPoint, centerPoint, dRadius);
      const pointsStr = points.map((item) => `${item.x},${item.y},0`).join(",");
      return `${item.Guid}:[${pointsStr}],`;
    } else {
      return `${item.Guid}:[${[
        ...item.m_stJoint.m_pt,
        ...item.m_edJoint.m_pt,
      ]}],`;
    }
  });
  let data = "";
  girdData.forEach((item) => (data += item));

  // 获取楼板绘制数据
  const createSlab = new CreateSlab();
  const res = createSlab.getSlabJsonData(data);
  if (!res) return;
  const model = JSON.parse(res)?.Slab;

  const modelKeys = Object.keys(model);
  const modelData = Object.values(model).flat();
  if (modelKeys.length == 0 || modelData.length == 0) return null;

  const slabDrawData = modelData[0];
  objSlab.points = slabDrawData.Points;
  objSlab.index2dData = slabDrawData["2DUpView"];
  objSlab.member = true;
  let gridsGuid = modelKeys[0].split(",");
  // 剔除重复的guid
  gridsGuid = [...new Set(gridsGuid)];
  gridsGuid = gridsGuid.join(",");
  objSlab.GridsGuid = gridsGuid;
  objSlab.VertexX = "";
  objSlab.VertexY = "";
  objSlab.VertexZ = "";
  for (let index = 0; index < slabDrawData["2DUpView"].length - 2; index += 3) {
    objSlab.VertexX += slabDrawData["2DUpView"][index] + ",";
  }
  for (let index = 1; index < slabDrawData["2DUpView"].length; index += 3) {
    objSlab.VertexY += slabDrawData["2DUpView"][index] + ",";
  }
  for (let index = 2; index < slabDrawData["2DUpView"].length; index += 3) {
    objSlab.VertexZ += slabDrawData["2DUpView"][index] + ",";
  }
}

async function jointArrayCutGridC(jointArray, grid) {
  // 对网格上的节点排序，依次绘制出分段网格
  if (jointArray && jointArray.length) {
    // grid.m_Axis.m_gridIds = grid.m_Axis.m_gridIds.filter(
    //   (item) => item != grid.Guid
    // );

    jointArray.unshift(grid.m_stJoint);
    jointArray.push(grid.m_edJoint);
    const st = grid.m_stJoint.m_pt;
    const ptStart = new THREE.Vector3(st[0], st[1], 0);
    jointArray.sort(
      (a, b) =>
        new THREE.Vector3(a.m_pt[0], a.m_pt[1], 0).distanceTo(ptStart) -
        new THREE.Vector3(b.m_pt[0], b.m_pt[1], 0).distanceTo(ptStart)
    );

    // 剔除重复节点--guid
    jointArray = jointArray.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.Guid === item.Guid)
    );
    for (let i = 0; i < jointArray.length - 1; i++) {
      let newGrid = null;
      newGrid = new rlGridCData();
      newGrid.initData({
        m_stJoint: jointArray[i],
        m_edJoint: jointArray[i + 1],
        m_Axis: null,
      });

      if (!GridCIsExist(newGrid)) {
        await addGridCEntityToDrawing(newGrid, false, true, true);

        if (grid.m_beamId) {
          const objtmpBeam = getEntityData({
            Guid: grid.m_beamId,
            classTypeName: "rlBeamSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
          if (objtmpBeam) {
            const newBeamObj = objtmpBeam.myClone();
            newBeamObj.m_gridData = newGrid;
            newBeamObj.draw();
            await addEntityToDrawing(newBeamObj, false);
          }
        }

        if (grid.m_wallId) {
          const objtmpWall = getEntityData({
            Guid: grid.m_wallId,
            classTypeName: "rlWallSeg",
          }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
          if (objtmpWall) {
            const newWallObj = objtmpWall.myClone();
            newWallObj.m_gridData = newGrid;
            newWallObj.draw();
            await addEntityToDrawing(newWallObj, false);
          }
        }
      }
    }

    // 即将原本的墙梁切分成多段，所以原本的墙梁需要删除
    if (grid.m_beamId) {
      const objtmpBeam = getEntityData({
        Guid: grid.m_beamId,
        classTypeName: "rlBeamSeg",
      }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
      if (objtmpBeam) {
        objtmpBeam.erase();
      }
    }

    if (grid.m_wallId) {
      const objtmpWall = getEntityData({
        Guid: grid.m_wallId,
        classTypeName: "rlWallSeg",
      }); // rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
      if (objtmpWall) {
        objtmpWall.erase();
      }
    }
    // grid.erase();
    // 原数据已被切分，需删除
    if (getEntityData({ Guid: grid.Guid, classTypeName: "rlGridC" })) {
      await grid.erase(); // 已添加到画布
    } else {
      grid.mcDbGrid?.erase();
    }
  }
}

// 计算直线与直线的交点
export function lineInsection(
  line1_pt1,
  line1_pt2,
  line2_pt1,
  line2_pt2,
  isGrid = true // 是否用于网格相交计算,如果是网格相交计算，则需要判断交点是否在网格上
) {
  const EPRES = 1e-6; // 用于比较浮点数的阈值
  line1_pt1 = new THREE.Vector3(line1_pt1.x, line1_pt1.y, line1_pt1.z);
  line1_pt2 = new THREE.Vector3(line1_pt2.x, line1_pt2.y, line1_pt2.z);
  line2_pt1 = new THREE.Vector3(line2_pt1.x, line2_pt1.y, line2_pt1.z);
  line2_pt2 = new THREE.Vector3(line2_pt2.x, line2_pt2.y, line2_pt2.z);

  if (
    Math.abs(line1_pt1.z - line2_pt1.z) > EPRES ||
    Math.abs(line1_pt2.z - line2_pt2.z) > EPRES
  ) {
    return { isIntersected: false };
  }

  // 求直线解析方程：a * x + b * y + c = 0 (a >= 0)
  let a = line1_pt2.y - line1_pt1.y;
  let b = line1_pt1.x - line1_pt2.x;
  let c = line1_pt2.x * line1_pt1.y - line1_pt2.y * line1_pt1.x;

  if (a < -EPRES) {
    a = -a;
    b = -b;
    c = -c;
  }

  let aOther = line2_pt2.y - line2_pt1.y;
  let bOther = line2_pt1.x - line2_pt2.x;
  let cOther = line2_pt2.x * line2_pt1.y - line2_pt2.y * line2_pt1.x;

  if (aOther < -EPRES) {
    aOther = -aOther;
    bOther = -bOther;
    cOther = -cOther;
  }

  const dTmp = a * bOther - aOther * b;

  if (Math.abs(dTmp) < EPRES) {
    //直线完全或局部重叠
    if (
      Math.abs(a * cOther - aOther * c) < EPRES &&
      Math.abs(b * cOther - bOther * c) < EPRES
    ) {
      //完全重叠
      if (
        (line1_pt1.equals(line2_pt1) && line1_pt2.equals(line2_pt2)) ||
        (line1_pt1.equals(line2_pt2) && line1_pt2.equals(line2_pt1))
      ) {
        return { isIntersected: false, insertType: "overlapping" };
      } else {
        return {
          isIntersected: false,
          insertType: "part_overlapping",
        };
      }
    }
    // 不相交
    return { isIntersected: false };
  }
  const InsectPt = {
    x: (cOther * b - c * bOther) / dTmp,
    y: (aOther * c - a * cOther) / dTmp,
    z: line1_pt1.z,
  };
  // 判断点是否在线段上
  if (isGrid) {
    if (
      ptOnLine(line1_pt1, line1_pt2, InsectPt) == 1 &&
      ptOnLine(line2_pt1, line2_pt2, InsectPt) == 1
    ) {
      return { isIntersected: true, intersectionPoint: InsectPt };
    } else return { isIntersected: false };
  } else {
    if (
      ptOnLine(line1_pt1, line1_pt2, InsectPt) >= 1 &&
      ptOnLine(line2_pt1, line2_pt2, InsectPt) >= 1
    ) {
      return { isIntersected: true, intersectionPoint: InsectPt };
    } else return { isIntersected: false };
  }
}

// 计算直线与圆弧的交点
// 计算直线与圆弧的交点
export function lineArcIntersection(
  line1_pt1, // 直线起点
  line1_pt2, // 直线终点
  arcCenter, // 圆心
  arcRadius, // 半径
  arcStartAngle, // 圆弧起始角度
  arcEndAngle // 圆弧结束角度
) {
  const EPRES = 1e-1; // 用于比较浮点数的阈值

  // 将直线参数化为: ax + by + c = 0
  const a = line1_pt2.y - line1_pt1.y;
  const b = line1_pt1.x - line1_pt2.x;
  const c = line1_pt2.x * line1_pt1.y - line1_pt2.y * line1_pt1.x;

  // 计算圆心到直线的距离
  const dist =
    Math.abs(a * arcCenter.x + b * arcCenter.y + c) / Math.sqrt(a * a + b * b);
  // 如果距离大于半径，则无交点
  if (dist > arcRadius + EPRES) {
    return { isIntersected: false };
  }

  // 计算交点
  const intersectionPoints = [];

  // 计算直线上的最近点
  const t = -(a * arcCenter.x + b * arcCenter.y + c) / (a * a + b * b);
  const closestX = arcCenter.x + a * t;
  const closestY = arcCenter.y + b * t;

  // 如果距离等于半径，则只有一个交点
  if (Math.abs(dist - arcRadius) < EPRES) {
    const pt = { x: closestX, y: closestY, z: line1_pt1.z };

    // 检查交点是否在线段上
    if (ptOnLine(line1_pt1, line1_pt2, pt) === 1) {
      // 检查交点是否在圆弧范围内
      const angle = toDegrees(calculateArcAngle(arcCenter, pt));

      const isAngleInArc = isAngleInArcRange(angle, arcStartAngle, arcEndAngle);

      if (isAngleInArc > 0) {
        intersectionPoints.push(pt);
      }
    }
  } else {
    // 距离小于半径，有两个交点
    const dOnLine = Math.sqrt(arcRadius * arcRadius - dist * dist);
    const dx = (-b * dOnLine) / Math.sqrt(a * a + b * b);
    const dy = (a * dOnLine) / Math.sqrt(a * a + b * b);

    const pt1 = { x: closestX + dx, y: closestY + dy, z: line1_pt1.z };
    const pt2 = { x: closestX - dx, y: closestY - dy, z: line1_pt1.z };

    // 检查交点是否在线段上和圆弧范围内
    [pt1, pt2].forEach((pt) => {
      if (ptOnLine(line1_pt1, line1_pt2, pt) === 1) {
        const angle = toDegrees(calculateArcAngle(arcCenter, pt));

        const isAngleInArc = isAngleInArcRange(
          angle,
          arcStartAngle,
          arcEndAngle
        );

        if (isAngleInArc > 0) {
          intersectionPoints.push(pt);
        }
      }
    });
  }

  return {
    isIntersected: intersectionPoints.length > 0,
    intersectionPoints: intersectionPoints,
  };
}
export function lineArcIntersection1(
  line1_pt1, // 直线起点
  line1_pt2, // 直线终点
  arcCenter, // 圆心
  ptSt,
  ptEd
) {
  const arcRadius = ptSt.distanceTo(arcCenter);
  const arcStartAngle = toDegrees(calculateArcAngle(arcCenter, ptSt));
  const arcEndAngle = toDegrees(calculateArcAngle(arcCenter, ptEd));

  const EPRES = 1e-1; // 用于比较浮点数的阈值

  // 将直线参数化为: ax + by + c = 0
  const a = line1_pt2.y - line1_pt1.y;
  const b = line1_pt1.x - line1_pt2.x;
  const c = line1_pt2.x * line1_pt1.y - line1_pt2.y * line1_pt1.x;

  // 计算圆心到直线的距离
  const dist =
    Math.abs(a * arcCenter.x + b * arcCenter.y + c) / Math.sqrt(a * a + b * b);
  // 如果距离大于半径，则无交点
  if (dist > arcRadius + EPRES) {
    return { isIntersected: false };
  }

  // 计算交点
  const intersectionPoints = [];

  // 计算直线上的最近点
  const t = -(a * arcCenter.x + b * arcCenter.y + c) / (a * a + b * b);
  const closestX = arcCenter.x + a * t;
  const closestY = arcCenter.y + b * t;

  // 如果距离等于半径，则只有一个交点
  if (Math.abs(dist - arcRadius) < EPRES) {
    const pt = { x: closestX, y: closestY, z: line1_pt1.z };

    // 检查交点是否在线段上
    if (ptOnLine(line1_pt1, line1_pt2, pt) === 1) {
      // 检查交点是否在圆弧范围内
      const angle = toDegrees(calculateArcAngle(arcCenter, pt));

      const isAngleInArc = isAngleInArcRange(angle, arcStartAngle, arcEndAngle);

      if (isAngleInArc > 0) {
        intersectionPoints.push(pt);
      }
    }
  } else {
    // 距离小于半径，有两个交点
    const dOnLine = Math.sqrt(arcRadius * arcRadius - dist * dist);
    const dx = (-b * dOnLine) / Math.sqrt(a * a + b * b);
    const dy = (a * dOnLine) / Math.sqrt(a * a + b * b);

    const pt1 = { x: closestX + dx, y: closestY + dy, z: line1_pt1.z };
    const pt2 = { x: closestX - dx, y: closestY - dy, z: line1_pt1.z };

    // 检查交点是否在线段上和圆弧范围内
    [pt1, pt2].forEach((pt) => {
      if (ptOnLine(line1_pt1, line1_pt2, pt) === 1) {
        const angle = toDegrees(calculateArcAngle(arcCenter, pt));

        const isAngleInArc = isAngleInArcRange(
          angle,
          arcStartAngle,
          arcEndAngle
        );

        if (isAngleInArc > 0) {
          intersectionPoints.push(pt);
        }
      }
    });
  }

  return {
    isIntersected: intersectionPoints.length > 0,
    intersectionPoints: intersectionPoints,
  };
}

// 计算圆弧与圆弧的交点
export function arcArcIntersection(
  arc1Center,
  arc1Radius,
  arc1StartAngle,
  arc1EndAngle,
  arc2Center,
  arc2Radius,
  arc2StartAngle,
  arc2EndAngle
) {
  const EPRES = 1e-1; // 用于比较浮点数的阈值

  // 计算两圆心之间的距离
  const centerDist = arc1Center.distanceTo(arc2Center);

  // 如果两圆心距离大于两半径之和，则无交点
  if (centerDist > arc1Radius + arc2Radius + EPRES) {
    return { isIntersected: false };
  }

  // 如果两圆心距离小于两半径差的绝对值，则无交点（一个圆在另一个圆内部）
  if (centerDist < Math.abs(arc1Radius - arc2Radius) - EPRES) {
    return { isIntersected: false };
  }

  // 计算交点
  const intersectionPoints = [];

  // 使用余弦定理计算交点
  const a =
    (arc1Radius * arc1Radius -
      arc2Radius * arc2Radius +
      centerDist * centerDist) /
    (2 * centerDist);
  const h = Math.sqrt(arc1Radius * arc1Radius - a * a);

  // 计算交点坐标
  const dx = arc2Center.x - arc1Center.x;
  const dy = arc2Center.y - arc1Center.y;
  const dirX = dx / centerDist;
  const dirY = dy / centerDist;

  // 计算两个可能的交点
  const intersect1 = {
    x: arc1Center.x + a * dirX - h * dirY,
    y: arc1Center.y + a * dirY + h * dirX,
    z: arc1Center.z,
  };

  const intersect2 = {
    x: arc1Center.x + a * dirX + h * dirY,
    y: arc1Center.y + a * dirY - h * dirX,
    z: arc1Center.z,
  };

  // 检查交点是否在两个圆弧的角度范围内
  [intersect1, intersect2].forEach((pt) => {
    const angle1 = toDegrees(calculateArcAngle(arc1Center, pt));
    const angle2 = toDegrees(calculateArcAngle(arc2Center, pt));
    const isAngle1InArc = isAngleInArcRange(
      angle1,
      arc1StartAngle,
      arc1EndAngle
    );
    const isAngle2InArc = isAngleInArcRange(
      angle2,
      arc2StartAngle,
      arc2EndAngle
    );

    // const isAngle1InArc =
    //   arc1StartAngle <= arc1EndAngle
    //     ? angle1 > arc1StartAngle + 0.001 && angle1 < arc1EndAngle - 0.001
    //     : angle1 > arc1StartAngle + 0.001 || angle1 < arc1EndAngle - 0.001;

    // const isAngle2InArc =
    //   arc2StartAngle <= arc2EndAngle
    //     ? angle2 > arc2StartAngle + 0.001 && angle2 < arc2EndAngle - 0.001
    //     : angle2 > arc2StartAngle + 0.001 || angle2 < arc2EndAngle - 0.001;

    if (isAngle1InArc > 0 && isAngle2InArc > 0) {
      intersectionPoints.push(pt);
    }
  });

  return {
    isIntersected: intersectionPoints.length > 0,
    intersectionPoints: intersectionPoints,
  };
}

export function arcArcIntersection1(
  arc1Center,
  ptSt1,
  ptEd1,
  arc2Center,
  ptSt2,
  ptEd2
) {
  const arc1Radius = ptSt1.distanceTo(arc1Center);
  const arc2Radius = ptSt2.distanceTo(arc2Center);
  const arc1StartAngle = toDegrees(calculateArcAngle(arc1Center, ptSt1));
  const arc1EndAngle = toDegrees(calculateArcAngle(arc1Center, ptEd1));
  const arc2StartAngle = toDegrees(calculateArcAngle(arc2Center, ptSt2));
  const arc2EndAngle = toDegrees(calculateArcAngle(arc2Center, ptEd2));

  const EPRES = 1e-1; // 用于比较浮点数的阈值

  // 计算两圆心之间的距离
  const centerDist = arc1Center.distanceTo(arc2Center);

  // 如果两圆心距离大于两半径之和，则无交点
  if (centerDist > arc1Radius + arc2Radius + EPRES) {
    return { isIntersected: false };
  }

  // 如果两圆心距离小于两半径差的绝对值，则无交点（一个圆在另一个圆内部）
  if (centerDist < Math.abs(arc1Radius - arc2Radius) - EPRES) {
    return { isIntersected: false };
  }

  // 计算交点
  const intersectionPoints = [];

  // 使用余弦定理计算交点
  const a =
    (arc1Radius * arc1Radius -
      arc2Radius * arc2Radius +
      centerDist * centerDist) /
    (2 * centerDist);
  const h = Math.sqrt(arc1Radius * arc1Radius - a * a);

  // 计算交点坐标
  const dx = arc2Center.x - arc1Center.x;
  const dy = arc2Center.y - arc1Center.y;
  const dirX = dx / centerDist;
  const dirY = dy / centerDist;

  // 计算两个可能的交点
  const intersect1 = {
    x: arc1Center.x + a * dirX - h * dirY,
    y: arc1Center.y + a * dirY + h * dirX,
    z: arc1Center.z,
  };

  const intersect2 = {
    x: arc1Center.x + a * dirX + h * dirY,
    y: arc1Center.y + a * dirY - h * dirX,
    z: arc1Center.z,
  };

  // 检查交点是否在两个圆弧的角度范围内
  [intersect1, intersect2].forEach((pt) => {
    const angle1 = toDegrees(calculateArcAngle(arc1Center, pt));
    const angle2 = toDegrees(calculateArcAngle(arc2Center, pt));
    const isAngle1InArc = isAngleInArcRange(
      angle1,
      arc1StartAngle,
      arc1EndAngle
    );
    const isAngle2InArc = isAngleInArcRange(
      angle2,
      arc2StartAngle,
      arc2EndAngle
    );

    // const isAngle1InArc =
    //   arc1StartAngle <= arc1EndAngle
    //     ? angle1 > arc1StartAngle + 0.001 && angle1 < arc1EndAngle - 0.001
    //     : angle1 > arc1StartAngle + 0.001 || angle1 < arc1EndAngle - 0.001;

    // const isAngle2InArc =
    //   arc2StartAngle <= arc2EndAngle
    //     ? angle2 > arc2StartAngle + 0.001 && angle2 < arc2EndAngle - 0.001
    //     : angle2 > arc2StartAngle + 0.001 || angle2 < arc2EndAngle - 0.001;

    if (isAngle1InArc > 0 && isAngle2InArc > 0) {
      intersectionPoints.push(pt);
    }
  });

  return {
    isIntersected: intersectionPoints.length > 0,
    intersectionPoints: intersectionPoints,
  };
}

export function ptOnLine(line1_pt1, line1_pt2, pt) {
  // 判断点是否在线段上
  const point = new THREE.Vector3(pt.x, pt.y, pt.z);
  const point1 = new THREE.Vector3(line1_pt1.x, line1_pt1.y, line1_pt1.z);
  const point2 = new THREE.Vector3(line1_pt2.x, line1_pt2.y, line1_pt2.z);
  // 点在线段端点上
  if (point1.distanceTo(point) < 5) {
    return 2;
  } // 和传入的起点相等时
  if (point2.distanceTo(point) < 5) {
    return 3;
  } // 和传入的终点相等时

  // console.log("11ss", point.distanceTo(point1), point.distanceTo(point2));
  // console.log("mmmmm", point1.distanceTo(point2), point, point1, point2);

  if (
    Math.abs(
      point.distanceTo(point1) +
        point.distanceTo(point2) -
        point1.distanceTo(point2)
    ) < 1
  ) {
    const line = new THREE.Line3(
      new THREE.Vector3(line1_pt1.x, line1_pt1.y, line1_pt1.z),
      new THREE.Vector3(line1_pt2.x, line1_pt2.y, line1_pt2.z)
    );
    const isOnLine = line.closestPointToPoint(point).distanceTo(point) < 5;
    if (isOnLine) {
      return 1;
    } else {
      return -1;
    }
  } else {
    return -1;
  }
}

export function ptOnArc(arcCenter, arcRadius, ptSt, ptEd, pt) {
  if (Math.abs(pt.distanceTo(arcCenter) - arcRadius) > 1) return -1;
  if (Math.abs(pt.distanceTo(ptSt)) < 1 || Math.abs(pt.distanceTo(ptEd)) < 1) {
    return 2;
  }
  const angle = toDegrees(calculateArcAngle(arcCenter, pt));
  const angleSt = toDegrees(calculateArcAngle(arcCenter, ptSt));
  const angleEd = toDegrees(calculateArcAngle(arcCenter, ptEd));

  const isAngleInArc = isAngleInArcRange(angle, angleSt, angleEd);
  if (isAngleInArc > 0) {
    return isAngleInArc;
  } else {
    return -1;
  }
}

// 两个点是否相等
export function ptIsEqual(pt1, pt2) {
  return pt1.distanceTo(pt2) < 10;
}

// 计算两线共线
export function areLineCollinear(A, B, C, D) {
  if (Math.abs(A.x - B.x) < 1 && Math.abs(A.y - B.y) < 1) {
    return false;
  }
  if (Math.abs(C.x - D.x) < 1 && Math.abs(C.y - D.y) < 1) {
    return false;
  }

  //将所有点的x和y做四舍五入处理
  // 四舍五入到整数，以消除浮点误差
  if (Math.abs(A.x - B.x) < 1) {
    A.x = B.x = Math.round(A.x);
  }

  if (Math.abs(C.x - D.x) < 1) {
    C.x = D.x = Math.round(C.x);
  }

  if (Math.abs(A.y - B.y) < 1) {
    A.y = B.y = Math.round(A.y);
  }

  if (Math.abs(C.y - D.y) < 1) {
    C.y = D.y = Math.round(C.y);
  }

  // const roundedA = new THREE.Vector3(Math.round(A.x), Math.round(A.y), A.z);
  // const roundedB = new THREE.Vector3(Math.round(B.x), Math.round(B.y), B.z);
  // const roundedC = new THREE.Vector3(Math.round(C.x), Math.round(C.y), C.z);
  // const roundedD = new THREE.Vector3(Math.round(D.x), Math.round(D.y), D.z);

  // // 使用四舍五入后的点进行后续计算
  // A = roundedA;
  // B = roundedB;
  // C = roundedC;
  // D = roundedD;

  // 计算线段的方向向量
  const AB = new THREE.Vector3().subVectors(B, A);
  const CD = new THREE.Vector3().subVectors(D, C);

  const slope1 = Math.abs(AB.x) < Math.exp(-1) ? 9999 : AB.y / AB.x;
  const slope2 = Math.abs(CD.x) < Math.exp(-1) ? 9999 : CD.y / CD.x;

  //两线段斜率相等，则平行
  if (Math.abs(slope1 - slope2) < Math.exp(-4)) {
    // 检查两条线段是否共线
    // 使用向量共线性检测
    // 计算AB和AC的单位向量
    const ABLength = AB.length();
    const ABUnit = new THREE.Vector3().copy(AB).divideScalar(ABLength);

    // 计算AC和AD向量
    const AC = new THREE.Vector3().subVectors(C, A);
    const AD = new THREE.Vector3().subVectors(D, A);

    // 计算CD和AB的单位向量
    const CDLength = CD.length();
    const CDUnit = new THREE.Vector3().copy(CD).divideScalar(CDLength);

    // 检查向量是否平行（点积接近1或-1）
    const dotProductVectors = Math.abs(ABUnit.dot(CDUnit));
    if (Math.abs(dotProductVectors - 1) < 0.001) {
      // 检查点C是否在AB的延长线上
      // 计算AC在AB方向上的投影
      const projAC = AC.dot(ABUnit);
      const projAD = AD.dot(ABUnit);

      // 计算C到AB直线的垂直距离
      const distC = new THREE.Vector3()
        .copy(AC)
        .sub(new THREE.Vector3().copy(ABUnit).multiplyScalar(projAC))
        .length();

      // 如果距离足够小，则认为共线
      if (distC < 2) {
        return true;
      }
    }

    return false;
  }

  return false;
}

// 新增节点是否在网格上
export const JointIsOnGrid = (point, ignoreGridArray = []) => {
  const pointTmp = point instanceof Array ? point : point.m_pt;
  const pt = new THREE.Vector3(pointTmp[0], pointTmp[1], pointTmp[2]);
  const rlGroup = store.state.rlEntData.totalEntityData["rlGrid"]; // ;rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll(); //获取当前图纸中的网格数据

  const onGrids = new Array();
  if (rlGroup) {
    // rlGroup = rlGroup.filter((grid) => !removeGrids.includes(grid));
    for (let i = 0; i < rlGroup.length; i++) {
      if (ignoreGridArray.find((grid) => grid.Guid == rlGroup[i].Guid))
        continue;
      const pt1Tmp = new THREE.Vector3(...rlGroup[i].m_stJoint.m_pt);
      const pt2Tmp = new THREE.Vector3(...rlGroup[i].m_edJoint.m_pt);

      let res = ptOnLine(pt1Tmp, pt2Tmp, pt);
      if (rlGroup[i].m_centerJoint) {
        let ptCenter = new THREE.Vector3(...rlGroup[i].centerPoint);
        let redius = pt1Tmp.distanceTo(ptCenter);
        if (Math.abs(pt.distanceTo(ptCenter) - redius) > 1) {
          res = -1;
        } else {
          res = ptOnArc(ptCenter, redius, pt1Tmp, pt2Tmp, pt);
        }
      }

      if (res == 1) {
        if (!rlGroup[i].m_centerJoint) {
          const lineOrigin = new THREE.Line3(
            new THREE.Vector3(pt1Tmp.x, pt1Tmp.y, pt1Tmp.z),
            new THREE.Vector3(pt2Tmp.x, pt2Tmp.y, pt2Tmp.z)
          );
          const ptTmp = new THREE.Vector3(pt.x, pt.y, pt.z);
          let InsectPt = null;
          InsectPt = lineOrigin.closestPointToPoint(ptTmp);
          point.m_pt = [InsectPt.x, InsectPt.y, InsectPt.z];
        }

        onGrids.push(rlGroup[i]);
        // removeGrids.push(rlGroup[i]);
      }
    }
    return onGrids;
  }
};

// 新增节点是否在网格上--草图
export const JointIsOnGridC = (point) => {
  const pointTmp = point instanceof Array ? point : point.m_pt;
  const pt = new THREE.Vector3(pointTmp[0], pointTmp[1], pointTmp[2]);
  const rlGroup = store.state.rlEntData.totalEntityData["rlGridC"]; // ;rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll(); //获取当前图纸中的网格数据

  const onGrids = new Array();
  if (rlGroup) {
    // rlGroup = rlGroup.filter((grid) => !removeGrids.includes(grid));
    for (let i = 0; i < rlGroup.length; i++) {
      const pt1Tmp = new THREE.Vector3(...rlGroup[i].m_stJoint.m_pt);
      const pt2Tmp = new THREE.Vector3(...rlGroup[i].m_edJoint.m_pt);

      const res = ptOnLine(pt1Tmp, pt2Tmp, pt);

      if (res == 1) {
        const lineOrigin = new THREE.Line3(
          new THREE.Vector3(pt1Tmp.x, pt1Tmp.y, pt1Tmp.z),
          new THREE.Vector3(pt2Tmp.x, pt2Tmp.y, pt2Tmp.z)
        );
        const ptTmp = new THREE.Vector3(pt.x, pt.y, pt.z);
        let InsectPt = null;
        InsectPt = lineOrigin.closestPointToPoint(ptTmp);
        point.m_pt = [InsectPt.x, InsectPt.y, InsectPt.z];
        onGrids.push(rlGroup[i]);
        // removeGrids.push(rlGroup[i]);
      }
    }
    return onGrids;
  }
};

// 修改网格长度
export const modifyGridLength = async (
  objGrid,
  gridLength /* 更新后的长度 */
) => {
  const startPoint = new THREE.Vector3(...objGrid.m_stJoint.m_pt);
  const endPoint = new THREE.Vector3(...objGrid.m_edJoint.m_pt);
  if (Math.abs(startPoint.distanceTo(endPoint) - gridLength) < 5) return false;
  // let originLength = startPoint.distanceTo(endPoint);
  // 计算方向向量
  const direction = new THREE.Vector3()
    .subVectors(endPoint, startPoint)
    .normalize();

  let currAxis = await getGridAxisData(objGrid);
  if (!currAxis) return null;
  // let axisObj = objGrid.m_Axis;
  if (
    objGrid.m_edJoint.m_gridIds.length <= 1 // &&
    // objGrid.m_edJoint.m_AxisIds.length <= 1
  ) {
    // 终点仅连接当前网格
    // 计算新的终点坐标
    endPoint.x = startPoint.x + direction.x * gridLength;
    endPoint.y = startPoint.y + direction.y * gridLength;

    objGrid.m_edJoint.saveEditRevokeData();
    // 更新节点位置
    objGrid.m_edJoint.m_pt = [endPoint.x, endPoint.y, endPoint.z];
    objGrid.m_edJoint.updateThisObj(objGrid.m_edJoint, true);

    // 更新网格
    objGrid.saveEditRevokeData();
    await updataGridLength(objGrid);
    objGrid.updateThisObj(objGrid, true);
    // let originAxisGuid = objGrid.m_Axis.Guid; //原轴线id
    // 更新轴线
    // const isMerge = await updataAxisLength(currAxis, endPoint);

    // if (isMerge) {
    //   //清除节点与原轴线的绑定
    //   if (objGrid.m_stJoint.m_AxisIds.includes(originAxisGuid)) {
    //     objGrid.m_stJoint.m_AxisIds = objGrid.m_stJoint.m_AxisIds.filter(
    //       (item) => item != originAxisGuid
    //     );
    //   }
    //   if (objGrid.m_edJoint.m_AxisIds.includes(originAxisGuid)) {
    //     objGrid.m_edJoint.m_AxisIds = objGrid.m_edJoint.m_AxisIds.filter(
    //       (item) => item != originAxisGuid
    //     );
    //   }
    // }
    return objGrid;
    // ----------弃用
    // let stJoint = objGrid.m_stJoint;
    // if (
    //   objGrid.m_stJoint.m_gridIds.length <= 1 &&
    //   objGrid.m_stJoint.m_AxisIds.length <= 1
    // ) {
    //   //起点也仅在此网格上，删除终点时会将孤立节点都删除，所以需要重新添加一次
    //   let stPoint = objGrid.m_stJoint.m_pt;
    //   await objGrid.m_edJoint.erase(); //将原终点删除

    //   const newStJoint = new rlJointData();
    //   newStJoint.initData({ m_pt: stPoint });
    //   stJoint = await addEntityToDrawing(newStJoint, false);

    //   if (!stJoint) stJoint = newStJoint;
    //   axisObj = null;
    // } else {
    //   if (objGrid.m_Axis.m_gridIds.length <= 1) {
    //     axisObj = null;
    //   }
    //   await objGrid.m_edJoint.erase(); //将原终点删除
    // }
    // // 将新的结束点添加画布
    // const newEndJoint = new rlJointData();
    // newEndJoint.initData({ m_pt: [endPoint.x, endPoint.y, 0] });
    // let isExist = await addEntityToDrawing(newEndJoint, false);
    // if (!isExist) {
    //   isExist = newEndJoint;
    // }

    // if (!axisObj) {
    //   axisObj = new rlAxisData();
    //   axisObj.initData({
    //     m_stJoint: stJoint,
    //     m_edJoint: isExist,
    //   });
    //   await addEntityToDrawing(axisObj, false);
    // } else {
    //   //更新轴线数据
    //   updataAxisLength(axisObj, endPoint);
    // }

    // const newGridObj = new rlGridData();
    // newGridObj.initData({
    //   m_stJoint: stJoint,
    //   m_edJoint: isExist,
    //   m_Axis: axisObj,
    // });

    // await addEntityToDrawing(newGridObj, false);
    // return newGridObj;
  } else if (
    objGrid.m_stJoint.m_gridIds.length <= 1 // &&
    // objGrid.m_stJoint.m_AxisIds.length <= 1
  ) {
    // 起点仅连接当前网格
    // 计算新的起点坐标
    startPoint.x = endPoint.x - direction.x * gridLength;
    startPoint.y = endPoint.y - direction.y * gridLength;

    objGrid.m_stJoint.saveEditRevokeData();
    // 更新节点位置
    objGrid.m_stJoint.m_pt = [startPoint.x, startPoint.y, endPoint.z];
    objGrid.m_stJoint.updateThisObj(objGrid.m_stJoint, true);
    // let originAxisGuid = objGrid.m_Axis.Guid; //原轴线id
    objGrid.saveEditRevokeData();
    await updataGridLength(objGrid);
    objGrid.updateThisObj(objGrid, true);
    // 更新轴线
    // await updataAxisLength(currAxis, startPoint);

    // if (isMerge) {
    //   //清除节点与原轴线的绑定
    //   if (objGrid.m_stJoint.m_AxisIds.includes(originAxisGuid)) {
    //     objGrid.m_stJoint.m_AxisIds = objGrid.m_stJoint.m_AxisIds.filter(
    //       (item) => item != originAxisGuid
    //     );
    //   }
    //   if (objGrid.m_edJoint.m_AxisIds.includes(originAxisGuid)) {
    //     objGrid.m_edJoint.m_AxisIds = objGrid.m_edJoint.m_AxisIds.filter(
    //       (item) => item != originAxisGuid
    //     );
    //   }
    // }
    // ----弃用

    // if (objGrid.m_Axis.m_gridIds.length <= 1) {
    //   axisObj = null;
    // }
    // await objGrid.m_stJoint.erase();

    // // 将新的结束点添加画布
    // const newStartJoint = new rlJointData();
    // newStartJoint.initData({ m_pt: [startPoint.x, startPoint.y, 0] });
    // let isExist = await addEntityToDrawing(newStartJoint, false);
    // if (!isExist) {
    //   isExist = newStartJoint;
    // }
    // if (!axisObj) {
    //   axisObj = new rlAxisData();
    //   axisObj.initData({
    //     m_stJoint: isExist,
    //     m_edJoint: objGrid.m_edJoint,
    //   });
    //   await addEntityToDrawing(axisObj, false);
    // } else {
    //   //更新轴线数据
    //   updataAxisLength(axisObj, startPoint);
    // }

    // const newGridObj = new rlGridData();
    // newGridObj.initData({
    //   m_stJoint: isExist,
    //   m_edJoint: objGrid.m_edJoint,
    //   m_Axis: axisObj,
    // });

    // await addEntityToDrawing(newGridObj, false);
    return objGrid;
  }
  // ---------两段都有连接了其他网格，不能修改长度
  // else {
  //   //两端节点连接了其他网格
  //   //更新轴线
  //   let axisObj = objGrid.m_Axis;
  //   if (objGrid.m_Axis.m_gridIds?.length > 1) {
  //     await objGrid.erase();
  //   } else {
  //     await objGrid.erase();
  //     axisObj = null;
  //   }
  //   //计算新的终点坐标
  //   endPoint.x = startPoint.x + direction.x * gridLength;
  //   endPoint.y = startPoint.y + direction.y * gridLength;

  //   //新生成一个终点节点
  //   const newEndJoint = new rlJointData();
  //   newEndJoint.initData({ m_pt: [endPoint.x, endPoint.y, 0] });

  //   let isExist = await addEntityToDrawing(newEndJoint, false);
  //   if (!isExist) {
  //     isExist = newEndJoint;
  //   }
  //   if (!axisObj) {
  //     axisObj = new rlAxisData();
  //     axisObj.initData({
  //       m_stJoint: objGrid.m_stJoint,
  //       m_edJoint: isExist,
  //     });
  //     await addEntityToDrawing(axisObj, false);
  //   } else {
  //     //更新轴线数据
  //     updataAxisLength(axisObj, endPoint);
  //   }
  //   //重新生成新的网格，删除当前网格
  //   const newGridObj = new rlGridData();
  //   newGridObj.initData({
  //     m_stJoint: objGrid.m_stJoint,
  //     m_edJoint: isExist,
  //     m_Axis: axisObj,
  //   });
  //   await addEntityToDrawing(newGridObj, false);

  //   // if (originLength > gridLength)
  //   await objGrid.erase();
  //   return newGridObj;
  // }
};

//更新网格长度
export const updataGridLength = async (objCurrGird) => {
  if (!objCurrGird) return;
  const pt1 = new THREE.Vector3(
    objCurrGird.m_stJoint.m_pt[0],
    objCurrGird.m_stJoint.m_pt[1],
    objCurrGird.m_stJoint.m_pt[2]
  );
  const pt2 = new THREE.Vector3(
    objCurrGird.m_edJoint.m_pt[0],
    objCurrGird.m_edJoint.m_pt[1],
    objCurrGird.m_edJoint.m_pt[2]
  );

  const insertPtArray = new Array();
  // const rlGroup = store.state.rlEntData.totalEntityData["rlGrid"]; // rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll(); //获取当前图纸中的网格数据
  const rlGroup = [...store.state.rlEntData.totalEntityData["rlGrid"]];
  if (rlGroup) {
    // 从 rlGroup 中删除需要删除的网格
    // rlGroup = rlGroup.filter((grid) => !removeGrids.includes(grid));
    for (let i = 0; i < rlGroup.length; i++) {
      const objTmp = rlGroup[i];
      if (objTmp) {
        const pt1Tmp = new THREE.Vector3(
          objTmp.m_stJoint.m_pt[0],
          objTmp.m_stJoint.m_pt[1],
          objTmp.m_stJoint.m_pt[2]
        );
        const pt2Tmp = new THREE.Vector3(
          objTmp.m_edJoint.m_pt[0],
          objTmp.m_edJoint.m_pt[1],
          objTmp.m_edJoint.m_pt[2]
        );

        if (
          objCurrGird.m_centerJoint ||
          (objCurrGird.m_Axis && objCurrGird.m_Axis.IsMainAxis < 0) ||
          objTmp.m_centerJoint ||
          (objTmp.m_Axis && objTmp.m_Axis.IsMainAxis < 0)
        ) {
          // 圆弧轴线与圆弧轴线相交
          if (
            (objCurrGird.m_centerJoint ||
              (objCurrGird.m_Axis && objCurrGird.m_Axis.IsMainAxis < 0)) &&
            (objTmp.m_centerJoint ||
              (objTmp.m_Axis && objTmp.m_Axis.IsMainAxis < 0))
          ) {
            const center1 = objCurrGird.m_centerJoint
              ? new THREE.Vector3(...objCurrGird.m_centerJoint.m_pt)
              : new THREE.Vector3(...objCurrGird.m_Axis.m_stJoint.m_pt);

            const redius1 = pt1.distanceTo(center1);
            const startAngle1 = toDegrees(calculateArcAngle(center1, pt1));
            const endAngle1 = toDegrees(calculateArcAngle(center1, pt2));

            const center2 = objTmp.m_centerJoint
              ? new THREE.Vector3(...objTmp.m_centerJoint.m_pt)
              : new THREE.Vector3(...objTmp.m_Axis.m_stJoint.m_pt);
            const redius2 = pt1Tmp.distanceTo(center2);
            const startAngle2 = toDegrees(calculateArcAngle(center2, pt1Tmp));
            const endAngle2 = toDegrees(calculateArcAngle(center2, pt2Tmp));

            const insertRes = arcArcIntersection(
              center1,
              redius1,
              startAngle1,
              endAngle1,
              center2,
              redius2,
              startAngle2,
              endAngle2
            );

            if (insertRes.isIntersected) {
              const insertArcArray = [];
              for (let i = 0; i < insertRes.intersectionPoints.length; i++) {
                // 添加一个节点
                const rlPointObj = new rlJointData();
                rlPointObj.initData({
                  m_pt: [
                    insertRes.intersectionPoints[i]["x"],
                    insertRes.intersectionPoints[i]["y"],
                    insertRes.intersectionPoints[i]["z"],
                  ],
                });
                const isExist = await addPointEntityToDrawing(
                  rlPointObj,
                  false,
                  true,
                  true
                );
                // await jointCutGrid(rlPointObj, objTmp);
                if (!isExist) {
                  insertArcArray.push(rlPointObj);
                }

                if (
                  !isExist &&
                  rlPointObj &&
                  !insertPtArray.includes(rlPointObj)
                ) {
                  insertPtArray.push(rlPointObj);
                }
              }

              await jointArrayCutGrid(insertArcArray, objTmp);
            }
          }
          // 直线轴线与圆弧轴线相交
          else if (
            objCurrGird.m_centerJoint ||
            objCurrGird.m_Axis.IsMainAxis < 0
          ) {
            const center1 = objCurrGird.m_centerJoint
              ? new THREE.Vector3(...objCurrGird.m_centerJoint.m_pt)
              : new THREE.Vector3(...objCurrGird.m_Axis.m_stJoint.m_pt);

            const redius1 = pt1.distanceTo(center1);
            const startAngle1 = toDegrees(calculateArcAngle(center1, pt1));
            const endAngle1 = toDegrees(calculateArcAngle(center1, pt2));

            const insertRes = lineArcIntersection(
              pt1Tmp,
              pt2Tmp,
              center1,
              redius1,
              startAngle1,
              endAngle1
            );

            if (insertRes.isIntersected) {
              const insertArcArray = [];
              for (let j = 0; j < insertRes.intersectionPoints.length; j++) {
                // 添加一个节点
                const rlPointObj = new rlJointData();
                rlPointObj.initData({
                  m_pt: [
                    insertRes.intersectionPoints[j]["x"],
                    insertRes.intersectionPoints[j]["y"],
                    insertRes.intersectionPoints[j]["z"],
                  ],
                });
                const isExist = await addPointEntityToDrawing(
                  rlPointObj,
                  false,
                  true,
                  true
                );
                // await jointCutGrid(rlPointObj, objTmp);
                if (!isExist) {
                  insertArcArray.push(rlPointObj);
                }
                if (
                  !isExist &&
                  rlPointObj &&
                  !insertPtArray.includes(rlPointObj)
                ) {
                  insertPtArray.push(rlPointObj);
                }
              }

              await jointArrayCutGrid(insertArcArray, objTmp);
            }
          }
          // 直线轴线与圆弧轴线相交
          else if (objTmp.m_centerJoint || objTmp.m_Axis.IsMainAxis < 0) {
            const center1 = objTmp.m_centerJoint
              ? new THREE.Vector3(...objTmp.m_centerJoint.m_pt)
              : new THREE.Vector3(...objTmp.m_Axis.m_stJoint.m_pt);

            const redius1 = pt1Tmp.distanceTo(center1);
            const startAngle1 = toDegrees(calculateArcAngle(center1, pt1Tmp));
            const endAngle1 = toDegrees(calculateArcAngle(center1, pt2Tmp));

            const insertRes = lineArcIntersection(
              pt1,
              pt2,
              center1,
              redius1,
              startAngle1,
              endAngle1
            );
            if (insertRes.isIntersected) {
              const insertArcArray = [];
              for (let j = 0; j < insertRes.intersectionPoints.length; j++) {
                // 添加一个节点
                const rlPointObj = new rlJointData();
                rlPointObj.initData({
                  m_pt: [
                    insertRes.intersectionPoints[j]["x"],
                    insertRes.intersectionPoints[j]["y"],
                    insertRes.intersectionPoints[j]["z"],
                  ],
                });

                const isExist = await addPointEntityToDrawing(
                  rlPointObj,
                  false,
                  true,
                  true
                );
                // await jointCutGrid(rlPointObj, objTmp);
                if (!isExist) {
                  insertArcArray.push(rlPointObj);
                }
                if (
                  !isExist &&
                  rlPointObj &&
                  !insertPtArray.includes(rlPointObj)
                ) {
                  insertPtArray.push(rlPointObj);
                }
              }

              await jointArrayCutGrid(insertArcArray, objTmp);
            }
          }

          continue;
        }

        const insertRes = lineInsection(pt1, pt2, pt1Tmp, pt2Tmp);
        if (insertRes.isIntersected && insertRes.intersectionPoint) {
          // 添加一个节点
          const rlPointObj = new rlJointData();
          rlPointObj.initData({
            m_pt: [
              insertRes.intersectionPoint["x"],
              insertRes.intersectionPoint["y"],
              insertRes.intersectionPoint["z"],
            ],
          });
          const isExist = await addPointEntityToDrawing(
            rlPointObj,
            false,
            true,
            true
          );
          if (!isExist) await jointCutGrid(rlPointObj, objTmp);

          if (!isExist && rlPointObj && !insertPtArray.includes(rlPointObj)) {
            insertPtArray.push(rlPointObj);
          }
          // removeGrids.push(objTmp); // 将需要删除的网格添加到 removeGrids 数组中
        }
      }
    }
  }

  // 查找网格上的节点
  const rlJointGroup = store.state.rlEntData.totalEntityData["rlJoint"];
  if (rlJointGroup) {
    rlJointGroup.forEach((joint) => {
      if (
        objCurrGird.m_centerJoint ||
        (objCurrGird.m_Axis && objCurrGird.m_Axis.IsMainAxis < 0)
      ) {
        const center1 = objCurrGird.m_centerJoint
          ? new THREE.Vector3(...objCurrGird.m_centerJoint.m_pt)
          : new THREE.Vector3(...objCurrGird.m_Axis.m_stJoint.m_pt);
        const redius1 = pt1.distanceTo(center1);
        const res = ptOnArc(
          center1,
          redius1,
          pt1,
          pt2,
          new THREE.Vector3(...joint.m_pt)
        );
        // 在圆弧上
        if (res > 0 && !insertPtArray.includes(joint)) {
          insertPtArray.push(joint);
        }
      } else {
        const res = ptOnLine(pt1, pt2, new THREE.Vector3(...joint.m_pt));
        if (res === 1 && !insertPtArray.includes(joint)) {
          insertPtArray.push(joint);
        }
      }
    });
  }

  if (insertPtArray && insertPtArray.length) {
    jointArrayCutGrid(insertPtArray, objCurrGird);
    return true; // 该段网格被切分了
  }
};

// 更新轴线长度
export const updataAxisLength = async (axisObj, addPoint) => {
  const ptArray = new Array();
  ptArray.push(addPoint);
  // 比较两个向量是否相等的函数
  function vectorEquals(v1, v2) {
    return v1.x === v2.x && v1.y === v2.y && v1.z === v2.z;
  }

  // 检查向量是否已存在于数组中的函数
  function vectorExists(array, vector) {
    return array.some((v) => vectorEquals(v, vector));
  }
  // 获取轴线上所有节点，对节点排序，取端部两点作为轴线的端点
  axisObj.m_gridIds.forEach((grid) => {
    const gridObj = getEntityData({ Guid: grid, classTypeName: "rlGrid" });
    if (gridObj) {
      if (gridObj.m_stJoint) {
        const pt = new THREE.Vector3(...gridObj.m_stJoint.m_pt);
        if (!vectorExists(ptArray, pt)) {
          ptArray.push(pt);
        }
      }
      if (gridObj.m_edJoint) {
        const pt = new THREE.Vector3(...gridObj.m_edJoint.m_pt);
        if (!vectorExists(ptArray, pt)) {
          ptArray.push(pt);
        }
      }
    }
  });
  // 如果轴线上的节点数大于2，则对节点进行排序
  if (ptArray.length > 2) {
    const pt0 = ptArray[0];
    const pt1 = ptArray[1];
    const direction = new THREE.Vector3().subVectors(pt1, pt0).normalize();

    // 投影每个点到直线上并计算投影点的标量值
    ptArray.forEach((pt) => {
      pt.projection = new THREE.Vector3().subVectors(pt, pt0).dot(direction);
    });

    // 根据投影点的标量值对点进行排序
    ptArray.sort((a, b) => a.projection - b.projection);
  }
  if (ptArray.length >= 2) {
    const stJointTmp = JointIsExist([ptArray[0].x, ptArray[0].y, ptArray[0].z]);
    const edJointTmp = JointIsExist([
      ptArray[ptArray.length - 1].x,
      ptArray[ptArray.length - 1].y,
      0,
    ]);
    if (stJointTmp && edJointTmp) {
      axisObj.saveEditRevokeData();
      axisObj.m_stJoint = stJointTmp;
      axisObj.m_edJoint = edJointTmp;
      axisObj.updateThisObj(axisObj);

      // axisObj.updateAxisDrawData();
      return true; // 轴线合并成功
    }
  }
  return false; // 轴线合并失败
};

// 通过鼠标选择多个对象

let mxSelect = null;
let clickHandlerRef = null;
let touchTimerRef = null; // 触摸事件计时器
let touchStartHandlerRef = null; // 触摸事件处理器引用
let touchEndHandlerRef = null; // 触摸结束事件处理器引用
let filterIds = [];
// 处理选中的对象ID
const processIds = async (isDele, callback) => {
  const ids = mxSelect.getIds().reduce((acc, obj) => {
    // 检查新数组中是否已经存在相同 id 的对象
    const existingObj = filterIds.find((item) => item.id == obj.id);
    if (!existingObj) {
      // 如果不存在相同 id 的对象，则将当前对象推送到新数组中
      acc.push(obj);
      filterIds.push(obj); // 将当前对象推送到 filterIds 数组中
    }
    return acc;
  }, []);
  if (ids && ids.length > 0) {
    ids.forEach((e) => {
      const mcObj = e.getMcDbEntity(); // 获取数据库实体
      const selObj =
        mcObj &&
        get_entity_by_id(Number(mcObj.getxDataString("mcObjectId").val)); // 获取选中的对象
      if (selObj && selObj.classTypeName === "rlGrid") {
        selObj.dLineWidth = isDele ? 0 : 5; // 根据是否删除设置线宽
        selObj.setNeedUpdateDisplay(true); // 设置需要更新显示
      }
    });
  }

  if (callback) {
    await callback(ids, isDele);
  }
};

// 点击处理函数
const clickHandler = (isDele, callback) => {
  return () => {
    processIds(isDele, callback); // 处理选中的对象ID
  };
};

// 初始化选择
export const initSelect = (bol, callback) => {
  clickHandlerRef = clickHandler(false, callback); // 设置点击处理函数
  document.addEventListener("click", clickHandlerRef); // 添加点击事件监听器
};

// 移除选择
export const removeSelect = () => {
  processIds(true); // 处理选中的对象ID
  filterIds = [];
  if (clickHandlerRef) {
    document.removeEventListener("click", clickHandlerRef); // 移除点击事件监听器
  }
  // 移除触摸事件监听器
  if (touchStartHandlerRef) {
    const canvasElement = document.getElementById("container");
    if (canvasElement) {
      canvasElement.removeEventListener("touchstart", touchStartHandlerRef);
    }
    touchStartHandlerRef = null;
  }
  // 移除触摸结束事件监听器
  if (touchEndHandlerRef) {
    const canvasElement = document.getElementById("container");
    if (canvasElement) {
      canvasElement.removeEventListener("touchend", touchEndHandlerRef);
    }
    touchEndHandlerRef = null;
  }
  // 清除触摸计时器
  if (touchTimerRef) {
    clearTimeout(touchTimerRef);
    touchTimerRef = null;
  }
};

// 通过鼠标选择多个对象
export const userSelect = (
  setColumnMethod, // set_column 方法
  callback = null, // 回调函数
  str = "请框选要操作的对象",
  isCallback = true // 是否循环调用
) => {
  if (!store.state.inspectionStore.isInCommand) {
    console.log("不在命令中，结束框选");
    return;
  }
  if (str && str != "") resetMessage.info(str);

  if (clickHandlerRef) {
    removeSelect(); // 移除已有的事件监听器
  }
  mxSelect = null;
  const findFilter = new MxCADResbuf();
  findFilter.AddMcDbEntityTypes(
    "TEXT,MTEXT,CIRCLE,ARC,POINT,LWPOLYLINE,INSERT,ELLIPSE,SPLINE"
  );

  // PC端使用鼠标选择
  return new Promise((resolve, reject) => {
    // 通过鼠标选择多个对象
    mxSelect = new MxCADSelectionSet();
    mxSelect.isSelectHighlight = true;
    mxSelect.isWhileSelect = false;

    // 创建控制变量，用于确定是否应该取消选择操作
    let shouldCancelSelection = false;
    // 创建一个标志，跟踪touchend是否已经安排了新的选择操作
    let hasScheduledNewSelection = false;

    // 添加触摸事件监听
    const canvasElement = document.getElementById("container");
    if (canvasElement) {
      // 处理触摸开始事件
      const touchStartHandler = (event) => {
        // 如果是多指触摸（双指），立即设置标志并返回空数组
        if (event.touches.length > 1) {
          // 清除可能存在的单指触摸定时器
          if (touchTimerRef) {
            clearTimeout(touchTimerRef);
            touchTimerRef = null;
          }

          // 标记应该取消选择操作
          shouldCancelSelection = true;

          // 结束所有命令
          if (rlAppObj._rlMx.MxFun.stopRunCommand) {
            rlAppObj._rlMx.MxFun.stopRunCommand();
          }

          // 使用空数组解析Promise以结束当前选择
          resolve([]);

          // 不在这里安排新的选择，而是在touchend中处理
          return;
        }

        // 清除之前的定时器
        if (touchTimerRef) {
          clearTimeout(touchTimerRef);
        }

        // 捕获事件的引用，以便在回调中正确访问
        const touchEvent = event;

        // 设置200ms延迟判断
        touchTimerRef = setTimeout(() => {
          // 单指触摸处理，继续正常选择流程
          if (touchEvent.touches.length === 1) {
            // 继续常规的选择处理
            // 这里不再调用mxSelect.userSelect，而是通过控制变量来控制外部的选择流程
          }
          touchTimerRef = null;
        }, 200); // 延迟200ms
      };

      // 处理触摸结束事件
      const touchEndHandler = () => {
        // 只有在取消选择且尚未安排新选择时执行
        if (shouldCancelSelection && !hasScheduledNewSelection && isCallback) {
          // 标记已安排新选择，防止重复调用
          hasScheduledNewSelection = true;

          // 延迟执行以确保所有事件处理完成
          setTimeout(() => {
            // 移除当前的监听器和选择
            removeSelect();
            // 重新开始新的选择流程
            userSelect(setColumnMethod, callback, str, isCallback).catch(
              reject
            );
          }, 300);
        }
      };

      // 保存事件处理器引用以便后续移除
      touchStartHandlerRef = touchStartHandler;
      canvasElement.addEventListener("touchstart", touchStartHandler);

      // 添加触摸结束事件监听器并保存引用
      touchEndHandlerRef = touchEndHandler;
      canvasElement.addEventListener("touchend", touchEndHandler);
    }

    // 原有的事件处理
    clickHandlerRef = clickHandler(false, callback); // 设置点击处理函数
    document.addEventListener("click", clickHandlerRef); // 添加点击事件监听器

    // 将mxSelect.userSelect调用移到外面，避免在touchstart事件中调用
    mxSelect
      .userSelect(str, findFilter, initSelect(false, callback))
      .then(async (is) => {
        // 如果在多指触摸中标记了应该取消选择，则不执行后续处理
        if (shouldCancelSelection) {
          return;
        }

        const ids = mxSelect.getIds();
        removeSelect();
        // messageObj.close();
        rlAppObj.rlMxDrawObject.clearMxCurrentSelect();
        if (is) {
          // PC模式下直接执行
          await setColumnMethod(ids);

          resolve(ids);
          if (isCallback) {
            // 再次调用 userSelect 连续执行
            userSelect(setColumnMethod, callback, str, isCallback).catch(
              reject
            );
          }
        }
      });
  });
};

// 选取实体
export const select_entiy_get = (isGetData = true, findFilter = null) => {
  // const selEntityTouchHandler = (event) => {
  //   // 如果是多指触摸，立即设置标志并返回，不阻止默认行为
  //   if (event.touches.length > 1) {
  //     // isSingleTouch = false;

  //     // 清除可能存在的单指触摸定时器
  //     if (touchTimer) {
  //       clearTimeout(touchTimer);
  //       touchTimer = null;
  //     }
  //     // 结束所有命令
  //     rlAppObj._rlMx.MxFun.stopRunCommand();
  //     return true;
  //   }

  //   // 清除之前的定时器并设置新定时器
  //   if (touchTimer) {
  //     clearTimeout(touchTimer);
  //   }

  //   // 捕获事件的引用，以便在回调中正确访问
  //   const touchEvent = event;
  //   touchTimer = setTimeout(() => {
  //     // 只有当没有多触点时，才认为是单触点
  //     if (touchEvent.touches.length === 1) {
  //       // isSingleTouch = true;
  //       //todo 获取选中的实体
  //       console.log("touchEvent", touchEvent);
  //       // 移除触摸事件监听器
  //     }
  //     touchTimer = null;
  //   }, 50); // 缩短延迟时间
  // };

  // const selEntityTouchEndHandler = (event) => {
  //   //todo 获取选中的实体
  //   // 移除触摸事件监听器

  //   // 移除触摸事件监听器
  // };

  try {
    return new Promise(async (resolve, reject) => {
      let ids = await rlAppObj.rlMxCpp.MxCADUtility.selectEnt(
        "提示信息",
        findFilter
      );

      if (!ids || ids.length == 0) {
        reject(null);
        return;
      }

      ids = ids[0];
      const finObj = ids.getMcDbEntity();
      finObj.getxDataString("Guid").val;
      let objGrid = null;
      if (isGetData) {
        // 获取对象自定义属性
        const findGuid = finObj.getxDataString("Guid").val;
        const findName = finObj.getxDataString("classTypeName").val;
        // 获取对象自定义属性
        objGrid = getEntityData({
          classTypeName: findName,
          Guid: findGuid,
        });
      }
      resolve(isGetData ? objGrid : finObj);
    });
  } catch (error) {
    console.log("select_entiy_get error", error);
  }
};

// 更新图层颜色
export const updateModelColor = async () => {
  try {
    // 获取构件的图层颜色
    const rlLayer = await getRlLayer();

    let beamColor = rlLayer.filter((item) => item.Type == "rlBeamSeg");
    let wallColor = rlLayer.filter((item) => item.Type == "rlWallSeg");
    let colColor = rlLayer.filter((item) => item.Type == "rlColSeg");
    let slabColor = rlLayer.filter((item) => item.Type == "rlSlabSeg");
    let ringBeamColor = rlLayer.filter((item) => item.Type == "rlRingBeamSeg");
    let subBeamColor = rlLayer.filter((item) => item.Type == "rlSubBeam");

    if (beamColor && wallColor && colColor && slabColor) {
      beamColor = beamColor[0].Color;
      wallColor = wallColor[0].Color;
      colColor = colColor[0].Color;
      slabColor = slabColor[0].Color;
      ringBeamColor = ringBeamColor[0].Color;
      subBeamColor = subBeamColor[0].Color;
      // 获取所有模型对象
      const allMxEntity = store.state.rlEntData.totalEntityData; // rlAppObj.rlMxDrawObject.getAllMxEntity();
      if (!allMxEntity) {
        return;
      }

      const rlWallGroup = allMxEntity["rlWallSeg"];
      const rlbeamGroup = allMxEntity["rlBeamSeg"];
      const rlColGroup = allMxEntity["rlColSeg"];
      const rlSlabGroup = allMxEntity["rlSlab"];
      const rlRingBeamGroup = allMxEntity["rlRingBeamSeg"];
      const rlSubBeamGroup = allMxEntity["rlSubBeam"];

      // 绘制步数
      // store.commit("globalData/addRawStep");

      if (rlWallGroup) {
        rlWallGroup.forEach(async (item) => {
          if (item.Color != wallColor) {
            item.Color = wallColor;
            changeEntityColorById(item.mcDbId, wallColor);
          }
        });
      }
      if (rlbeamGroup) {
        rlbeamGroup.forEach(async (item) => {
          if (item.m_sectParamData.IsRingBeamSeg) {
            if (item.Color != ringBeamColor) {
              item.Color = ringBeamColor;
              changeEntityColorById(item.mcDbId, ringBeamColor);
            }
          } else if (item.Attribute != 1) {
            if (item.Color != subBeamColor) {
              item.Color = subBeamColor;
              changeEntityColorById(item.mcDbId, subBeamColor);
            }
          } else {
            if (item.Color != beamColor) {
              item.Color = beamColor;
              changeEntityColorById(item.mcDbId, beamColor);
            }
          }
        });
      }

      if (rlColGroup) {
        rlColGroup.forEach(async (item) => {
          if (item.Color != colColor) {
            item.Color = colColor;
            changeEntityColorById(item.mcDbId, colColor);
          }
        });
      }

      if (rlSlabGroup) {
        rlSlabGroup.forEach(async (item) => {
          if (item.Color != slabColor) {
            item.Color = slabColor;
            changeEntityColorById(item.mcDbId, slabColor);
          }
        });
      }

      if (rlRingBeamGroup) {
        rlRingBeamGroup.forEach(async (item) => {
          if (item.Color != ringBeamColor) {
            item.Color = ringBeamColor;
            changeEntityColorById(item.mcDbId, ringBeamColor);
          }
        });
      }

      if (rlSubBeamGroup) {
        rlSubBeamGroup.forEach(async (item) => {
          if (item.Color != subBeamColor) {
            item.Color = subBeamColor;
            changeEntityColorById(item.mcDbId, subBeamColor);
          }
        });
      }
    }
  } catch (error) {}
};

// 对轴线归类排序
export const sortAxisData = (rlAxisroup) => {
  // 找到平行线--分组:key==斜率，value==轴线数组
  const slopeGroup = {};
  for (let axis of rlAxisroup) {
    if (axis.IsMainAxis < 0) continue;

    const pt1 = axis.m_stJoint.m_pt;
    const pt2 = axis.m_edJoint.m_pt;
    // 剔除无效轴线
    if (Math.abs(pt1[0] - pt2[0]) < 1 && Math.abs(pt1[1] - pt2[1]) < 1) {
      axis.erase();
      return;
    }
    let slope =
      Math.abs(pt1[0] - pt2[0]) < 0.1
        ? 9999
        : (pt1[1] - pt2[1]) / (pt1[0] - pt2[0]);
    // if (slope < 0) slope = -slope;
    if (slope == -0.0) slope = 0.0; // 将0和-0统一
    slope = slope.toFixed(2);
    if (slope == -0.0) slope = 0.0;
    if (slopeGroup[slope]) {
      slopeGroup[slope].push(axis);
    } else {
      const arrayTmp = [];
      arrayTmp.push(axis);
      slopeGroup[slope] = arrayTmp;
    }
  }

  const resAxisData = {};
  // 按照分组对轴线排序
  Object.keys(slopeGroup).forEach(async (key) => {
    const value = slopeGroup[key];
    if (value && value.length > 0) {
      // 对轴线排序
      const sortAxisData = [];
      // 以第一条为基准，记录其他轴线到此轴线的间距（有方向）
      const lineOrigin = new THREE.Line3(
        new THREE.Vector3(...value[0].m_stJoint.m_pt),
        new THREE.Vector3(...value[0].m_edJoint.m_pt)
      );
      value.forEach(async (itemTmp) => {
        const ptTmp = new THREE.Vector3(...itemTmp.m_stJoint.m_pt);
        let InsectPt = null;

        InsectPt = lineOrigin.closestPointToPoint(ptTmp);
        if (InsectPt) {
          let distance = ptTmp.distanceTo(InsectPt);
          const perLine = new THREE.Line3(InsectPt, ptTmp);
          const vecDir = new THREE.Vector3();
          perLine.delta(vecDir);
          // 处理精度问题
          vecDir.x = vecDir.x.toFixed(1);
          vecDir.y = vecDir.y.toFixed(1);
          if (vecDir.x < 0) {
            distance = -distance;
          } else if (vecDir.y < 0) {
            distance = -distance;
          }

          // 将 distance 和 itemTmp 添加到数组中
          sortAxisData.push({ distance, item: itemTmp });
        }
      });

      // 按照 distance 数值大小排序
      sortAxisData.sort((a, b) => a.distance - b.distance);

      // 将排序后的数据存入 resAxisData
      resAxisData[key] = sortAxisData;
    }
  });

  return resAxisData;
};

// 计算两条轴线的间距
export const getDistanceBetweenTwoAxis = (objAxis1, objAxis2) => {
  // 判断两条轴线是否平行，若不平行，返回-1
  const slope1 =
    Math.abs(objAxis1.m_stJoint.m_pt[0] - objAxis1.m_edJoint.m_pt[0]) < 0.1
      ? 9999
      : (objAxis1.m_stJoint.m_pt[1] - objAxis1.m_edJoint.m_pt[1]) /
        (objAxis1.m_stJoint.m_pt[0] - objAxis1.m_edJoint.m_pt[0]);

  const slope2 =
    Math.abs(objAxis2.m_stJoint.m_pt[0] - objAxis2.m_edJoint.m_pt[0]) < 0.1
      ? 9999
      : (objAxis2.m_stJoint.m_pt[1] - objAxis2.m_edJoint.m_pt[1]) /
        (objAxis2.m_stJoint.m_pt[0] - objAxis2.m_edJoint.m_pt[0]);

  if (slope1 !== slope2) return -1;
  else {
    const lineOrigin = new THREE.Line3(
      new THREE.Vector3(...objAxis1.m_stJoint.m_pt),
      new THREE.Vector3(...objAxis1.m_edJoint.m_pt)
    );
    const ptTmp = new THREE.Vector3(...objAxis2.m_edJoint.m_pt);
    let InsectPt = null;
    InsectPt = lineOrigin.closestPointToPoint(ptTmp);
    if (InsectPt) {
      return ptTmp.distanceTo(InsectPt);
    }
  }
};

// 通过Guid获取构件数据
export const getEntityData = (obj) => {
  if (!store.state.rlEntData.totalEntityData[obj.classTypeName]) return null;
  return store.state.rlEntData.totalEntityData[obj.classTypeName].find(
    (item) => {
      const itemGuidUp =
        typeof item.Guid === "string" ? item.Guid.toUpperCase() : item.Guid;
      const ObjGuidUp =
        typeof obj.Guid === "string" ? obj.Guid.toUpperCase() : obj.Guid;
      return itemGuidUp == ObjGuidUp;
    }
  );
};

// 获取图上所有的实体
export const getAllEntityData = (isData = false, is3d = false) => {
  if (!window.rlAppObj || !rlAppObj.mxcadObject) {
    return [];
  }
  const mxAll = new MxCADSelectionSet();
  mxAll.allSelect();
  const allEntity = [];
  const allEntityData = [];
  mxAll.forEach((id) => {
    const ent = id.getMcDbEntity();
    if (!ent) return;
    allEntity.push(ent);

    // 是否获取更详细的数据
    if (isData) {
      const findGuid = ent.getxDataString("Guid").val;
      const findName = ent.getxDataString("classTypeName").val;
      const allData = getEntityData({
        classTypeName: findName,
        Guid: findGuid,
      });
      if (allData && (!is3d || (is3d && allData.componentType))) {
        allEntityData.push(allData);
      }
    }
  });
  if (isData) return allEntityData;
  return allEntity;
};

// 清空所有高亮
export const clearAllHighLight = () => {
  // 清除缓存，确保获取最新数据
  entityCache.clear();
  store.commit("inspectionStore/setpartShow", false);
  store.commit("inspectionStore/setRotateShow", false);
  if (!window.rlAppObj) {
    return [];
  }
  // 使用批量处理减少重绘次数
  const entitiesToErase = [];
  getAllEntityData()?.forEach((item) => {
    if (item.objectName === "McDbPolyline" || item.objectName === "McDbArc") {
      try {
        // 优先使用实体引用直接清理
        if (item.highlightEntities && Array.isArray(item.highlightEntities)) {
          for (const entityId of item.highlightEntities) {
            try {
              const entity = entityId.getMcDbEntity();
              if (entity) {
                entitiesToErase.push(entity);
              }
            } catch (error) {
              // 忽略错误
            }
          }
          // 清空引用
          item.highlightEntities = [];
        } else if (item.lineweight == -999) {
          // 兼容旧方式
          entitiesToErase.push(item);
        }
      } catch (error) {
        console.log("清除高亮失败:", error);
      }
    }
  });

  // 批量清除
  if (entitiesToErase.length > 0) {
    try {
      // 一次性删除所有高亮实体
      entitiesToErase.forEach((entity) => entity.erase());
    } catch (error) {
      console.log("批量清除高亮失败:", error);
    }
  }

  // 更新画布显示
  rlAppObj.mxcadObject?.updateDisplay();
  // setTimeout(() => {
  //   getAllEntityData().forEach((item) => {
  //     if (item.objectName === "McDbPolyline" || item.objectName === "McDbArc") {
  //       try {
  //         // 优先使用实体引用直接清理
  //         if (item.highlightEntities && Array.isArray(item.highlightEntities)) {
  //           for (const entityId of item.highlightEntities) {
  //             try {
  //               const entity = entityId.getMcDbEntity();
  //               if (entity) {
  //                 entitiesToErase.push(entity);
  //               }
  //             } catch (error) {
  //               // 忽略错误
  //             }
  //           }
  //           // 清空引用
  //           item.highlightEntities = [];
  //         } else if (item.lineweight == -999) {
  //           // 兼容旧方式
  //           entitiesToErase.push(item);
  //         }
  //       } catch (error) {
  //         console.log("清除高亮失败:", error);
  //       }
  //     }
  //   });

  //   // 批量清除
  //   if (entitiesToErase.length > 0) {
  //     try {
  //       // 一次性删除所有高亮实体
  //       entitiesToErase.forEach((entity) => entity.erase());
  //     } catch (error) {
  //       console.log("批量清除高亮失败:", error);
  //     }
  //   }

  //   // 更新画布显示
  //   rlAppObj.mxcadObject.updateDisplay();
  // }, 1000);
};

// 通过id修改构件颜色
export const changeEntityColorById = (id, color) => {
  const finObj = id.getMcDbEntity();
  if (finObj) {
    finObj.trueColor = new McCmColor(color.r, color.g, color.b);
    const obbj = getEntityById(id);
    if (obbj && obbj._threeObj) {
      // 更改three.js几何体颜色
      obbj._threeObj.material.color = new THREE.Color(
        color.r / 255,
        color.g / 255,
        color.b / 255
      );

      // 更改几何体透明度
      obbj._threeObj.material.transparent = color.a != 1;
      obbj._threeObj.material.opacity = color.a;
    }

    // 更新画布
    rlAppObj.rlMxDrawObject.updateDisplay();
  }
};

// 通过id获取完整对象/是否需要高亮
export const getEntityById = (id, isHighlight = false) => {
  // 只有在需要高亮时才清除之前的高亮
  if (isHighlight) {
    clearAllHighLight();
  }

  const finObj = id.getMcDbEntity();
  if (!finObj) return null;

  // 获取Guid和classTypeName
  const findGuid = finObj.getxDataString("Guid").val;
  const findName = finObj.getxDataString("classTypeName").val;

  // 生成缓存键
  const cacheKey = `${findName}:${findGuid}`;

  // 如果不需要高亮，且缓存中有数据，则直接返回缓存结果
  if (!isHighlight) {
    const cachedEntity = entityCache.get(cacheKey);
    if (cachedEntity) {
      return cachedEntity;
    }
  }

  // 获取对象自定义属性
  // 优化：避免重复访问store.state
  const classTypeCollection = store.state.rlEntData.totalEntityData[findName];

  // 对象不存在或集合为空时直接返回null
  if (!classTypeCollection || classTypeCollection.length === 0) {
    return null;
  }

  // 获取对象自定义属性
  const objGrid = classTypeCollection.find((item) => item.Guid === findGuid);

  // 存入缓存
  if (objGrid) {
    entityCache.set(cacheKey, objGrid);
  }

  if (isHighlight && objGrid) {
    try {
      // 保存当前drawOrder值
      const originalDrawOrder = finObj.drawOrder;

      if (
        finObj.objectName === "McDbPolyline" ||
        finObj.objectName === "McDbArc"
      ) {
        console.log("finObj", finObj);
        // 只有真正需要高亮时才创建高亮效果，减少不必要的操作
        createHighlightEffect(finObj);
      }

      // 还原drawOrder值
      if (
        originalDrawOrder !== undefined &&
        finObj.drawOrder !== originalDrawOrder
      ) {
        finObj.drawOrder = originalDrawOrder;
      }
    } catch (error) {
      console.log("创建高亮效果失败:", error);
    }

    // 确保刷新显示
    rlAppObj.mxcadObject.updateDisplay();
  }

  return objGrid;
};
export const highlightEntityArray = (entityArray, clearAll = true) => {
  if (clearAll) {
    clearEntityArrayHighlight();
  }
  MxCpp.getCurrentMxCAD().showLineWeight(true);
  for (let i = 0; i < entityArray.length; i++) {
    const finObj = entityArray[i].mcDbId
      ? entityArray[i].mcDbId.getMcDbEntity()
      : entityArray[i].getMcDbEntity();
    if (
      finObj &&
      (finObj.objectName === "McDbPolyline" || finObj.objectName === "McDbArc")
    ) {
      finObj.lineweight = 100;
    }
  }
  rlAppObj.mxcadObject.updateDisplay();
};

// 清除一组构件的高亮效果
export const clearEntityArrayHighlight = () => {
  MxCpp.getCurrentMxCAD().showLineWeight(true);
  getAllEntityData().forEach((item) => {
    if (item) {
      item.lineweight = 2;
    }
  });
  rlAppObj.mxcadObject.updateDisplay();
};

//高亮一组构件
export const highlightEntityGroup = (entityGroup, clearAll = true) => {
  if (clearAll) {
    clearAllHighLight();
  }
  // 获取所有构件的guid
  if (entityGroup.length > 0) {
    for (let i = 0; i < entityGroup.length; i++) {
      const finObj = entityGroup[i].mcDbId
        ? entityGroup[i].mcDbId.getMcDbEntity()
        : entityGroup[i].getMcDbEntity();
      if (
        finObj &&
        (finObj.objectName === "McDbPolyline" ||
          finObj.objectName === "McDbArc")
      ) {
        createHighlightEffect(finObj);
      }
    }
    // 确保刷新显示
    rlAppObj.mxcadObject.updateDisplay();
  }
};

// 提取创建高亮效果的代码到单独的函数中
export const createHighlightEffect = (finObj) => {
  // 存储当前对象的高亮实体ID，用于管理和清理
  if (!finObj.highlightEntities) {
    finObj.highlightEntities = [];
  } else {
    // 如果已经存在高亮效果，先清除旧的
    for (const entityId of finObj.highlightEntities) {
      try {
        const entity = entityId.getMcDbEntity();
        if (entity) {
          entity.erase();
        }
      } catch (error) {
        console.log("清除旧高亮效果失败:", error);
      }
    }
    finObj.highlightEntities = [];
  }

  const offsets = Array.from({ length: 50 }, (_, i) => (i + 1) * 0.4).filter(
    (val) => val <= 20
  );

  // 创建一个批量操作以减少重绘次数
  const outerLines = [];
  const innerLines = [];

  // 获取最大渲染层
  let minmaxOrder =
    MxCpp.getCurrentDatabase().currentSpace.getMinMaxDrawOrder();
  // 把对象放到最上面
  let lOrder = minmaxOrder.maxDrawOrder + 100000;

  // 预先获取所有顶点数据，避免重复获取
  let points = [];

  if (finObj.objectName === "McDbPolyline") {
    // 处理多段线
    const vertCount = finObj.numVerts();
    for (let i = 0; i < vertCount; i++) {
      points.push(finObj.getPointAt(i).val);
    }
  } else if (finObj.objectName === "McDbArc") {
    // 处理圆弧
    const center = finObj.center;
    const radius = finObj.radius;
    const startAngle = finObj.startAngle;
    const endAngle = finObj.endAngle;

    const numPoints = 36; // 降低圆弧精度

    // 检查是否需要调整角度以确保圆弧方向正确
    let angleStart = startAngle;
    let angleEnd = endAngle;

    // 确保圆弧方向始终正确
    if (endAngle < startAngle) {
      // 如果终止角小于起始角，说明圆弧跨越了0度位置
      angleEnd = endAngle + 2 * Math.PI;
    }

    for (let i = 0; i <= numPoints; i++) {
      const angle = angleStart + ((angleEnd - angleStart) * i) / numPoints;
      const x = center.x + radius * Math.cos(angle);
      const y = center.y + radius * Math.sin(angle);
      points.push({ x, y, z: center.z });
    }
  } else {
    // 其他对象类型不支持高亮，直接返回
    console.log("不支持的对象类型:", finObj.objectName);
    return;
  }

  const offsetsToUse = offsets;

  for (const offset of offsetsToUse) {
    const outerLine = new McDbPolyline();
    const innerLine = new McDbPolyline();
    outerLine.lineweight = -999;
    innerLine.lineweight = -999;
    outerLine.drawOrder = lOrder;
    innerLine.drawOrder = lOrder;

    // 使用预先获取的点数据
    for (let i = 0; i < points.length; i++) {
      const ptVal = points[i];

      if (finObj.objectName === "McDbArc") {
        // 法线方向进行偏移，确保高亮效果宽度一致
        const center = finObj.center;
        // 计算当前点到圆心的向量
        const dx = ptVal.x - center.x;
        const dy = ptVal.y - center.y;
        // 标准化向量长度
        const length = Math.sqrt(dx * dx + dy * dy);
        const nx = dx / length;
        const ny = dy / length;
        // 沿法线方向添加偏移
        outerLine.addVertexAt(
          new McGePoint3d(ptVal.x + nx * offset, ptVal.y + ny * offset, ptVal.z)
        );
        innerLine.addVertexAt(
          new McGePoint3d(ptVal.x - nx * offset, ptVal.y - ny * offset, ptVal.z)
        );
      } else {
        // 多段线偏移方式
        outerLine.addVertexAt(
          new McGePoint3d(ptVal.x + offset, ptVal.y + offset, ptVal.z)
        );
        innerLine.addVertexAt(
          new McGePoint3d(ptVal.x - offset, ptVal.y - offset, ptVal.z)
        );
      }
    }

    // 设置颜色
    outerLine.trueColor = new McCmColor(255, 0, 255);
    innerLine.trueColor = new McCmColor(255, 0, 255);

    // 设置闭合性
    if (finObj.objectName === "McDbPolyline") {
      outerLine.isClosed = finObj.isClosed;
      innerLine.isClosed = finObj.isClosed;
    } else if (finObj.objectName === "McDbArc") {
      // 圆弧不闭合
      outerLine.isClosed = false;
      innerLine.isClosed = false;
    }

    outerLines.push(outerLine);
    innerLines.push(innerLine);
  }

  // 批量添加到画布，减少重绘次数
  const addedEntities = [];

  outerLines.forEach((line) => {
    const entityId = rlAppObj.mxcadObject.drawEntity(line);
    addedEntities.push(entityId);
  });

  innerLines.forEach((line) => {
    const entityId = rlAppObj.mxcadObject.drawEntity(line);
    addedEntities.push(entityId);
  });

  // 保存添加的实体引用，方便后续清理
  finObj.highlightEntities = addedEntities;
};

// 清除实体的高亮效果
export const clearEntityHighlight = (finObj) => {
  // 先检查是否有存储的高亮实体
  if (finObj.highlightEntities && Array.isArray(finObj.highlightEntities)) {
    for (const entityId of finObj.highlightEntities) {
      try {
        const entity = entityId.getMcDbEntity();
        if (entity) {
          entity.erase();
        }
      } catch (error) {
        console.log("清除高亮效果失败:", error);
      }
    }
    // 清空引用
    finObj.highlightEntities = [];
    return;
  }

  // 兼容旧的清理方式
  if (finObj.lineweight == -999) {
    finObj.erase();
  }
};
let crackHeightEntities = new Map();
//裂损多选多个构件并且高亮
export const createHighlightEffectSelectMore = (finId) => {
  const finObj = finId.getMcDbEntity();
  // 存储当前对象的高亮实体ID，用于管理和清理
  if (!crackHeightEntities.get(finId.id)) {
    crackHeightEntities.set(finId.id, []);
  }

  const offsets = Array.from({ length: 50 }, (_, i) => (i + 1) * 0.4).filter(
    (val) => val <= 20
  );

  // 创建一个批量操作以减少重绘次数
  const outerLines = [];
  const innerLines = [];

  // 获取最大渲染层
  let minmaxOrder =
    MxCpp.getCurrentDatabase().currentSpace.getMinMaxDrawOrder();
  // 把对象放到最上面
  let lOrder = minmaxOrder.maxDrawOrder + 100000;

  // 预先获取所有顶点数据，避免重复获取
  let points = [];

  if (finObj.objectName === "McDbPolyline") {
    // 处理多段线
    const vertCount = finObj.numVerts();
    for (let i = 0; i < vertCount; i++) {
      points.push(finObj.getPointAt(i).val);
    }
  } else if (finObj.objectName === "McDbArc") {
    // 处理圆弧
    const center = finObj.center;
    const radius = finObj.radius;
    const startAngle = finObj.startAngle;
    const endAngle = finObj.endAngle;

    const numPoints = 36; // 降低圆弧精度

    // 检查是否需要调整角度以确保圆弧方向正确
    let angleStart = startAngle;
    let angleEnd = endAngle;

    // 确保圆弧方向始终正确
    if (endAngle < startAngle) {
      // 如果终止角小于起始角，说明圆弧跨越了0度位置
      angleEnd = endAngle + 2 * Math.PI;
    }

    for (let i = 0; i <= numPoints; i++) {
      const angle = angleStart + ((angleEnd - angleStart) * i) / numPoints;
      const x = center.x + radius * Math.cos(angle);
      const y = center.y + radius * Math.sin(angle);
      points.push({ x, y, z: center.z });
    }
  } else {
    // 其他对象类型不支持高亮，直接返回
    console.log("不支持的对象类型:", finObj.objectName);
    return;
  }

  const offsetsToUse = offsets;

  for (const offset of offsetsToUse) {
    const outerLine = new McDbPolyline();
    const innerLine = new McDbPolyline();
    outerLine.lineweight = -999;
    innerLine.lineweight = -999;
    outerLine.drawOrder = lOrder;
    innerLine.drawOrder = lOrder;

    // 使用预先获取的点数据
    for (let i = 0; i < points.length; i++) {
      const ptVal = points[i];

      if (finObj.objectName === "McDbArc") {
        // 法线方向进行偏移，确保高亮效果宽度一致
        const center = finObj.center;
        // 计算当前点到圆心的向量
        const dx = ptVal.x - center.x;
        const dy = ptVal.y - center.y;
        // 标准化向量长度
        const length = Math.sqrt(dx * dx + dy * dy);
        const nx = dx / length;
        const ny = dy / length;
        // 沿法线方向添加偏移
        outerLine.addVertexAt(
          new McGePoint3d(ptVal.x + nx * offset, ptVal.y + ny * offset, ptVal.z)
        );
        innerLine.addVertexAt(
          new McGePoint3d(ptVal.x - nx * offset, ptVal.y - ny * offset, ptVal.z)
        );
      } else {
        // 多段线偏移方式
        outerLine.addVertexAt(
          new McGePoint3d(ptVal.x + offset, ptVal.y + offset, ptVal.z)
        );
        innerLine.addVertexAt(
          new McGePoint3d(ptVal.x - offset, ptVal.y - offset, ptVal.z)
        );
      }
    }

    // 设置颜色
    outerLine.trueColor = new McCmColor(255, 193, 7);
    innerLine.trueColor = new McCmColor(255, 193, 7);

    // 设置闭合性
    if (finObj.objectName === "McDbPolyline") {
      outerLine.isClosed = finObj.isClosed;
      innerLine.isClosed = finObj.isClosed;
    } else if (finObj.objectName === "McDbArc") {
      // 圆弧不闭合
      outerLine.isClosed = false;
      innerLine.isClosed = false;
    }

    outerLines.push(outerLine);
    innerLines.push(innerLine);
  }

  // 批量添加到画布，减少重绘次数
  const addedEntities = [];

  outerLines.forEach((line) => {
    const entityId = rlAppObj.mxcadObject.drawEntity(line);
    addedEntities.push(entityId);
  });

  innerLines.forEach((line) => {
    const entityId = rlAppObj.mxcadObject.drawEntity(line);
    addedEntities.push(entityId);
  });
  crackHeightEntities.set(finId.id, addedEntities);
  rlAppObj.rlMxDrawObject.updateDisplay();
};
// 选中多个构件清除实体的高亮效果
export const clearEntityHighlightSelectMore = (findId) => {
  if (!findId) {
    crackHeightEntities.forEach((value, key) => {
      for (const entityId of value) {
        try {
          const entity = entityId.getMcDbEntity();
          if (entity) {
            entity.erase();
          }
        } catch (error) {
          console.log("清除高亮效果失败:", error);
        }
      }
      crackHeightEntities.delete(key);
    });
    rlAppObj.rlMxDrawObject.updateDisplay();
    return;
  }
  if (crackHeightEntities.get(findId.id)) {
    for (const entityId of crackHeightEntities.get(findId.id)) {
      try {
        const entity = entityId.getMcDbEntity();
        if (entity) {
          entity.erase();
        }
      } catch (error) {
        console.log("清除高亮效果失败:", error);
      }
    }
    crackHeightEntities.set(findId.id, []);
    rlAppObj.rlMxDrawObject.updateDisplay();
  }
};
// 单个构件移动
export const modeMove = async (data) => {
  const modelId = data.clickDataId;
  const modelObj = modelId.getMcDbEntity();
  const modelData = getEntityById(modelId);
  if (!modelData) return;

  // 保存模型对象的原始位置
  let originalPoint = null;

  // 重置移动回原始位置方法
  const resetMove = (m1, m2) => {
    modelObj.move(new McGePoint3d(m1, m2, 0), new McGePoint3d(m1, m2, 0));
  };

  const moveModel = async () => {
    // 构造当前构件轮廓线围成的包围盒
    const boundingBox = new THREE.Box3();
    const ptNum = modelObj.numVerts();
    for (let num = 0; num < ptNum; num++) {
      const pt = modelObj.getPointAt(num);
      boundingBox.expandByPoint(
        new THREE.Vector3(pt.val.x, pt.val.y, pt.val.z)
      );
    }
    store.commit("globalData/setCanAddRawStep", true);
    if (modelData.classTypeName == "rlColSeg") {
      modelData.saveEditRevokeData();
      // 计算偏轴、沿轴
      const center = new THREE.Vector3();
      boundingBox.getCenter(center); // 获取包围盒中心点

      modelData.EccX = center.x - modelData.m_JointData.m_pt[0];
      modelData.EccY = center.y - modelData.m_JointData.m_pt[1];
      // modelData.draw();
      // modelData.mcDbId = rlAppObj.mxcadObject.drawEntity(
      //   modelData.mcDbPolyline
      // );
      modelData.updateThisObj(modelData);
      return true;
    } else {
      modelData.saveEditRevokeData();
      // 计算偏轴
      const center = new THREE.Vector3();
      boundingBox.getCenter(center); // 获取包围盒中心点

      let stJoint = new THREE.Vector3(...modelData.m_gridData.m_stJoint.m_pt);
      let edJoint = new THREE.Vector3(...modelData.m_gridData.m_edJoint.m_pt);

      let lineDirection = new THREE.Vector3().subVectors(stJoint, edJoint); // 直线方向向量
      if (
        // lineDirection.x * lineDirection.y <= 0 &&
        lineDirection.x < 0 ||
        lineDirection.y < 0
      ) {
        const tmp = stJoint;
        stJoint = edJoint;
        edJoint = tmp;
        lineDirection = new THREE.Vector3().subVectors(stJoint, edJoint);
      }

      var line = new THREE.Line3(stJoint, edJoint);
      var closestPoint = null;
      closestPoint = line.closestPointToPoint(center);
      const vecCenter = new THREE.Vector3().subVectors(center, closestPoint); // 从 A 到 C 的向量

      // 计算叉积
      const crossProduct = new THREE.Vector3().crossVectors(
        lineDirection,
        vecCenter
      );

      if (closestPoint) {
        let Ecc = closestPoint.distanceTo(center);
        // if (vecCenter.x < 0) {
        //   Ecc = crossProduct.z < 0 ? Ecc : -Ecc;
        // } else
        if (crossProduct.z < 0) {
          Ecc = -Ecc;
        }
        modelData.Ecc = Ecc;
      }

      // modelData.draw();
      // modelData.mcDbId = rlAppObj.mxcadObject.drawEntity(
      //   modelData.mcDbPolyline
      // );
      modelData.updateThisObj(modelData);
      return true;
    }
  };

  await new Promise((resolve) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    let pt1 = null;

    // 关闭正交模式
    fixOrthogonal(false);

    getPoint.setInputToucheType(1);
    getPoint.go((status) => {
      if (status !== 0) {
        if (originalPoint) resetMove(pt1, originalPoint);
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        return;
      }
      // 开启正交模式
      fixOrthogonal(true);
      pt1 = store.state.cadModules.snapPoint.snapPoint; // getPoint.value();

      if (!pt1) {
        pt1 = getPoint.value();
        // 启用捕捉优化
        const snapPoint = enableSnapCorrection(pt1, null, true);
        pt1 = snapPoint || pt1;
      }

      getPoint.setBasePt(pt1);
      originalPoint = pt1;
      modelObj.highlight(false);

      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: false,
      });

      const mxcad = MxCpp.getCurrentMxCAD();
      mxcad.addDimStyle(
        "MoveDistDimStyle",
        "41,0.18,141,0.09,140,0,40,200",
        "77,1,271,3,73,1",
        "",
        ""
      );

      mxcad.drawDimStyle = "MoveDistDimStyle";
      const mDimensionId = mxcad.drawDimAligned(
        originalPoint.x,
        originalPoint.y,
        originalPoint.x,
        originalPoint.y,
        originalPoint.x,
        originalPoint.y
      );

      // const mDimension = new McDbAlignedDimension();
      // mDimension.xLine1Point = new McGePoint3d(
      //   originalPoint.x,
      //   originalPoint.y,
      //   0
      // );
      // mDimension.xLine2Point = new McGePoint3d(
      //   originalPoint.x,
      //   originalPoint.y,
      //   0
      // );
      // mDimension.textAttachment = 1;

      // const mDimensionId = rlAppObj.mxcadObject.drawEntity(mDimension);
      const mDimensionObj = mDimensionId.getMcDbEntity();
      // 添加输入框
      let inputElement = getInputElement();
      if (!inputElement) {
        inputElement = createInputElement(mDimensionObj);
      } else {
        setCurrDataObj(mDimensionObj);
        // inputElement.style.display = "block";
        setContainerShow(true);
      }

      // 设置第一个点位置
      getPoint.setUserDraw((currentPoint) => {
        const snapPoint = enableSnapCorrection(
          currentPoint,
          originalPoint,
          true
        );
        currentPoint = snapPoint || currentPoint;
        // const jointpoint = getMinDistJoint(currentPoint);
        const dx = currentPoint.x - pt1.x;
        const dy = currentPoint.y - pt1.y;
        const dz = 0;

        // if (
        //   jointpoint &&
        //   jointpoint.m_pt &&
        //   jointpoint.classTypeName === "rlJoint"
        // ) {
        //   // 吸附位置
        //   modelObj.move(
        //     new McGePoint3d(pt1.x, pt1.y, pt1.z),
        //     new McGePoint3d(jointpoint.m_pt[0], jointpoint.m_pt[1], 0)
        //   );
        //   // 更新 pt1 为 吸附位置
        //   pt1 = new McGePoint3d(jointpoint.m_pt[0], jointpoint.m_pt[1], 0);
        // } else {
        // 鼠标位置
        modelObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt1.x + dx, pt1.y + dy, pt1.z + dz)
        );
        // 更新 pt1 为 鼠标位置
        pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);

        mDimensionObj.xLine2Point = new McGePoint3d(
          currentPoint.x,
          currentPoint.y,
          currentPoint.z
        );
        const midX = (originalPoint.x + currentPoint.x) / 2;
        const midY = (originalPoint.y + currentPoint.y) / 2;
        mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

        setInputElementPosition(
          originalPoint.distanceTo(currentPoint).toFixed(0),
          midX,
          midY
        );
        // }
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go((status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        if (status2 !== 0) {
          if (originalPoint) {
            // 移动回原始位置
            modelObj.move(
              new McGePoint3d(pt1.x, pt1.y, pt1.z),
              new McGePoint3d(originalPoint.x, originalPoint.y, originalPoint.z)
            );
            // 删除标注
            mDimensionObj.erase();
          }
          return;
        }

        // 获取最终点位置
        const finalPoint = pt1;

        // store.state.cadModules.snapPoint.snapPoint; //getPoint.value();
        // if (!finalPoint) {
        //   finalPoint = getPoint.value();
        //   let snapPoint = enableSnapCorrection(finalPoint);
        //   finalPoint = snapPoint ? snapPoint : finalPoint;
        // }

        // 鼠标位置
        modelObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(finalPoint.x, finalPoint.y, finalPoint.z)
        );

        // 计算移动的距离和角度
        const dx = finalPoint.x - originalPoint.x;
        const dy = finalPoint.y - originalPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy).toFixed(2);
        const angle = (Math.atan2(dy, dx) * (180 / Math.PI)).toFixed(2); // 转换为角度

        const res = moveModel();
        if (res == false) {
          // 删除标注
          mDimensionObj.erase();
          modelObj.move(
            new McGePoint3d(pt1.x, pt1.y, pt1.z),
            new McGePoint3d(originalPoint.x, originalPoint.y, originalPoint.z)
          );
        }
        //
        store.commit("cadModules/setMoveDistObj", {
          id: modelData.mcDbId,
          distId: mDimensionId,
          distance,
          angle,
        });

        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        setTimeout(() => {
          clearAllHighLight();
          rlAppObj.rlMxDrawObject.updateDisplay();
        }, 200);
        resolve();
      });
    });
  });
};

// 单个构件复制
export const modeCopy = async (data) => {
  const modelId = data.clickDataId;
  const modelObj = modelId.getMcDbEntity();
  const modelData = getEntityById(modelId);
  if (!modelData) return;
  console.log("1111111111111111111111111");

  // 保存模型对象的原始位置
  let originalPoint = null;

  // 重置移动回原始位置方法
  const resetMove = (m1, m2) => {
    modelObj.move(new McGePoint3d(m1, m2, 0), new McGePoint3d(m1, m2, 0));
  };

  const copyModel = async (newModelObj, copyPolyline) => {
    // 构造当前构件轮廓线围成的包围盒
    const boundingBox = new THREE.Box3();
    const ptNum = copyPolyline.numVerts();
    for (let num = 0; num < ptNum; num++) {
      const pt = copyPolyline.getPointAt(num);
      boundingBox.expandByPoint(
        new THREE.Vector3(pt.val.x, pt.val.y, pt.val.z)
      );
    }
    const center = new THREE.Vector3();
    boundingBox.getCenter(center);

    if (modelData.classTypeName == "rlColSeg") {
      const currPoint = new THREE.Vector3(...modelData.m_JointData.m_pt);
      // 搜索最近的节点
      let closestJoint = null;
      const jointGroup = store.state.rlEntData.totalEntityData["rlJoint"];
      for (let i = 0; i < jointGroup.length; i++) {
        const item = jointGroup[i];
        const jointPt = new THREE.Vector3(...item.m_pt);
        if (!jointPt.equals(currPoint)) {
          // 不能复制到原来的节点上
          const isInBoundingBox = boundingBox.containsPoint(jointPt);
          if (isInBoundingBox) {
            closestJoint = item;
            break;
          }
        }
      }

      if (closestJoint) {
        newModelObj.m_JointData = closestJoint;

        // 计算偏轴、沿轴
        newModelObj.EccX = center.x - closestJoint.m_pt[0];
        newModelObj.EccY = center.y - closestJoint.m_pt[1];
        // newModelObj.mcDbPolyline = copyPolyline;
        newModelObj.draw();
        await addEntityToDrawing(newModelObj, false);
        return true;
      } else {
        return false;
      }
    } else {
      // 搜索最近的网格
      const gridGroup = store.state.rlEntData.totalEntityData["rlGrid"];
      let minDist = 10000;
      let minDistGrid = null;

      const dirOrigin = new THREE.Vector3().subVectors(
        new THREE.Vector3(...modelData.m_gridData.m_stJoint.m_pt),
        new THREE.Vector3(...modelData.m_gridData.m_stJoint.m_pt)
      );
      for (let i = 0; i < gridGroup.length; i++) {
        const item = gridGroup[i];
        const stJoint = new THREE.Vector3(...item.m_stJoint.m_pt);
        const edJoint = new THREE.Vector3(...item.m_edJoint.m_pt);
        var line = new THREE.Line3(stJoint, edJoint);
        const dir = new THREE.Vector3().subVectors(stJoint, edJoint);
        const crossProduct = new THREE.Vector3().crossVectors(dirOrigin, dir);
        if (crossProduct.length() === 0) {
          var closestPoint = null;
          closestPoint = line.closestPointToPoint(center);
          if (closestPoint) {
            const dist = closestPoint.distanceTo(center);
            if (dist < minDist) {
              minDist = dist;
              minDistGrid = item;
            }
          }
        }
      }

      if (minDist < 500 && minDistGrid && minDistGrid.m_beamId == null) {
        // 计算偏轴
        const stJoint = new THREE.Vector3(...minDistGrid.m_stJoint.m_pt);
        const edJoint = new THREE.Vector3(...minDistGrid.m_edJoint.m_pt);

        var line = new THREE.Line3(stJoint, edJoint);

        const lineDirection = new THREE.Vector3().subVectors(stJoint, edJoint); // 直线方向向量
        const vecCenter = new THREE.Vector3().subVectors(center, stJoint); // 从 A 到 C 的向量

        // 计算叉积
        const crossProduct = new THREE.Vector3().crossVectors(
          lineDirection,
          vecCenter
        );

        var closestPoint = null;
        closestPoint = line.closestPointToPoint(center);
        if (closestPoint) {
          let Ecc = closestPoint.distanceTo(center);
          if (crossProduct.z > 0) {
            Ecc = -Ecc;
          }
          newModelObj.Ecc = Ecc;
        }
        newModelObj.m_gridData = minDistGrid;
        newModelObj.draw();
        await addEntityToDrawing(newModelObj, false);
        return true;
      } else {
        return false;
      }

      // 更新数据
    }
  };

  await new Promise((resolve) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    let pt1 = null;

    getPoint.setInputToucheType(1);
    getPoint.go((status) => {
      if (status !== 0) {
        if (originalPoint) resetMove(pt1, originalPoint);
        return;
      }

      pt1 = store.state.cadModules.snapPoint.snapPoint; // getPoint.value();
      // 开启正交模式
      fixOrthogonal(true);
      if (!pt1) {
        pt1 = getPoint.value();
        // 启用捕捉优化
        const snapPoint = enableSnapCorrection(pt1, null, true);
        pt1 = snapPoint || pt1;
      }
      getPoint.setBasePt(pt1);
      originalPoint = pt1;
      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: false,
      });
      const copyModelObj = modelData.myClone();
      copyModelObj.draw();
      copyModelObj.mcDbId = rlAppObj.mxcadObject.drawEntity(
        copyModelObj.mcDbPolyline
      );

      const copyPolyline = copyModelObj.mcDbId.getMcDbEntity();

      modelObj.highlight(false);
      const mxcad = MxCpp.getCurrentMxCAD();
      mxcad.addDimStyle(
        "MoveDistDimStyle",
        "41,0.18,141,0.09,140,0,40,200",
        "77,1,271,3,73,1",
        "",
        ""
      );

      mxcad.drawDimStyle = "MoveDistDimStyle";
      const mDimensionId = mxcad.drawDimAligned(
        originalPoint.x,
        originalPoint.y,
        originalPoint.x,
        originalPoint.y,
        originalPoint.x,
        originalPoint.y
      );
      // const mDimension = new McDbAlignedDimension();
      // mDimension.xLine1Point = new McGePoint3d(
      //   originalPoint.x,
      //   originalPoint.y,
      //   0
      // );
      // mDimension.xLine2Point = new McGePoint3d(
      //   originalPoint.x,
      //   originalPoint.y,
      //   0
      // );
      // mDimension.textAttachment = 1;

      // const mDimensionId = rlAppObj.mxcadObject.drawEntity(mDimension);
      const mDimensionObj = mDimensionId.getMcDbEntity();
      // 添加输入框
      let inputElement = getInputElement();
      if (!inputElement) {
        inputElement = createInputElement(mDimensionObj);
      } else {
        setCurrDataObj(mDimensionObj);
        // inputElement.style.display = "block";
        setContainerShow(true);
      }

      // 设置第一个点位置
      getPoint.setUserDraw((currentPoint) => {
        const snapPoint = enableSnapCorrection(
          currentPoint,
          originalPoint,
          true
        );
        currentPoint = snapPoint || currentPoint;

        const dx = currentPoint.x - pt1.x;
        const dy = currentPoint.y - pt1.y;
        const dz = 0;

        // 鼠标位置
        copyPolyline.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt1.x + dx, pt1.y + dy, pt1.z + dz)
        );
        // 更新 pt1 为 鼠标位置
        pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);

        mDimensionObj.xLine2Point = new McGePoint3d(
          currentPoint.x,
          currentPoint.y,
          currentPoint.z
        );
        const midX = (originalPoint.x + currentPoint.x) / 2;
        const midY = (originalPoint.y + currentPoint.y) / 2;
        mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

        setInputElementPosition(
          originalPoint.distanceTo(currentPoint).toFixed(0),
          midX,
          midY
        );
        // }
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go((status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        if (status2 !== 0) {
          if (originalPoint) {
            // 移动回原始位置
            copyPolyline.erase();
            // 删除标注
            mDimensionObj.erase();
          }
          // 删除标注
          mDimensionObj.erase();
          return;
        }

        // 获取最终点位置
        const finalPoint = pt1;
        // store.state.cadModules.snapPoint.snapPoint; //getPoint.value();
        // if (!finalPoint) {
        //   finalPoint = getPoint.value();
        //   let snapPoint = enableSnapCorrection(finalPoint);
        //   finalPoint = snapPoint ? snapPoint : finalPoint;
        // }
        // 鼠标位置
        copyPolyline.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(finalPoint.x, finalPoint.y, finalPoint.z)
        );
        // }

        // 计算移动的距离和角度
        const dx = finalPoint.x - originalPoint.x;
        const dy = finalPoint.y - originalPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy).toFixed(2);
        const angle = (Math.atan2(dy, dx) * (180 / Math.PI)).toFixed(2); // 转换为角度

        // copyPolyline.erase();
        // copyModel(copyModelObj, copyPolyline).then((res) => {
        //   if (res == false) {
        //     // 删除标注
        //     mDimensionObj.erase();
        //   }
        // });
        // copyPolyline.erase();
        store.commit("cadModules/setMoveDistObj", {
          id: modelId,
          viewId: copyModelObj.mcDbId, // 复制预览线的id
          distId: mDimensionId,
          alignType: 1, // 标注类型为复制-------1==复制，2==移动，否则为测量
          originalPoint: originalPoint,
          angle,
        });

        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        setTimeout(() => {
          clearAllHighLight();
          rlAppObj.rlMxDrawObject.updateDisplay();
        }, 200);
        resolve();
      });
    });
  });
};

// 添加距离标注
const addDistTagging = (ptClick) => {
  // 设置对齐标注
  // 设置第一条线的端点
  // const mDimension = new McDbAlignedDimension();
  // mDimension.xLine1Point = new McGePoint3d(
  //   objGrid.m_stJoint.m_pt[0],
  //   objGrid.m_stJoint.m_pt[1]
  // );
  // // 设置第二条线的端点
  // mDimension.xLine2Point = new McGePoint3d(
  //   objGrid.m_edJoint.m_pt[0],
  //   objGrid.m_edJoint.m_pt[1]
  // );

  // // 根据法线方向计算偏移值
  // mDimension.dimLinePoint = new McGePoint3d(
  //   objGrid.m_stJoint.m_pt[0],
  //   objGrid.m_stJoint.m_pt[1]
  // );

  // mDimension.textAttachment = 1;

  // let mDimensionId = rlAppObj.mxcadObject.drawEntity(mDimension); // 绘制尺寸标注

  const mxcad = MxCpp.getCurrentMxCAD();
  // mxcad.addDimStyle(
  //   "MoveDistDimStyle",
  //   "140,5,142,1,41,0.18,141,0.09,40,200",
  //   "271,0,173,1",
  //   ""
  // );
  mxcad.addDimStyle(
    "MoveDistDimStyle",
    "41,0.18,141,0.09,140,0,40,200",
    "77,1,271,3,73,1",
    "",
    ""
  );

  mxcad.drawDimStyle = "MoveDistDimStyle";
  const mDimensionId = mxcad.drawDimAligned(
    ptClick.x,
    ptClick.y,
    ptClick.x,
    ptClick.y,
    ptClick.x,
    ptClick.y
  );
  return mDimensionId;
};

// const addAngleTagging = (objGrid) => {
//   // 设置角度标注

//   let mDimAngularId = rlAppObj.mxcadObject.drawDimAngular(
//     objGrid.m_stJoint.m_pt[0],
//     objGrid.m_stJoint.m_pt[1],
//     objGrid.m_stJoint.m_pt[0],
//     objGrid.m_stJoint.m_pt[1],
//     objGrid.m_stJoint.m_pt[0],
//     objGrid.m_stJoint.m_pt[1],
//     objGrid.m_stJoint.m_pt[0],
//     objGrid.m_stJoint.m_pt[1]
//   );

//   return mDimAngularId;
// };

// 单个网格移动axisMove
export const gridMove = async (data) => {
  const modelId = data.clickDataId;
  const modelObj = modelId.getMcDbEntity();
  const modelData = getEntityById(modelId);
  if (!modelData) return;

  // 初始化移动数据
  const compList = [];

  // 添加实体到列表
  const addEntityToList = (entityType, id) => {
    const entityData = getEntityData({
      classTypeName: entityType,
      Guid: id,
    });

    compList.push({
      id: entityData.mcDbId,
      classTypeName: entityType,
    });
  };

  // 添加需要移动的类型
  const entityType = {
    m_wallId: "rlWallSeg",
    m_beamId: "rlBeamSeg",
    m_wallHoleId: "rlWallHole",
    m_ringBeamId: "rlRingBeamSeg",
    m_cloumId: "rlColSeg",
  };
  // 循环添加
  Object.keys(entityType).forEach((key) => {
    if (modelData[key]) {
      addEntityToList(entityType[key], modelData[key]);
    } else {
      if (
        modelData.m_stJoint &&
        modelData.m_stJoint[key] &&
        modelData.m_stJoint.m_gridIds.length < 2
      ) {
        addEntityToList(entityType[key], modelData.m_stJoint[key]);
      }
      if (
        modelData.m_edJoint &&
        modelData.m_edJoint[key] &&
        modelData.m_edJoint.m_gridIds.length < 2
      ) {
        addEntityToList(entityType[key], modelData.m_edJoint[key]);
      }
    }
  });

  // 移动构件
  const moveModObj = (pt1, pt2) => {
    for (let i = 0; i < compList.length; i++) {
      const entity = compList[i];
      const entityObj = entity.id.getMcDbEntity();
      const entityData = getEntityById(entity.id);
      if (entityData) {
        // 移动选中的构件
        entityObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt2.x, pt2.y, pt2.z)
        );
      }
    }
  };

  await new Promise((resolve, reject) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    // 关闭正交模式
    fixOrthogonal(false);

    let ptClick = null;
    // 保存模型对象的原始位置
    let originalPoint = null;
    let finalPoint = null;

    getPoint.setInputToucheType(1);
    getPoint.go((status) => {
      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: false,
      });
      if (status != 0) {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        return;
      }
      // 开启正交模式
      fixOrthogonal(true);
      ptClick = store.state.cadModules.snapPoint.snapPoint; // getPoint.value();

      if (!ptClick) {
        ptClick = getPoint.value();
        // 启用捕捉优化
        const snapPoint = enableSnapCorrection(ptClick);
        ptClick = snapPoint || ptClick;
      }
      getPoint.setBasePt(ptClick);
      originalPoint = ptClick;
      modelObj.highlight(false);

      // 克隆轴线网格
      const entityClone = new McDbLine(); // modelData.myClone();
      entityClone.startPoint = new McGePoint3d(
        modelData.m_stJoint.m_pt[0],
        modelData.m_stJoint.m_pt[1],
        modelData.m_stJoint.m_pt[2]
      );
      entityClone.endPoint = new McGePoint3d(
        modelData.m_edJoint.m_pt[0],
        modelData.m_edJoint.m_pt[1],
        modelData.m_edJoint.m_pt[2]
      );
      entityClone.trueColor = new McCmColor(255, 0, 0);
      const cloneId = rlAppObj.mxcadObject.drawEntity(entityClone);
      const entityCloneObj = cloneId.getMcDbEntity();

      // 添加距离标注
      const mDimensionId = addDistTagging(originalPoint);
      const dimensionObj = mDimensionId.getMcDbEntity();

      // 添加输入框
      let inputElement = getInputElement();
      if (!inputElement) {
        inputElement = createInputElement(dimensionObj);
      } else {
        setCurrDataObj(dimensionObj);
        // inputElement.style.display = "block";
        setContainerShow(true);
      }
      inputElement.readOnly = true;
      // 设置第一个点位置
      getPoint.setUserDraw((currentPoint, pw) => {
        // 开启正交模式并设置点
        fixOrthogonal(true);

        const snapPoint = enableSnapCorrection(currentPoint, originalPoint);
        currentPoint = snapPoint || currentPoint;

        // 计算单次移动的距离
        const dx = currentPoint.x - ptClick.x;
        const dy = currentPoint.y - ptClick.y;
        const dz = 0;

        // 计算累计移动的距离
        const dxs = currentPoint.x - originalPoint.x;
        const dys = currentPoint.y - originalPoint.y;

        // 移动轴线
        entityCloneObj.move(
          new McGePoint3d(ptClick.x, ptClick.y, ptClick.z),
          new McGePoint3d(ptClick.x + dx, ptClick.y + dy, ptClick.z + dz)
        );
        // // 移动构件
        // moveModObj(ptClick, {
        //   x: ptClick.x + dx,
        //   y: ptClick.y + dy,
        //   z: ptClick.z + dz,
        // });

        // 更新 pt1 为 鼠标位置
        ptClick = new McGePoint3d(
          currentPoint.x,
          currentPoint.y,
          currentPoint.z
        );

        // 更新标注位置
        dimensionObj.xLine2Point = new McGePoint3d(ptClick.x, ptClick.y, 0);

        // 计算中点位置用于显示距离
        const midPoint = new THREE.Vector3().lerpVectors(
          originalPoint,
          currentPoint,
          0.5
        );
        setInputElementPosition(
          originalPoint.distanceTo(currentPoint).toFixed(0),
          midPoint.x,
          midPoint.y
        );
        // rlAppObj.mxcadObject.drawDimAngular(
        //   stPoint,
        //   edPoint,
        //   stPoint,
        //   edPoint,
        //   modelData.m_stJoint.m_pt[0] + dxs,
        //   modelData.m_stJoint.m_pt[1] + dys,
        //   stPoint,
        //   edPoint
        // );
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);

      getPoint.go((status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        if (status2 != 0) {
          dimensionObj.erase();
          if (originalPoint) {
            entityCloneObj.erase();
            // 轴线移动回原始位置
            // entityCloneObj.move(
            //   new McGePoint3d(ptClick.x, ptClick.y, ptClick.z),
            //   new McGePoint3d(originalPoint.x, originalPoint.y, originalPoint.z)
            // );
            // // 构件移动回原来位置
            // moveModObj(ptClick, originalPoint);
          }
          // 还原标注位置
          return;
        }

        // 获取最终点位置
        finalPoint = store.state.cadModules.snapPoint.snapPoint; // getPoint.value();
        if (!finalPoint) {
          finalPoint = getPoint.value();
          const snapPoint = enableSnapCorrection(finalPoint);
          finalPoint = snapPoint || finalPoint;
        }
        // store.commit("cadModules/setSnapPoint", {
        //   snapPoint: null,
        //   needCatchSnap: false,
        // });
        // 鼠标位置

        const vecMove = new THREE.Vector3(
          finalPoint.x - originalPoint.x,
          finalPoint.y - originalPoint.y,
          0
        );

        // const resFlag = await modelData.transformBy(vecMove);
        // if (resFlag == false) {
        //   modelObj.move(
        //     new McGePoint3d(finalPoint.x, finalPoint.y, finalPoint.z),
        //     new McGePoint3d(originalPoint.x, originalPoint.y, originalPoint.z)
        //   );
        //   moveModObj(originalPoint, finalPoint);
        //   return;
        // } else if (resFlag == true) {
        //   dimensionObj.erase();
        //   return; //网格被切分为两段
        // }

        // 计算移动的距离和角度
        const dx = finalPoint.x - originalPoint.x;
        const dy = finalPoint.y - originalPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy).toFixed(2);
        const angle = (Math.atan2(dy, dx) * (180 / Math.PI)).toFixed(2); // 转换为角度

        store.commit("cadModules/setMoveDistObj", {
          id: modelId,
          viewId: cloneId, // 复制预览线的id
          distId: mDimensionId,
          alignType: 2, // 1==复制，2==移动，否则为测量
          distance,
          angle,
        });
        inputElement.readOnly = false;
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        // store.commit("cadModules/setMoveDistObj", {
        //   id: modelId,
        //   viewId: cloneId, //复制预览线的id
        //   alignType: 1, //标注类型为复制-------1==复制，2==移动，否则为测量
        //   distId: mDimensionId,
        //   distance,
        //   angle,
        // });

        setTimeout(() => {
          clearAllHighLight();
          rlAppObj.rlMxDrawObject.updateDisplay();
        }, 200);
        resolve();
      });
    });
  });
};

// 单个网格复制axisCopy
export const gridCopy = async (data) => {
  const modelId = data.clickDataId;
  const modelObj = modelId.getMcDbEntity(); // 网格的直线对象
  const modelData = getEntityById(modelId); // 网格对象
  if (!modelData) return;

  // 保存模型对象的原始位置
  await new Promise((resolve, reject) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    // 关闭正交模式
    fixOrthogonal(false);

    let originalPoint = null;
    let finalPoint = null;
    store.commit("cadModules/setForceRlGridSnap", true);
    getPoint.setInputToucheType(1);
    getPoint.go((status) => {
      if (status != 0) {
        store.commit("cadModules/setForceRlGridSnap", false);
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        return;
      }
      // 开启正交模式
      fixOrthogonal(true);
      let ptClick = store.state.cadModules.snapPoint.snapPoint;

      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: false,
      });

      if (!ptClick) {
        ptClick = getPoint.value();

        // 启用捕捉优化
        const snapPoint = enableSnapCorrection(ptClick);
        ptClick = snapPoint || ptClick;
      }
      getPoint.setBasePt(ptClick);
      originalPoint = ptClick;
      modelObj.highlight(false);

      // 添加距离标注
      const mDimensionId = addDistTagging(originalPoint);
      const dimensionObj = mDimensionId.getMcDbEntity();
      // 添加输入框
      let inputElement = getInputElement();
      if (!inputElement) {
        inputElement = createInputElement(dimensionObj);
      } else {
        setCurrDataObj(dimensionObj);
        // inputElement.style.display = "block";
        setContainerShow(true);
      }
      inputElement.readOnly = true;
      inputElement.disabled = true;
      // 存储到全局状态中
      store.commit("globalData/setDimensionObj", dimensionObj);
      // 克隆轴线网格
      let entityClone = null;
      if (
        modelData.m_centerJoint ||
        (modelData.m_Axis && modelData.m_Axis.IsMainAxis < 0)
      ) {
        entityClone = new McDbArc();
        entityClone.center = new McGePoint3d(
          modelData.centerPoint[0],
          modelData.centerPoint[1],
          modelData.centerPoint[2]
        );
        entityClone.radius = new THREE.Vector3(
          ...modelData.m_edJoint.m_pt
        ).distanceTo(new THREE.Vector3(...modelData.centerPoint));

        entityClone.startAngle = calculateArcAngle(
          entityClone.center,
          new THREE.Vector3(...modelData.m_stJoint.m_pt)
        );

        entityClone.endAngle = calculateArcAngle(
          entityClone.center,
          new THREE.Vector3(...modelData.m_edJoint.m_pt)
        );
      } else {
        entityClone = new McDbLine(); // modelData.myClone();
        entityClone.startPoint = new McGePoint3d(
          modelData.m_stJoint.m_pt[0],
          modelData.m_stJoint.m_pt[1],
          modelData.m_stJoint.m_pt[2]
        );
        entityClone.endPoint = new McGePoint3d(
          modelData.m_edJoint.m_pt[0],
          modelData.m_edJoint.m_pt[1],
          modelData.m_edJoint.m_pt[2]
        );
      }

      store.commit("cadModules/setForceRlGridSnap", false);
      entityClone.trueColor = new McCmColor(255, 0, 0);
      const cloneId = rlAppObj.mxcadObject.drawEntity(entityClone);
      const entityCloneObj = cloneId.getMcDbEntity();
      // 设置第一个点位置
      getPoint.setUserDraw((currentPoint, pw) => {
        // 开启正交模式并设置点
        fixOrthogonal(true);
        // 计算移动的距离
        const snapPoint = enableSnapCorrection(currentPoint, originalPoint);
        currentPoint = snapPoint || currentPoint;
        const dx = currentPoint.x - ptClick.x;
        const dy = currentPoint.y - ptClick.y;
        const dz = currentPoint.z - ptClick.z;

        // 计算累计移动的距离
        const dxs = currentPoint.x - originalPoint.x;
        const dys = currentPoint.y - originalPoint.y;

        entityCloneObj.move(
          new McGePoint3d(ptClick.x, ptClick.y, ptClick.z),
          new McGePoint3d(ptClick.x + dx, ptClick.y + dy, ptClick.z + dz)
        );

        // 移动构件
        // moveModObj(ptClick, {
        //   x: ptClick.x + dx,
        //   y: ptClick.y + dy,
        //   z: ptClick.z + dz,
        // });

        // 更新 pt1 为 鼠标位置
        ptClick = new McGePoint3d(
          currentPoint.x,
          currentPoint.y,
          currentPoint.z
        );

        // 更新标注位置
        dimensionObj.xLine2Point = new McGePoint3d(ptClick.x, ptClick.y, 0);
        // 计算中点位置用于显示距离
        const midPoint = new THREE.Vector3().lerpVectors(
          originalPoint,
          currentPoint,
          0.5
        );
        setInputElementPosition(
          originalPoint.distanceTo(currentPoint).toFixed(0),
          midPoint.x,
          midPoint.y
        );
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go(async (status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        // 获取最终点位置
        finalPoint = store.state.cadModules.snapPoint.snapPoint; // getPoint.value();
        if (!finalPoint) {
          finalPoint = getPoint.value();
          const snapPoint = enableSnapCorrection(finalPoint);
          finalPoint = snapPoint || finalPoint;
        }
        if (status2 != 0) {
          store.commit("cadModules/setForceRlGridSnap", false);
          if (originalPoint) {
            // 用户取消复制，删除数据
            entityCloneObj.erase();
            // deleteModObj(entityCloneObj);
          }
          return;
        }

        // 鼠标位置
        const vecMove = new THREE.Vector3(
          finalPoint.x - originalPoint.x,
          finalPoint.y - originalPoint.y,
          0
        );
        // entityCloneObj.erase();
        // const resFlag = await modelData.copyGridData(vecMove);
        // 网格已经存在移动回原始位置
        // if (resFlag == false) {
        //   deleteModObj(entityCloneObj);
        // } else {
        //   //只删除构件即可
        //   for (let i = 0; i < compList.length; i++) {
        //     const entity = compList[i];
        //     // 移动选中的构件
        //     entity.id.getMcDbEntity().erase();
        //   }
        // }

        // 计算移动的距离和角度
        const dx = finalPoint.x - originalPoint.x;
        const dy = finalPoint.y - originalPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy).toFixed(2);
        const angle = (Math.atan2(dy, dx) * (180 / Math.PI)).toFixed(2); // 转换为角度
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        store.commit("cadModules/setMoveDistObj", {
          id: modelId,
          viewId: cloneId, // 复制预览线的id
          alignType: 1, // 标注类型为复制-------1==复制，2==移动，否则为测量
          distId: mDimensionId,
          distance,
          angle,
        });
        inputElement.readOnly = false;
        inputElement.disabled = false;
        setTimeout(() => {
          clearAllHighLight();
          rlAppObj.rlMxDrawObject.updateDisplay();
        }, 200);
        resolve();
      });
    });
  });
};

// 单个轴线复制
export const axisCopy = async (data) => {
  const modelId = data.clickDataId;
  const modelObj = modelId.getMcDbEntity(); // 网格渲染对象
  const modelData = await getGridAxisData(getEntityById(modelId)); // 轴线对象
  if (!modelData) return;

  await new Promise((resolve, reject) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    // 关闭正交模式
    fixOrthogonal(false);

    const ptClick = null;
    let originalPoint = null;
    let finalPoint = null;

    getPoint.setInputToucheType(1);
    getPoint.go((status) => {
      if (status != 0) {
        store.commit("cadModules/setForceRlGridSnap", false);
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        return;
      }
      // 开启正交模式
      fixOrthogonal(true);
      let ptClick = store.state.cadModules.snapPoint.snapPoint;

      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: false,
      });
      if (!ptClick) {
        ptClick = getPoint.value();
        // 启用捕捉优化
        const snapPoint = enableSnapCorrection(ptClick);
        ptClick = snapPoint || ptClick;
      }
      getPoint.setBasePt(ptClick);
      originalPoint = ptClick;
      modelObj.highlight(false);

      // 添加距离标注
      const mDimensionId = addDistTagging(originalPoint);
      const dimensionObj = mDimensionId.getMcDbEntity();
      // 添加输入框
      let inputElement = getInputElement();
      if (!inputElement) {
        inputElement = createInputElement(dimensionObj);
      } else {
        setCurrDataObj(dimensionObj);
        // inputElement.style.display = "block";
        setContainerShow(true);
      }
      inputElement.readOnly = true;
      // 存储到全局状态中
      store.commit("globalData/setDimensionObj", dimensionObj);
      // 克隆轴线网格
      let entityClone = null;
      if (modelData.IsMainAxis < 0) {
        entityClone = new McDbArc();
        entityClone.center = new McGePoint3d(
          modelData.m_stJoint.m_pt[0],
          modelData.m_stJoint.m_pt[1],
          modelData.m_stJoint.m_pt[2]
        );
        entityClone.radius = new THREE.Vector3(
          ...modelData.m_edJoint.m_pt
        ).distanceTo(new THREE.Vector3(...modelData.m_stJoint.m_pt));

        entityClone.startAngle = calculateArcAngle(
          entityClone.center,
          new THREE.Vector3(...modelData.m_stArcPoint)
        );

        entityClone.endAngle = calculateArcAngle(
          entityClone.center,
          new THREE.Vector3(...modelData.m_edArcPoint)
        );
      } else {
        entityClone = new McDbLine(); // modelData.myClone();
        entityClone.startPoint = new McGePoint3d(
          modelData.m_stJoint.m_pt[0],
          modelData.m_stJoint.m_pt[1],
          modelData.m_stJoint.m_pt[2]
        );
        entityClone.endPoint = new McGePoint3d(
          modelData.m_edJoint.m_pt[0],
          modelData.m_edJoint.m_pt[1],
          modelData.m_edJoint.m_pt[2]
        );
      }
      store.commit("cadModules/setForceRlGridSnap", false);
      entityClone.trueColor = new McCmColor(255, 0, 0);
      const cloneId = rlAppObj.mxcadObject.drawEntity(entityClone);
      const entityCloneObj = cloneId.getMcDbEntity();
      // 设置第一个点位置
      getPoint.setUserDraw((currentPoint, pw) => {
        // 开启正交模式并设置点
        fixOrthogonal(true);
        // 计算移动的距离
        const snapPoint = enableSnapCorrection(currentPoint, originalPoint);
        currentPoint = snapPoint || currentPoint;
        const dx = currentPoint.x - ptClick.x;
        const dy = currentPoint.y - ptClick.y;
        const dz = currentPoint.z - ptClick.z;

        // 计算累计移动的距离
        const dxs = currentPoint.x - originalPoint.x;
        const dys = currentPoint.y - originalPoint.y;

        entityCloneObj.move(
          new McGePoint3d(ptClick.x, ptClick.y, ptClick.z),
          new McGePoint3d(ptClick.x + dx, ptClick.y + dy, ptClick.z + dz)
        );

        // 移动构件
        // moveModObj(ptClick, {
        //   x: ptClick.x + dx,
        //   y: ptClick.y + dy,
        //   z: ptClick.z + dz,
        // });

        // 更新 pt1 为 鼠标位置
        ptClick = new McGePoint3d(
          currentPoint.x,
          currentPoint.y,
          currentPoint.z
        );

        // 更新标注位置
        dimensionObj.xLine2Point = new McGePoint3d(ptClick.x, ptClick.y, 0);
        // 计算中点位置用于显示距离
        const midPoint = new THREE.Vector3().lerpVectors(
          originalPoint,
          currentPoint,
          0.5
        );
        setInputElementPosition(
          originalPoint.distanceTo(currentPoint).toFixed(0),
          midPoint.x,
          midPoint.y
        );
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go(async (status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        if (status2 != 0) {
          store.commit("cadModules/setForceRlGridSnap", false);
          entityCloneObj?.erase();
          return;
        }
        // 获取最终点位置
        finalPoint = store.state.cadModules.snapPoint.snapPoint; // getPoint.value();
        if (!finalPoint) {
          finalPoint = getPoint.value();
          const snapPoint = enableSnapCorrection(finalPoint);
          finalPoint = snapPoint || finalPoint;
        }
        // 鼠标位置
        const vecMove = new THREE.Vector3(
          finalPoint.x - originalPoint.x,
          finalPoint.y - originalPoint.y,
          0
        );

        // 计算移动的距离和角度
        const dx = finalPoint.x - originalPoint.x;
        const dy = finalPoint.y - originalPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy).toFixed(2);
        const angle = (Math.atan2(dy, dx) * (180 / Math.PI)).toFixed(2); // 转换为角度
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        store.commit("cadModules/setMoveDistObj", {
          id: modelData.mcDbId,
          viewId: cloneId, // 复制预览线的id
          alignType: 1, // 标注类型为复制-------1==复制，2==移动，否则为测量
          distId: mDimensionId,
          distance,
          angle,
        });
        inputElement.readOnly = false;
        setTimeout(() => {
          clearAllHighLight();
          rlAppObj.rlMxDrawObject.updateDisplay();
        }, 200);
        resolve();
      });
    });
  });
};

/**
 * 计算两个点之间的距离和角度
 * @param {Object} startPoint - 起始点坐标 {x: Number, y: Number}
 * @param {Object} endPoint - 终点坐标 {x: Number, y: Number}
 * @returns {Object} - 包含距离和角度的对象 {distance: Number, angle: Number}
 */
export const calculateDistanceAndAngle = (startPoint, endPoint) => {
  let angle = 0; // 角度
  let angleValue = 0; // 角度值

  const distance = Math.sqrt(
    Math.pow(endPoint.x - startPoint.x, 2) +
      Math.pow(endPoint.y - startPoint.y, 2)
  );

  // 保留距离到整数位
  const modulusDistance = Math.round(distance);

  const normalizedEndPoint = {
    x: (endPoint.x - startPoint.x) / distance,
    y: (endPoint.y - startPoint.y) / distance,
  };

  const adjustedEndPoint = {
    x: startPoint.x + normalizedEndPoint.x * modulusDistance,
    y: startPoint.y + normalizedEndPoint.y * modulusDistance,
  };

  // 计算角度
  angle = Math.atan2(
    adjustedEndPoint.y - startPoint.y,
    adjustedEndPoint.x - startPoint.x
  );
  angleValue = ((angle * 180) / Math.PI + 360) % 360;

  // 修正角度在左右侧的显示
  if (angle > Math.PI / 2 || angle < -Math.PI / 2) {
    angle -= Math.PI;
  }

  return {
    distance: modulusDistance,
    angle: parseFloat((angleValue === 360 ? 0 : angleValue).toFixed(1)),
  };
};

// 计算圆弧的中点（自动判断起点到终点的实际弧度方向，返回该段弧的中点）
export const calculateArcCenterByCenter = (arcCenter, ptSt, ptEd) => {
  if (!arcCenter || !ptSt || !ptEd) {
    console.warn("calculateArcCenterByCenter: 缺少必要的参数");
    return null;
  }

  // 计算半径
  const radius1 = Math.sqrt(
    Math.pow(ptSt.x - arcCenter.x, 2) +
      Math.pow(ptSt.y - arcCenter.y, 2) +
      Math.pow((ptSt.z || 0) - (arcCenter.z || 0), 2)
  );
  const radius2 = Math.sqrt(
    Math.pow(ptEd.x - arcCenter.x, 2) +
      Math.pow(ptEd.y - arcCenter.y, 2) +
      Math.pow((ptEd.z || 0) - (arcCenter.z || 0), 2)
  );
  if (Math.abs(radius1 - radius2) > 1) {
    console.warn(
      "calculateArcCenterByCenter: 起点和终点不在同一个圆上",
      radius1,
      radius2
    );
    return null;
  }

  // 计算起点和终点的角度
  let angle1 = Math.atan2(ptSt.y - arcCenter.y, ptSt.x - arcCenter.x);
  let angle2 = Math.atan2(ptEd.y - arcCenter.y, ptEd.x - arcCenter.x);
  angle1 = normalizeAngle(angle1);
  angle2 = normalizeAngle(angle2);

  // 计算角度差（保持方向，支持跨0）
  let angleDiff = angle1 > angle2 ? angle1 - angle2 : angle2 - angle1;
  // 保证angleDiff在(-2PI, 2PI)范围
  if (angleDiff > Math.PI) {
    angleDiff -= 2 * Math.PI;
  } else if (angleDiff < -Math.PI) {
    angleDiff += 2 * Math.PI;
  }

  // 计算中点角度
  const midAngle = angle1 + angleDiff / 2;

  // 计算中点坐标
  const midPoint = new THREE.Vector3(
    arcCenter.x + radius1 * Math.cos(midAngle),
    arcCenter.y + radius1 * Math.sin(midAngle),
    arcCenter.z
  );

  return midPoint;
};

// 获取光标最近的网格
export const getMinDistGrid = (cadCoord, maxDist = 500) => {
  // 获取所有轴网
  const axisGroup = store.state.rlEntData.totalEntityData["rlAxis"];

  let lastMinDist = maxDist;
  let minDistAxis = null;

  // 遍历每一个轴网
  axisGroup.forEach((item) => {
    var line = new THREE.Line3(
      new THREE.Vector3(...item.m_stJoint.m_pt),
      new THREE.Vector3(...item.m_edJoint.m_pt)
    );

    // 获取光标到该轴网的最近点
    var closestPoint = line.closestPointToPoint(cadCoord, true);
    if (closestPoint) {
      const dist = closestPoint.distanceTo(cadCoord);

      // 记录最小距离的轴网
      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistAxis = item;
      }
    }
  });

  // 如果找到了最近的轴线，继续找该轴线上的最近网格
  if (minDistAxis) {
    let lastMinDist = maxDist;
    let minDistGrid = null;
    let minDistPoint = null;

    // 获取该轴线上的网格ID列表
    const gridIds = minDistAxis.m_gridIds;

    // 遍历每一个网格
    gridIds.forEach((guid) => {
      const objTmp = getEntityData({
        Guid: guid,
        classTypeName: "rlGrid",
      });

      if (objTmp) {
        var line = new THREE.Line3(
          new THREE.Vector3(...objTmp.m_stJoint.m_pt),
          new THREE.Vector3(...objTmp.m_edJoint.m_pt)
        );

        // 获取光标到该网格的最近点
        var closestPoint = line.closestPointToPoint(cadCoord, true);
        if (closestPoint) {
          const dist = closestPoint.distanceTo(cadCoord);

          // 记录最小距离的网格和最近点
          if (dist < lastMinDist) {
            lastMinDist = dist;
            minDistGrid = objTmp;
            minDistPoint = closestPoint;
          }
        }
      }
    });

    // 返回最近的网格和最近点
    if (minDistGrid && minDistPoint) {
      const gridMidPoint = new THREE.Vector3(
        (minDistGrid.m_stJoint.m_pt[0] + minDistGrid.m_edJoint.m_pt[0]) / 2,
        (minDistGrid.m_stJoint.m_pt[1] + minDistGrid.m_edJoint.m_pt[1]) / 2,
        (minDistGrid.m_stJoint.m_pt[2] + minDistGrid.m_edJoint.m_pt[2]) / 2
      );

      const distToMidPoint = gridMidPoint.distanceTo(cadCoord);
      const result = {
        data: minDistGrid,
        point: minDistPoint,
      };

      if (distToMidPoint < maxDist) {
        result.midPoint = gridMidPoint;
      }

      return result;
    }
  }

  return null;
};

// 获取光标最近的模型顶点或路径点
export const getMinDistModelVertex = (cadCoord, maxDist = 500) => {
  // 需要排除的属性列表
  const excludedProperties = [
    "rlAxis",
    "rlCircle",
    "rlGrid",
    "rlJoint",
    "rlLine",
    "rlText",
  ];

  // 获取所有模型顶点数据
  const totalEntityData = store.state.rlEntData.totalEntityData;
  const modelData = [];

  // 遍历 totalEntityData 对象中的所有属性
  for (const property in totalEntityData) {
    // 如果属性不在排除列表中，则将其加入到 modelData 中
    if (!excludedProperties.includes(property)) {
      modelData.push(...totalEntityData[property]);
    }
  }

  let lastMinDist = maxDist;
  let minDistVertex = null;
  let minDistPoint = null;

  // 遍历每一个模型对象，首先查找顶点坐标和中点坐标
  modelData.forEach((item) => {
    const index2dData = item.index2dData;

    for (let i = 0; i < index2dData.length; i += 3) {
      const vertex = new THREE.Vector3(index2dData[i], index2dData[i + 1], 0);
      const dist = vertex.distanceTo(cadCoord);

      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistVertex = item;
        minDistPoint = vertex;
      }
    }

    for (let i = 0; i < index2dData.length - 3; i += 3) {
      const startVertex = new THREE.Vector3(
        index2dData[i],
        index2dData[i + 1],
        0
      );
      const endVertex = new THREE.Vector3(
        index2dData[i + 3],
        index2dData[i + 4],
        0
      );
      const midPoint = new THREE.Vector3(
        (startVertex.x + endVertex.x) / 2,
        (startVertex.y + endVertex.y) / 2,
        0
      );
      const dist = midPoint.distanceTo(cadCoord);

      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistVertex = item;
        minDistPoint = midPoint;
      }
    }
  });

  // 如果找到最近的顶点或中点，并且距离小于maxDist，则直接返回
  if (minDistVertex && minDistPoint && lastMinDist < maxDist) {
    return {
      data: minDistVertex,
      point: minDistPoint,
    };
  }

  // 如果没有找到足够近的顶点或中点，则检查最近的路径点
  lastMinDist = maxDist;
  minDistVertex = null;
  minDistPoint = null;

  modelData.forEach((item) => {
    const index2dData = item.index2dData;

    // 遍历顶点数据，计算光标到线段的最近点
    for (let i = 0; i < index2dData.length - 3; i += 3) {
      const startVertex = new THREE.Vector3(
        index2dData[i],
        index2dData[i + 1],
        0
      );
      const endVertex = new THREE.Vector3(
        index2dData[i + 3],
        index2dData[i + 4],
        0
      );

      const line = new THREE.Line3(startVertex, endVertex);
      const closestPoint = line.closestPointToPoint(cadCoord, true);
      const dist = closestPoint.distanceTo(cadCoord);

      // 记录最小距离的路径点
      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistVertex = item;
        minDistPoint = closestPoint;
      }
    }
  });

  // 返回最近的路径点和其所在的模型对象
  if (minDistVertex && minDistPoint) {
    return {
      data: minDistVertex,
      point: minDistPoint,
    };
  }

  return null;
};

// 获取距离给定点最近的线上点的辅助函数
THREE.Line3.prototype.closestPointToPoint = function (point, clampToLine) {
  var startP = new THREE.Vector3();
  var startEnd = new THREE.Vector3();

  startP.subVectors(point, this.start); // 计算从线段起点到给定点的向量
  startEnd.subVectors(this.end, this.start); // 计算线段的方向向量

  var startEnd2 = startEnd.dot(startEnd); // 计算线段长度的平方
  var startEnd_startP = startEnd.dot(startP); // 计算线段方向向量与起点到给定点向量的点积

  var t = startEnd_startP / startEnd2; // 计算参数t，使得start + t*(end - start)为最近点

  if (clampToLine) {
    t = Math.max(0, Math.min(1, t)); // 如果需要限定在线段内，t值需在0到1之间
  }

  return this.start.clone().add(startEnd.multiplyScalar(t)); // 计算并返回最近点的坐标
};

// 获取光标最近的节点
export const getMinDistJoint = (cadCoord, minDist = 200) => {
  // 获取所有轴网
  const axisGroup = store.state.rlEntData.totalEntityData["rlAxis"];
  let lastMinDist = minDist;
  let minDistAxis = null;
  axisGroup.forEach((item) => {
    // 创建轴线对象
    var line = new THREE.Line3(
      new THREE.Vector3(...item.m_stJoint.m_pt),
      new THREE.Vector3(...item.m_edJoint.m_pt)
    );
    var closestPoint = null;
    // 计算光标最近的点
    closestPoint = line.closestPointToPoint(cadCoord);
    if (closestPoint) {
      const dist = closestPoint.distanceTo(cadCoord);
      // 记录最小的轴线
      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistAxis = item;
      }
    }
  });

  if (minDistAxis) {
    let lastMinDist = minDist;
    let minDistJoint = null;
    // 找该轴线上最近的网格
    const gridIds = minDistAxis.m_gridIds;
    gridIds.forEach((guid) => {
      const objTmp = getEntityData({
        Guid: guid,
        classTypeName: "rlGrid",
      });
      if (objTmp) {
        const pt1 = new THREE.Vector3(...objTmp.m_stJoint.m_pt);
        const pt2 = new THREE.Vector3(...objTmp.m_edJoint.m_pt);
        const dist1 = pt1.distanceTo(cadCoord);
        const dist2 = pt2.distanceTo(cadCoord);
        if (dist1 < dist2 && dist1 < lastMinDist) {
          minDistJoint = objTmp.m_stJoint;
          lastMinDist = dist1;
        } else if (dist1 > dist2 && dist2 < lastMinDist) {
          minDistJoint = objTmp.m_edJoint;
          lastMinDist = dist2;
        }
      }
    });
    if (minDistJoint) {
      return {
        data: minDistJoint,
        point: new THREE.Vector3(...minDistJoint.m_pt),
      };
    }
  }
  return null;
};

// 启用捕捉矫正优化
export const enableSnapCorrection = (
  cadCoord, // CAD坐标
  lastPt = null, // 输入的上一个点
  snapModel = false, // 是否需要计算构件捕捉点
  threshold = 60, // 阈值，默认值为150
  isMode = false // 模型模式标志，默认为false
) => {
  const displayData = store.state.displayData;
  if (
    !displayData.endSnapPoint &&
    !displayData.midSnapPoint &&
    !displayData.perSnapPoint &&
    !displayData.intSnapPoint &&
    !displayData.tanSnapPoint &&
    !displayData.cenSnapPoint
  ) {
    return cadCoord;
  }

  const isMobile = isMobileDevice();
  threshold = isMobile ? 40 : 60;
  const minThreshold = isMobile ? 200 : 100;
  const viewCoord = rlAppObj.rlMxDrawObject.getViewDocCoord();
  // 根据视区范围调整文本大小
  let viewWidth = Math.abs(viewCoord.pt3.x - viewCoord.pt1.x);
  viewWidth = viewWidth <= 400 ? 400 : viewWidth;

  let size = viewWidth / threshold;
  size = size < minThreshold ? minThreshold : size;
  let closestPoint = null;
  // let gridPoint = null;
  // let jointPoint = null;
  let modePoint = null;
  // 判断是否是模型-------------------
  if (!isMode) {
    // 计算网格最近点
    closestPoint = getSnapPtOnGrid(cadCoord, lastPt, snapModel, size);
    // gridPoint = getMinDistGrid(cadCoord, size);
    // //计算节点最近点
    // jointPoint = getMinDistJoint(cadCoord, size * 1.3);
  } else {
    // 计算模型最近点
    modePoint = getMinDistModelVertex(cadCoord, size);
  }
  // removeCurrentCanvas2DObject();
  // 确定返回点
  let returnPoint = null;
  if (closestPoint) {
    returnPoint = closestPoint;
  } else if (modePoint) {
    returnPoint = modePoint.point;
  } else {
    returnPoint = cadCoord;
  }
  return returnPoint;
};

// 存储所有标注的ID
let dimensionIds = [];

// 开关轴线距离显示
// export const toggleAxisDist = (flag) => {
//   // 如果标注存在且需要隐藏，则删除标注
//   if (dimensionIds.length > 0 && !flag) {
//     dimensionIds.forEach((id) => {
//       id.getMcDbEntity().erase();
//     });
//     dimensionIds = [];
//     return;
//   }
//   const axisArray = store.state.rlEntData.totalEntityData["rlAxis"];
//   const parallelThreshold = 0.01; // 定义一个阈值误差

//   if (axisArray && axisArray.length > 0) {
//     // 提取起点和终点，并存储斜率信息
//     const lines = axisArray.map((axis) => {
//       const start = axis.m_stJoint.m_pt;
//       const end = axis.m_edJoint.m_pt;
//       const dx = end[0] - start[0];
//       const dy = end[1] - start[1];
//       const slope = dx === 0 ? Infinity : Number((dy / dx).toFixed(2)); // 计算斜率，垂直线的斜率为 Infinity

//       const guid = axis.Guid; // 记录轴线的 Guid
//       return { start, end, slope, guid };
//     });

//     // 分组平行的线
//     const groupedLines = {};
//     lines.forEach((line, index) => {
//       let found = false;
//       Object.keys(groupedLines).forEach((slope) => {
//
//         if (Math.abs(slope - line.slope) <= parallelThreshold) {
//           groupedLines[slope].push({ ...line, index });
//           found = true;
//         }
//       });
//       if (!found) {
//         groupedLines[line.slope] = [{ ...line, index }];
//       }
//     });

//     // 找到每组内相邻且平行的线
//     Object.keys(groupedLines).forEach((slope) => {
//       const group = groupedLines[slope];
//       // 遍历组中的每一对相邻线段
//       for (let i = 0; i < group.length - 1; i++) {
//         // 当前线段
//         const currentLine = group[i];
//         // 下一条线段
//         const nextLine = group[i + 1];

//         // 计算当前线段的A、B、C系数（用于直线方程Ax + By + C = 0）
//         const A = currentLine.end[1] - currentLine.start[1];
//         const B = currentLine.start[0] - currentLine.end[0];
//         const C =
//           currentLine.end[0] * currentLine.start[1] -
//           currentLine.start[0] * currentLine.end[1];

//         // 计算下一条线段起点到当前线段的距离
//         const distance =
//           Math.abs(A * nextLine.start[0] + B * nextLine.start[1] + C) /
//           Math.sqrt(A * A + B * B);

//         // 计算偏移量函数
//         const calculateOffset = (direction, currentPoint, nextPoint) => {
//           // 计算法向量并归一化
//           const normal = new THREE.Vector3(
//             -direction.y,
//             direction.x,
//             0
//           ).normalize();
//           // 根据距离乘以法向量得到偏移量
//           let offset = normal.multiplyScalar(distance);

//           // 计算潜在的终点
//           const potentialEndPoint = new THREE.Vector3(
//             currentPoint[0] + offset.x,
//             currentPoint[1] + offset.y,
//             0
//           );

//           // 如果潜在终点的y坐标与下一点的y坐标差距大于当前点与下一点的y坐标差距，则反向偏移量
//           if (
//             Math.abs(potentialEndPoint.y - nextPoint[1]) >
//             Math.abs(currentPoint[1] - nextPoint[1])
//           ) {
//             offset.multiplyScalar(-1);
//           }

//           return offset;
//         };

//         // 创建标注函数
//         const createDimension = (start, end, offset) => {
//           const mDimension = new McDbAlignedDimension();
//           mDimension.xLine1Point = new McGePoint3d(start[0], start[1]);
//           mDimension.xLine2Point = new McGePoint3d(end[0], end[1]);
//           mDimension.dimLinePoint = new McGePoint3d(start[0], start[1]);

//           // const mxcad = MxCpp.getCurrentMxCAD();
//           // mxcad.addDimStyle(
//           //   "MyDimStyle2",
//           //   "410,0.18,1410,0.09,40,2000",
//           //   "77,1,271,3",
//           //   "",
//           //   ""
//           // );
//           // mxcad.drawDimStyle = "MyDimStyle2";
//           // mxcad.drawDimAligned(100, 0, 2000, 0, 12000, 0);

//           // 计算垂直偏移后的终点
//           const verticalEndPoint = new THREE.Vector3(
//             start[0] + offset.x,
//             start[1] + offset.y,
//             0
//           );

//           mDimension.xLine2Point = new McGePoint3d(
//             verticalEndPoint.x,
//             verticalEndPoint.y
//           );

//           return mDimension;
//         };

//         // 计算当前线段方向向量并归一化
//         let direction = new THREE.Vector3(
//           currentLine.end[0] - currentLine.start[0],
//           currentLine.end[1] - currentLine.start[1],
//           0
//         ).normalize();

//         // 计算偏移量
//         let offset = calculateOffset(
//           direction,
//           currentLine.start,
//           nextLine.start
//         );

//         // 创建并绘制当前线段起点到下一条线段起点的标注
//         let mDimension = createDimension(
//           currentLine.start,
//           nextLine.start,
//           offset
//         );
//         const dimensionId = rlAppObj.mxcadObject.drawEntity(mDimension);
//         dimensionIds.push(dimensionId); // 存储返回的ID

//         // 计算下一条线段方向向量并归一化
//         direction = new THREE.Vector3(
//           nextLine.end[0] - nextLine.start[0],
//           nextLine.end[1] - nextLine.start[1],
//           0
//         ).normalize();

//         // 计算偏移量
//         offset = calculateOffset(direction, currentLine.end, nextLine.end);

//         // 创建并绘制当前线段终点到下一条线段终点的标注
//         mDimension = createDimension(currentLine.end, nextLine.end, offset);
//         const dimensionId2 = rlAppObj.mxcadObject.drawEntity(mDimension);
//         dimensionIds.push(dimensionId2); // 存储返回的ID
//       }
//     });
//   }

//   // 打印存储的ID数组
//
// };

// 延长轴线标注线
const externAxisLine = async (resSortedAxisData) => {
  if (resSortedAxisData) {
    for (let jj = 0; jj < Object.keys(resSortedAxisData).length; jj++) {
      // 获取当前斜率下最端部的位置
      const value = resSortedAxisData[Object.keys(resSortedAxisData)[jj]];

      const sortAxisData = [];
      // 以第一条为基准
      const ptStOrigin = new THREE.Vector3(...value[0].item.m_stJoint.m_pt);
      const ptEdOrigin = new THREE.Vector3(...value[0].item.m_edJoint.m_pt);
      const lineOrigin = new THREE.Line3(ptStOrigin, ptEdOrigin);
      const dirOrigin = new THREE.Vector3()
        .subVectors(ptStOrigin, ptEdOrigin)
        .normalize();
      dirOrigin.x = parseFloat(dirOrigin.x.toFixed(1));
      dirOrigin.y = parseFloat(dirOrigin.y.toFixed(1));

      for (const itemTmp of value) {
        if (itemTmp.item.IsMainAxis < 0) continue;

        const ptSt = new THREE.Vector3(...itemTmp.item.m_stJoint.m_pt);
        const ptEd = new THREE.Vector3(...itemTmp.item.m_edJoint.m_pt);

        const stInsertPt = lineOrigin.closestPointToPoint(ptSt);
        const edInsertPt = lineOrigin.closestPointToPoint(ptEd);

        // 计算起点到插入点的距离
        if (stInsertPt) {
          let distance = ptStOrigin.distanceTo(stInsertPt);
          // 计算方向向量
          const dir = new THREE.Vector3()
            .subVectors(ptStOrigin, stInsertPt)
            .normalize();
          dir.x = parseFloat(dir.x.toFixed(1));
          dir.y = parseFloat(dir.y.toFixed(1));
          // 计算方向向量点积
          const dotProduct = dirOrigin.dot(dir);
          // 如果点积大于0，则距离为负
          if (dotProduct > 0) {
            // distance = -distance;
          } else if (dotProduct < 0) {
            distance = -distance;
          }

          // 将 distance 和 itemTmp 添加到数组中
          sortAxisData.push({ distance, pt: stInsertPt });
        }
        if (edInsertPt) {
          let distance = ptStOrigin.distanceTo(edInsertPt);
          const dir = new THREE.Vector3()
            .subVectors(ptStOrigin, edInsertPt)
            .normalize();
          const dotProduct = dirOrigin.dot(dir);

          if (dotProduct > 0) {
            // distance = -distance;
          } else if (dotProduct < 0) {
            distance = -distance;
          }

          // 将 distance 和 itemTmp 添加到数组中
          sortAxisData.push({ distance, pt: edInsertPt });
        }
      }

      // 按照 distance 数值大小排序
      sortAxisData.sort((a, b) => a.distance - b.distance);

      // 获取最大和最小的点
      const minPt = sortAxisData[0].pt;
      const maxPt = sortAxisData[sortAxisData.length - 1].pt;

      value.forEach((itemTmp) => {
        const ptSt = new THREE.Vector3(...itemTmp.item.m_stJoint.m_pt);
        const ptEd = new THREE.Vector3(...itemTmp.item.m_edJoint.m_pt);
        const lineOrigin = new THREE.Line3(ptSt, ptEd);

        const stInsertPt = lineOrigin.closestPointToPoint(minPt);
        const edInsertPt = lineOrigin.closestPointToPoint(maxPt);
        // itemTmp.item.m_axisLineStPt = stInsertPt;
        // itemTmp.item.m_axisLineEdPt = edInsertPt;

        itemTmp.item.updateAxisDrawData(stInsertPt, edInsertPt);
      });
    }
  }
  // await toggleAxisDist(false); //先删除原有尺寸标记
  // await toggleAxisDist(true); //更新尺寸标记
};

// 开关轴线距离显示
export const toggleAxisDist = (isShow) => {
  // 如果标注存在且需要隐藏，则删除标注
  if (dimensionIds.length > 0 && !isShow) {
    dimensionIds.forEach((id) => {
      id.getMcDbEntity().erase();
    });
    dimensionIds = [];
    return;
  }

  if (!isShow) {
    return;
  }

  let axisArray = store.state.rlEntData.totalEntityData["rlAxis"];
  if (axisArray.length == 0) return;

  //去掉isShow为0的轴线
  axisArray = axisArray.filter((item) => item.isShow == "1");

  // 排序后轴线数组
  const sortList = sortAxisData(axisArray);

  if (!sortList) return;
  externAxisLine(sortList);
  // 将所有轴线在同一方向上长度统一
  // if (resSortedAxisData) {
  //   //获取在当前方向上最端部的两点
  //   for (let jj = 0; jj < Object.keys(resSortedAxisData).length; jj++) {
  //     let minX = -100000000;
  //     let minY = -100000000;
  //     let maxX = 100000000;
  //     let maxY = 100000000;
  //     const boundingBox = new THREE.Box3();

  //     for (let i = 0; i < sortAxisData.length; i++) {
  //       const currentAxis = sortAxisData[i].item;
  //       const currentStart = new THREE.Vector3(
  //         ...currentAxis[i].item.m_stJoint.m_pt
  //       );
  //       const currentEnd = new THREE.Vector3(
  //         ...currentAxis[i].item.m_edJoint.m_pt
  //       );
  //       boundingBox.expandByPoint(
  //         new THREE.Vector3(...currentAxis[i].item.m_stJoint.m_pt)
  //       );
  //       boundingBox.expandByPoint(
  //         new THREE.Vector3(...currentAxis[i].item.m_edJoint.m_pt)
  //       );
  //       // minX = currentStart.x<minX?currentStart.x:minX;
  //       // minY = currentStart.y<minY?currentStart.x:minY;
  //       // maxX = currentEnd.x>maxX?currentEnd.x:maxX;
  //       // maxY = currentEnd.y>maxY?currentEnd.x:maxY;
  //     }
  //   }
  // }

  // 创建绘制标注
  const createDimension = (start, end, StAxisGuid, EdAxisGuid) => {
    const mDimension = new McDbAlignedDimension();
    mDimension.xLine1Point = new McGePoint3d(start.x, start.y);
    mDimension.xLine2Point = new McGePoint3d(end.x, end.y);
    mDimension.dimLinePoint = new McGePoint3d(start.x, start.y);
    mDimension.setDimVarDouble(140, store.state.platBtns.fontSize / 100 - 0.3); // 设置标注文本的字体大小
    mDimension.setDimVarDouble(142, 0.5); // 设置标注文本相对于标注线的偏移量
    mDimension.setDimVarDouble(41, 0.18); // 设置箭头的大小
    mDimension.setDimVarDouble(141, 0.09); // 设置标注线与基线的偏移距离
    mDimension.setDimVarDouble(40, 200); // 设置标注的总长度范围
    mDimension.setDimVarInt(271, 0); // 设置箭头类型
    mDimension.setDimVarInt(173, 1); // 设置是否显示标注的起点和终点标记
    mDimension.setDimVarInt(77, 1); // 文字在标注线之上

    // 设置轴线数据
    mDimension.setxDataString("StAxisGuid", StAxisGuid);
    mDimension.setxDataString("EdAxisGuid", EdAxisGuid);
    const mxcad = MxCpp.getCurrentMxCAD();
    const axisSizeLayer = mxcad.addLayer("轴网尺寸");
    mDimension.layerId = axisSizeLayer;
    const dimensionId = mxcad.drawEntity(mDimension);
    dimensionIds.push(dimensionId);

    // const mxcad = MxCpp.getCurrentMxCAD();
    // let fontSize = store.state.platBtns.fontSize / 100 - 1;
    // mxcad.addDimStyle(
    //   "DimStyle_AxisSize",
    //   `140,${fontSize},142,1,41,0.18,141,0.09,40,200`,
    //   "271,0,173,1",
    //   ""
    // );
    // let number = store.state.platBtns.fontSize;
    //

    // mxcad.drawDimStyle = "DimStyle_AxisSize";
    // dimensionIds.push(
    //   mxcad.drawDimAligned(start.x, start.y, end.x, end.y, start.x, start.y)
    // ); // 存储返回的ID
  };

  const createAxisDimension = (currentAxis1, currentAxis2, moveDist) => {
    // 获取当前轴线的起点和终点
    const currentStart = currentAxis1.item.m_axisLineStPt
      ? currentAxis1.item.m_axisLineStPt
      : new THREE.Vector3(...currentAxis1.item.m_stJoint.m_pt);
    const currentEnd = currentAxis1.item.m_axisLineEdPt
      ? currentAxis1.item.m_axisLineEdPt
      : new THREE.Vector3(...currentAxis1.item.m_edJoint.m_pt);
    // if (currentStart.x > currentEnd.x || currentStart.y > currentEnd.y) {
    //   let tmp = currentStart;
    //   currentStart = currentEnd;
    //   currentEnd = tmp;
    // }
    const lineOrigin = new THREE.Line3(currentStart, currentEnd);

    // 获取当前轴线的起点和终点
    let currentStart2 = currentAxis2.item.m_axisLineStPt
      ? currentAxis2.item.m_axisLineStPt
      : new THREE.Vector3(...currentAxis2.item.m_stJoint.m_pt);
    let currentEnd2 = currentAxis2.item.m_axisLineEdPt
      ? currentAxis2.item.m_axisLineEdPt
      : new THREE.Vector3(...currentAxis2.item.m_edJoint.m_pt);

    // let tmp = currentStart2;
    // currentStart2 = currentEnd2;
    // currentEnd2 = tmp;

    const InsectStPt = lineOrigin.closestPointToPoint(currentStart2);
    const InsectEdPt = lineOrigin.closestPointToPoint(currentEnd2);

    let vecMove = new THREE.Vector3(
      currentStart2.x - currentEnd2.x,
      currentStart2.y - currentEnd2.y
    );

    vecMove = vecMove.normalize();

    if (InsectStPt) {
      InsectStPt.x += vecMove.x * moveDist;
      InsectStPt.y += vecMove.y * moveDist;
      // currentStart2.x += vecMove.x * moveDist;
      // currentStart2.y += vecMove.y * moveDist;
      createDimension(
        InsectStPt,
        new THREE.Vector3(
          currentStart2.x + vecMove.x * moveDist,
          currentStart2.y + vecMove.y * moveDist,
          currentStart2.z
        ),
        currentAxis1.item.Guid,
        currentAxis2.item.Guid
      );
    }

    if (InsectEdPt) {
      InsectEdPt.x -= vecMove.x * moveDist;
      InsectEdPt.y -= vecMove.y * moveDist;
      // currentEnd2.x -= vecMove.x * moveDist;
      // currentEnd2.y -= vecMove.y * moveDist;
      createDimension(
        InsectEdPt,
        new THREE.Vector3(
          currentEnd2.x - vecMove.x * moveDist,
          currentEnd2.y - vecMove.y * moveDist,
          currentEnd2.z
        ),
        currentAxis1.item.Guid,
        currentAxis2.item.Guid
      );
    }
  };

  // 循环对象sortList
  for (const key in sortList) {
    // 获取当前轴线
    const currentAxis = sortList[key];
    if (currentAxis.length <= 1) continue;

    for (let i = 0; i < currentAxis.length - 1; i++) {
      createAxisDimension(currentAxis[i], currentAxis[i + 1], 2000);
    }

    createAxisDimension(
      currentAxis[0],
      currentAxis[currentAxis.length - 1],
      2500
    );
  }
};

export const clearDimensionHighlight = () => {
  if (dimensionIds.length == 0) return;
  dimensionIds.forEach((id) => {
    id.getMcDbEntity().highlight(false);
  });
};

/**
 * 计算多边形的中心点
 *
 * @param {Array} points - 顶点坐标数组，每三个数值表示一个顶点的 x, y, z 坐标
 * @returns {Object} - 返回中心点坐标对象，包含 x, y, z 属性
 */
export const calculateCentroid = (points) => {
  if (
    !Array.isArray(points) ||
    points.length === 0 ||
    points.length % 3 !== 0
  ) {
    return;
  }

  let sumX = 0;
  let sumY = 0;
  let maxX = -Infinity;
  let minX = Infinity;

  // 计算中心点
  for (let i = 0; i < points.length; i += 3) {
    const x = points[i];
    const y = points[i + 1];
    sumX += x;
    sumY += y;
    maxX = Math.max(maxX, x);
    minX = Math.min(minX, x);
  }

  // 计算中心点的xy坐标
  const centerX = sumX / (points.length / 3);
  const centerY = sumY / (points.length / 3);
  const centerPoint = new McGePoint3d(centerX, centerY, 0);

  return centerPoint;
};

// 计算多边形的角点(默认矩形的四个角)
export const calculatePolygonCorner = (points) => {
  if (
    !Array.isArray(points) ||
    points.length === 0 ||
    points.length % 3 !== 0
  ) {
    return;
  }

  const leftTop = new THREE.Vector3(Infinity, -Infinity, 0);
  const rightTop = new THREE.Vector3(-Infinity, -Infinity, 0);
  const rightBottom = new THREE.Vector3(-Infinity, Infinity, 0);
  const leftBottom = new THREE.Vector3(Infinity, Infinity, 0);

  // 计算角点
  for (let i = 0; i < points.length; i += 3) {
    const x = points[i];
    const y = points[i + 1];
    leftTop.x = Math.min(leftTop.x, x);
    leftTop.y = Math.max(leftTop.y, y);
    rightTop.x = Math.max(rightTop.x, x);
    rightTop.y = Math.max(rightTop.y, y);
    rightBottom.x = Math.max(rightBottom.x, x);
    rightBottom.y = Math.min(rightBottom.y, y);
    leftBottom.x = Math.min(leftBottom.x, x);
    leftBottom.y = Math.min(leftBottom.y, y);
  }

  return [leftTop, rightTop, rightBottom, leftBottom];
};

// 设置标注样式
export const setDimStyle = (dimStyle) => {
  rlAppObj.mxcadObject.addDimStyle(
    "MyDimStyle2",
    "41,0.18,141,0.09,40,200",
    "77,1,271,3",
    "",
    ""
  );

  rlAppObj.mxcadObject.drawDimStyle = "MyDimStyle2";
};

// 显示指定类型的构件(传入数组)
export const showEntityByType = (typeNameList) => {
  const mxAll = new MxCADSelectionSet();
  mxAll.allSelect();
  mxAll.forEach((id) => {
    const ent = id.getMcDbEntity();
    if (!ent) return;
    const findName = ent.getxDataString("classTypeName").val;
    if (typeNameList.includes(findName)) {
      ent.visible = true;
    } else {
      ent.visible = false;
    }
  });
};

/**
 * 判断点是否在多边形内部的函数
 * @param {Array} checkPoint 待判断的点坐标,形如[x, y]
 * @param {Array} polygonPoints 多边形的顶点坐标数组,形如[[x1, y1], [x2, y2], ...]
 * @return {Boolean} 如果点在多边形内部,返回true;否则返回false
 */
export function isInPolygon(checkPoint, polygonPoints) {
  // 交点计数器
  var counter = 0;
  // 循环变量
  var i;
  // 射线与边的交点的y坐标
  var xinters;
  // 多边形的相邻两个顶点
  var p1, p2;
  // 多边形的顶点数
  var pointCount = polygonPoints.length;
  // 将多边形的第一个顶点赋给p1
  p1 = polygonPoints[0];

  // 遍历多边形的所有边
  for (i = 1; i <= pointCount; i++) {
    // 将下一个顶点赋给p2
    p2 = polygonPoints[i % pointCount];
    // 判断待判断点的x坐标是否在p1和p2的x坐标之间
    if (
      checkPoint[0] >= Math.min(p1[0], p2[0]) &&
      checkPoint[0] <= Math.max(p1[0], p2[0])
    ) {
      // 如果在,再判断待判断点的y坐标是否小于等于p1和p2中y较大的那个
      if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
        // 如果p1和p2的x坐标不相等,说明不是垂直边
        if (p1[0] != p2[0]) {
          // 计算射线与该边交点的y坐标
          xinters =
            ((checkPoint[0] - p1[0]) * (p2[1] - p1[1])) / (p2[0] - p1[0]) +
            p1[1];
          // 如果p1和p2的y坐标相等(水平边)或者待判断点的y坐标小于等于交点的y坐标,说明相交
          if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
            // 交点计数器加1
            counter++;
          }
        }
      }
    }
    // 将p2赋给p1,继续遍历下一条边
    p1 = p2;
  }
  // 如果交点计数器大于0,说明点在多边形内
  if (counter > 0) {
    return true;
  } else {
    // 否则点在多边形外
    return false;
  }
}

// 读取dwg数据，将文本数据与砌体墙数据绑定
export const exportNoDataBinding = async (dwgFileUrls, type = "PKPM") => {
  if (dwgFileUrls && dwgFileUrls.length) {
    let rlFloor = await getrlFloor();
    if (!rlFloor) return;

    rlFloor.sort((a, b) => {
      return Number(a.No_) - Number(b.No_);
    });
    //地下层数
    let undergroundFloor = 0;
    if (rlFloor[0].No_ < 0) {
      undergroundFloor = rlFloor[0].No_;
    }

    const floorNoData = {};
    rlFloor.map((floorData) => {
      floorNoData[floorData.No_] = floorData;
    });

    const resData = {};
    for (const fileUrl of dwgFileUrls) {
      const dwgData = await getDwgData(fileUrl, type);

      if (dwgData && dwgData.data && dwgData.data.data) {
        // console.log("dwgData", dwgData.data);
        const dwgtype = dwgData.data.type;
        let floorNo = Number(dwgData.data.floorNo);
        if (undergroundFloor != 0) {
          floorNo += undergroundFloor;
          if (floorNo <= 0) {
            floorNo -= 1;
          }
        }

        if (dwgtype && floorNoData[floorNo]) {
          if (dwgtype == "LZPJ") {
            // const floorModelData = await getrlStdFlr(
            //   floorNoData[floorNo].StdFlrGuid
            // );
            // //处理梁柱数据的匹配
            // //匹配梁配筋结果
            // console.log(
            //   "floorModelData",
            //   floorModelData["rlBeamSeg"],
            //   floorNoData[floorNo].StdFlrGuid,
            //   dwgData.data.data,
            //   floorModelData["rlColSeg"]
            // );
            // resData["beam"][floorNo] = await matchYjkBeamCalData(
            //   floorModelData["rlBeamSeg"],
            //   floorNoData[floorNo].StdFlrGuid,
            //   dwgData.data.data,
            //   "PKPM"
            // );
            // //匹配柱配筋结果
            // resData["col"][floorNo] = await matchYjkColumnCalData(
            //   floorModelData["rlColSeg"],
            //   floorNoData[floorNo].StdFlrGuid,
            //   dwgData.data.data,
            //   "PKPM"
            // );
          } else {
            console.log("----------------------------", dwgtype, floorNo);
            const curFloorWallData =
              dwgtype == "PG"
                ? await NoDataBinding_PG(
                    floorNoData[floorNo].StdFlrGuid,
                    dwgData.data.data
                  )
                : await NoDataBinding_new(
                    floorNoData[floorNo].StdFlrGuid,
                    dwgData.data.data
                  );
            if (!resData[dwgtype]) {
              resData[dwgtype] = {};
            }
            resData[dwgtype][floorNo] = {
              FloorGuid: floorNoData[floorNo].Guid,
              data: curFloorWallData,
            };
          }
        }
      }
    }

    console.log("resData", resData);

    // 数据推送
    return resData;
  }
};
// 读取dwg数据，将文本数据与砌体墙数据绑定
export const NoDataBinding = async (currStdFlrId, dataInfo) => {
  try {
    //
    // let dataInfo = JSON.parse(dataJson);
    if (!dataInfo) {
      return;
    }

    // let currStdFlrId = curFloorData[0].StdFlrGuid;

    // 墙
    const wallData = await getRlModules("rlWallSeg", currStdFlrId);
    if (!wallData) return null;

    // 节点
    const jointData = await getRlModules("rlJoint", currStdFlrId);

    if (!jointData) {
      return null;
    }

    const jointKeyValue = {}; // 节点顶点数据
    Object.keys(jointData).map((guid) => {
      const item = jointData[guid];
      jointKeyValue[item.Guid] = new THREE.Vector3(item.X, item.Y, 0);
    });

    // 网格
    const gridData = await getRlModules("rlGrid", currStdFlrId);
    if (!gridData) {
      return null;
    }

    //墙洞
    const wallHoleData = await getRlModules("rlWallHole", currStdFlrId);

    const wallLineData = []; // 墙线计算
    Object.keys(wallData).map((guid) => {
      const item = gridData[wallData[guid]["GridGuid"]]; // 网格数据
      const line = new THREE.Line3(
        jointKeyValue[item.Jt1Guid],
        jointKeyValue[item.Jt2Guid],
        0
      );
      const vecDir = new THREE.Vector3();
      line.delta(vecDir);
      var angle = vecDir.angleTo(new THREE.Vector3(1, 0, 0)); // 计算两个向量之间的角度

      let withHole = false;
      if (wallHoleData && Object.keys(wallHoleData).length) {
        Object.keys(wallHoleData).forEach((holeGuid) => {
          const wallHoleItem = wallHoleData[holeGuid];
          if (wallHoleItem.GridGuid == item.Guid) {
            withHole = true;
          }
        });
      }

      wallLineData.push({
        Guid: guid,
        angle: angle,
        line: new THREE.Line3(
          jointKeyValue[item.Jt1Guid],
          jointKeyValue[item.Jt2Guid],
          0
        ),
        withHole: withHole,
      });
    });

    const resNoData = {}; // 绑定的No数据
    const resNoDataWithHole = {}; // 有墙洞的墙--绑定的No数据
    // const data = dataInfo["data"];
    // let i = 1;
    for (const item of dataInfo) {
      if (item.Layer == "13") {
        const position = new THREE.Vector3(
          item.Position[0],
          item.Position[1],
          item.Position[2]
        ); // 文字位置
        const Rotation = item.Rotation; // 文字角度
        let closetWall = null; // 给文本找一个最近的墙
        let minClostDist = 10000;
        let minMidDist = 10000;
        let testPos = null;

        wallLineData.forEach((wall) => {
          if (
            areRadianEqual(
              wall.angle,
              Rotation
            ) /*Math.abs(wall.angle - Rotation) < 0.01*/
          ) {
            const InsectPt = wall.line.closestPointToPoint(position);
            const clostDistTmp = position.distanceTo(InsectPt);
            const stDist = position.distanceTo(wall.line.start);
            const edDist = position.distanceTo(wall.line.end);
            const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;
            //判断position在wall.line.start的左侧还是右侧
            const isLeft =
              calculatePointPosition(wall.line.start, wall.line.end, position) >
              0;

            if (Math.abs(minClostDist - clostDistTmp) < 10) {
              if (minMidDist > distTmp) {
                closetWall = wall.Guid;
                testPos = wall.line.start;
                minClostDist = clostDistTmp;
                minMidDist = distTmp;
              }
            } else if (minClostDist > clostDistTmp) {
              closetWall = wall.Guid;
              testPos = wall.line.start;
              minClostDist = clostDistTmp;
              minMidDist = distTmp;
            }

            //处理有墙洞的墙:记录所有文字到墙线的距离
            if (wall.withHole) {
              if (resNoDataWithHole[wall.Guid]) {
                resNoDataWithHole[wall.Guid].push({
                  dist: clostDistTmp,
                  text: item.TextString,
                  minMidDist: distTmp,
                  isLeft: isLeft,
                  stDist: stDist,
                  edDist: edDist,
                });
              } else {
                resNoDataWithHole[wall.Guid] = [];
                resNoDataWithHole[wall.Guid].push({
                  dist: clostDistTmp,
                  text: item.TextString,
                  minMidDist: distTmp,
                  isLeft: isLeft,
                  stDist: stDist,
                  edDist: edDist,
                });
              }
            }
          }
        });
        if (minClostDist < 100) {
          // i++;
          if (resNoData[closetWall]) {
            resNoData[closetWall].push(item.TextString);
          } else {
            resNoData[closetWall] = [];
            resNoData[closetWall].push(item.TextString);
          }
        }
      }
    }

    // 判断是否还存在墙没有文本信息wallLineData
    wallLineData.forEach((wall) => {
      if (!resNoData[wall.Guid]) {
        // 找到网格最近的文字
        let closestText = null;
        let minClostDist = 10000; // 文字到网格的最近距离
        let minMidDist = 10000; // 文字到网格终点的最小距离
        dataInfo.forEach((item) => {
          if (item.Layer == "13") {
            const position = new THREE.Vector3(
              item.Position[0],
              item.Position[1],
              item.Position[2]
            ); // 文字位置
            const Rotation = item.Rotation; // 文字角度
            if (
              areRadianEqual(
                wall.angle,
                Rotation
              ) /*Math.abs(wall.angle - Rotation) < 0.01*/
            ) {
              const InsectPt = wall.line.closestPointToPoint(position);
              const clostDistTmp = position.distanceTo(InsectPt);
              const stDist = position.distanceTo(wall.line.start);
              const edDist = position.distanceTo(wall.line.end);
              const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;

              if (Math.abs(minClostDist - clostDistTmp) < 10) {
                if (minMidDist > distTmp) {
                  closestText = item.TextString;
                  minClostDist = clostDistTmp;
                  minMidDist = distTmp;
                }
              } else if (minClostDist > clostDistTmp) {
                closestText = item.TextString;
                minClostDist = clostDistTmp;
                minMidDist = distTmp;
              }
            }
          }
        });

        if (resNoData[wall.Guid]) {
          resNoData[wall.Guid].push(closestText);
        } else {
          resNoData[wall.Guid] = [];
          resNoData[wall.Guid].push(closestText);
        }
      }
    });

    //处理有墙洞的墙
    Object.keys(resNoDataWithHole).forEach((wallGuid) => {
      let textDatas = resNoDataWithHole[wallGuid];
      //取距离最小的前两个文字
      if (textDatas && textDatas.length > 2) {
        textDatas.sort((a, b) => a.dist - b.dist);
        textDatas = textDatas.filter((item) => item.dist < 300);
        //再按水平距离排序，取前2个
        textDatas.sort((a, b) => a.minMidDist - b.minMidDist);
        textDatas = textDatas.slice(0, 2);
      }

      if (resNoData[wallGuid] && textDatas && textDatas.length > 1) {
        // console.log("textDatas", textDatas);
        //按左右排序，若都是左或都是右，按照textData.text的最后一位数字排序
        textDatas.sort((a, b) => a.isLeft - b.isLeft);
        if (textDatas[0].isLeft == textDatas[1].isLeft) {
          textDatas.sort(
            (a, b) =>
              Number(a.text.split("-")[1]) - Number(b.text.split("-")[1])
          );
        }

        resNoData[wallGuid] = [];
        for (const textData of textDatas) {
          resNoData[wallGuid].push(textData.text);
        }
      }
    });

    // console.log("resNoData", resNoData);
    // 目前还存在墙上有洞，且能与左右的墙连接的数据缺失的问题---详情可查看项目《门卫》--待处理
    return resNoData;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

// 读取dwg数据，将文本数据与砌体墙数据绑定
export const NoDataBinding_new = async (currStdFlrId, dataInfo) => {
  try {
    if (!dataInfo) {
      return;
    }

    // 墙
    const wallData = await getRlModules("rlWallSeg", currStdFlrId);
    if (!wallData) return null;

    // 节点
    const jointData = await getRlModules("rlJoint", currStdFlrId);

    if (!jointData) {
      return null;
    }
    //轴线
    const axisDatas = await getRlModules("rlAxis", currStdFlrId);
    if (!axisDatas) {
      return null;
    }

    const jointKeyValue = {}; // 节点顶点数据
    Object.keys(jointData).map((guid) => {
      const item = jointData[guid];
      jointKeyValue[item.Guid] = new THREE.Vector3(item.X, item.Y, 0);
    });

    // 网格
    const gridData = await getRlModules("rlGrid", currStdFlrId);
    if (!gridData) {
      return null;
    }

    //墙洞
    const wallHoleData = await getRlModules("rlWallHole", currStdFlrId);
    const wallHoleSectData = await getRlWallHoleDef();
    const wallSectMap = new Map(
      wallHoleSectData.map((item) => [item.Guid, item])
    );

    //对墙线进行排序，将同一条轴线上的墙归于一类
    let wallLineGroup = {};
    let groupGuids = []; //已统计过的guid
    for (const guid of Object.keys(wallData)) {
      if (groupGuids.includes(guid)) continue;

      const gridGuid = wallData[guid]["GridGuid"];
      const gridObj = gridData[gridGuid];
      if (!gridObj) continue;
      //获取同一轴线上的网格
      const sameAxisGrid = Object.values(gridData).filter((item) => {
        return item.AxisGuid === gridObj.AxisGuid;
      });

      if (sameAxisGrid && sameAxisGrid.length > 0) {
        //获取当前轴线上所有布置了墙的网格
        let wallGrids = Object.values(wallData).filter((item) => {
          return (
            sameAxisGrid.filter((ii) => ii.Guid == item.GridGuid).length > 0
          );
        });

        //对共线网格排序
        wallGrids = sortSameAxisGrids(
          axisDatas[gridObj.AxisGuid].Jt1Guid,
          axisDatas[gridObj.AxisGuid].Jt2Guid,
          jointData,
          gridData,
          wallGrids
        );
        wallLineGroup[gridObj.AxisGuid] = wallGrids;
        for (const otherWall of wallGrids) {
          groupGuids.push(otherWall.guid);
        }
      }
    }

    //将所有相邻墙线连接起来，遇到墙洞则断开，并记录断开点
    const wallLineData = []; // 墙线计算
    let calWallGuid = []; // 计算过的墙Guid
    for (let jj = 0; jj < Object.values(wallLineGroup).length; jj++) {
      const wallGrids = Object.values(wallLineGroup)[jj];
      for (let i = 0; i < wallGrids.length; i++) {
        const guid = wallGrids[i]["Guid"];
        const gridGuid = wallGrids[i]["GridGuid"];
        const gridObj = gridData[gridGuid];
        let stJointGuid = gridObj.Jt1Guid;
        let edJointGuid = gridObj.Jt2Guid;
        let stJtPoint = jointKeyValue[stJointGuid];
        let edJtPoint = jointKeyValue[edJointGuid];

        const line = new THREE.Line3(stJtPoint, edJtPoint, 0);
        const vecDir = new THREE.Vector3();
        line.delta(vecDir);
        var angle = vecDir.angleTo(new THREE.Vector3(1, 0, 0)); // 计算两个向量之间的角度

        let stWithHole = false;
        let edWithHole = false;
        let currWithHole =
          wallHoleData &&
          Object.values(wallHoleData).filter(
            (item) => item.GridGuid === gridGuid
          );
        //若没有洞口，并已经计算，不用重复计算
        if (
          (!currWithHole || currWithHole.length == 0) &&
          calWallGuid.includes(guid)
        ) {
          continue;
        }
        if (currWithHole && currWithHole.length > 0) {
          //判断是否全洞
          let currHoleSect = wallSectMap.get(currWithHole[0].SectGuid);
          if (
            currHoleSect &&
            Math.abs(currHoleSect.B - stJtPoint.distanceTo(edJtPoint)) < 5
          ) {
            continue;
          }
          if (currHoleSect.Ecc == 1)
            //靠左
            stWithHole = true;

          if (currHoleSect.Ecc == -1)
            //靠右
            edWithHole = true;
        }

        calWallGuid.push(guid);

        let stLinkWallGuids = [guid];
        let edLinkWallGuids = [guid];

        //将所有连接的墙线连接起来
        for (const otherWall of wallGrids) {
          if (otherWall.Guid === guid) continue;
          if (stWithHole && edWithHole) break;

          const otherGridObj = gridData[otherWall.GridGuid];
          const otherStJointGuid = otherGridObj.Jt1Guid;
          const otherEdJointGuid = otherGridObj.Jt2Guid;

          const otherWithHole =
            wallHoleData &&
            Object.values(wallHoleData).filter(
              (item) => item.GridGuid === otherWall.GridGuid
            );
          //若没有洞口，并已经计算，不用重复计算
          if (
            (!otherWithHole || otherWithHole.length == 0) &&
            calWallGuid.includes(otherWall.Guid)
          ) {
            continue;
          }
          if (otherWithHole && otherWithHole.length > 0) {
            //判断是否全洞
            let otherHoleSect = wallSectMap.get(otherWithHole[0].SectGuid);
            if (
              otherHoleSect &&
              Math.abs(
                otherHoleSect.B -
                  jointKeyValue[otherStJointGuid].distanceTo(
                    jointKeyValue[otherEdJointGuid]
                  )
              ) < 5
            ) {
              continue;
            }
          }

          if (
            !stWithHole &&
            (otherStJointGuid === stJointGuid ||
              otherEdJointGuid === stJointGuid)
          ) {
            stJointGuid =
              otherStJointGuid === stJointGuid
                ? otherEdJointGuid
                : otherStJointGuid;

            stJtPoint = jointKeyValue[stJointGuid];
            stLinkWallGuids.push(otherWall.Guid);
            if (otherWithHole && otherWithHole.length > 0) {
              stWithHole = true;

              //若有墙洞，取墙线中点
              stJtPoint = new THREE.Vector3().lerpVectors(
                jointKeyValue[otherStJointGuid],
                jointKeyValue[otherEdJointGuid],
                0.5
              );
            }
          } else if (
            !edWithHole &&
            (otherStJointGuid === edJointGuid ||
              otherEdJointGuid === edJointGuid)
          ) {
            edJointGuid =
              otherStJointGuid === edJointGuid
                ? otherEdJointGuid
                : otherStJointGuid;

            edJtPoint = jointKeyValue[edJointGuid];
            edLinkWallGuids.push(otherWall.Guid);
            if (otherWithHole && otherWithHole.length > 0) {
              edWithHole = true;
              //若有墙洞，取墙线中点
              edJtPoint = new THREE.Vector3().lerpVectors(
                jointKeyValue[otherStJointGuid],
                jointKeyValue[otherEdJointGuid],
                0.5
              );
            }
          } else {
            continue;
          }

          calWallGuid.push(otherWall.Guid);
        }

        // 将墙线数据添加到wallLineData中
        if (currWithHole && currWithHole.length > 0) {
          let midPoint = new THREE.Vector3().lerpVectors(
            jointKeyValue[stJointGuid],
            jointKeyValue[edJointGuid],
            0.5
          );
          wallLineData.push({
            Guid: guid,
            linkWallGuids: stLinkWallGuids,
            angle: angle,
            line: new THREE.Line3(stJtPoint, midPoint),
          });

          wallLineData.push({
            Guid: guid,
            linkWallGuids: edLinkWallGuids,
            angle: angle,
            line: new THREE.Line3(midPoint, edJtPoint),
          });
        } else {
          let linkWallGuids = [...stLinkWallGuids, ...edLinkWallGuids];
          wallLineData.push({
            Guid: guid,
            linkWallGuids,
            angle: angle,
            line: new THREE.Line3(
              jointKeyValue[stJointGuid],
              jointKeyValue[edJointGuid]
            ),
          });
        }
      }

      // const stJointGuid = gridObj.Jt1Guid;
      // const edJointGuid = gridObj.Jt2Guid;

      // const item = gridData[wallData[guid]["GridGuid"]]; // 网格数据
      // const line = new THREE.Line3(
      //   jointKeyValue[item.Jt1Guid],
      //   jointKeyValue[item.Jt2Guid],
      //   0
      // );
      // const vecDir = new THREE.Vector3();
      // line.delta(vecDir);
      // var angle = vecDir.angleTo(new THREE.Vector3(1, 0, 0)); // 计算两个向量之间的角度

      // wallLineData.push({
      //   Guid: guid,
      //   angle: angle,
      //   line: new THREE.Line3(
      //     jointKeyValue[item.Jt1Guid],
      //     jointKeyValue[item.Jt2Guid],
      //     0
      //   ),
      // });
    }
    console.log("wallLineData", wallLineData);

    let resNoData = [];
    for (const item of dataInfo) {
      if (item.Layer == "13") {
        const position = new THREE.Vector3(
          item.Position[0],
          item.Position[1],
          item.Position[2]
        ); // 文字位置
        const Rotation = item.Rotation; // 文字角度
        let closetWall = null; // 给文本找一个最近的墙
        let minClostDist = 10000;
        let minMidDist = 10000;
        let testPos = null;

        wallLineData.forEach((wall) => {
          if (
            areRadianEqual(
              wall.angle,
              Rotation
            ) /*Math.abs(wall.angle - Rotation) < 0.01*/
          ) {
            const InsectPt = wall.line.closestPointToPoint(position);
            const clostDistTmp = position.distanceTo(InsectPt);
            const stDist = position.distanceTo(wall.line.start);
            const edDist = position.distanceTo(wall.line.end);
            const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;

            if (Math.abs(minClostDist - clostDistTmp) < 10) {
              if (minMidDist > distTmp) {
                closetWall = wall.linkWallGuids;
                testPos = wall.line.start;
                minClostDist = clostDistTmp;
                minMidDist = distTmp;
              }
            } else if (minClostDist > clostDistTmp) {
              closetWall = wall.linkWallGuids;
              testPos = wall.line.start;
              minClostDist = clostDistTmp;
              minMidDist = distTmp;
            }
          }
        });

        if (closetWall && minClostDist < 300) {
          resNoData.push({
            linkWallGuids: closetWall,
            text: item.TextString,
            minClostDist,
            minMidDist,
          });
        }
      }
    }
    console.log("resNoData", resNoData);

    //resNoData[wallGuid].push(textData.text);
    let returnNoData = {};
    for (let i = 0; i < resNoData.length; i++) {
      const element = resNoData[i];
      const linkWallGuids = [...new Set(element.linkWallGuids)];

      for (let jj = 0; jj < linkWallGuids.length; jj++) {
        const guid = linkWallGuids[jj];
        if (returnNoData[guid]) {
          if (!returnNoData[guid].includes(element.text)) {
            returnNoData[guid].push(element.text);
          }
        } else {
          returnNoData[guid] = [element.text];
        }
      }
    }

    console.log("returnNoData", returnNoData);
    return returnNoData;

    //   // const resNoData = {}; // 绑定的No数据，文字与最近的构件绑定
    //   // const resNoDataWithHole = {}; // 有墙洞的墙--绑定的No数据
    //   // for (const item of dataInfo) {
    //   //   if (item.Layer == "13") {
    //   //     const position = new THREE.Vector3(
    //   //       item.Position[0],
    //   //       item.Position[1],
    //   //       item.Position[2]
    //   //     ); // 文字位置
    //   //     const Rotation = item.Rotation; // 文字角度
    //   //     let closetWall = null; // 给文本找一个最近的墙
    //   //     let minClostDist = 10000;
    //   //     let minMidDist = 10000;
    //   //     let testPos = null;

    //   //     wallLineData.forEach((wall) => {
    //   //       if (
    //   //         areRadianEqual(
    //   //           wall.angle,
    //   //           Rotation
    //   //         ) /*Math.abs(wall.angle - Rotation) < 0.01*/
    //   //       ) {
    //   //         const InsectPt = wall.line.closestPointToPoint(position);
    //   //         const clostDistTmp = position.distanceTo(InsectPt);
    //   //         const stDist = position.distanceTo(wall.line.start);
    //   //         const edDist = position.distanceTo(wall.line.end);
    //   //         const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;
    //   //         //判断position在wall.line.start的左侧还是右侧
    //   //         const isLeft =
    //   //           calculatePointPosition(wall.line.start, wall.line.end, position) >
    //   //           0;

    //   //         if (Math.abs(minClostDist - clostDistTmp) < 10) {
    //   //           if (minMidDist > distTmp) {
    //   //             closetWall = wall.Guid;
    //   //             testPos = wall.line.start;
    //   //             minClostDist = clostDistTmp;
    //   //             minMidDist = distTmp;
    //   //           }
    //   //         } else if (minClostDist > clostDistTmp) {
    //   //           closetWall = wall.Guid;
    //   //           testPos = wall.line.start;
    //   //           minClostDist = clostDistTmp;
    //   //           minMidDist = distTmp;
    //   //         }

    //   //         //处理有墙洞的墙:记录所有文字到墙线的距离
    //   //         if (wall.withHole) {
    //   //           if (resNoDataWithHole[wall.Guid]) {
    //   //             resNoDataWithHole[wall.Guid].push({
    //   //               dist: clostDistTmp,
    //   //               text: item.TextString,
    //   //               minMidDist: distTmp,
    //   //               isLeft: isLeft,
    //   //               stDist: stDist,
    //   //               edDist: edDist,
    //   //             });
    //   //           } else {
    //   //             resNoDataWithHole[wall.Guid] = [];
    //   //             resNoDataWithHole[wall.Guid].push({
    //   //               dist: clostDistTmp,
    //   //               text: item.TextString,
    //   //               minMidDist: distTmp,
    //   //               isLeft: isLeft,
    //   //               stDist: stDist,
    //   //               edDist: edDist,
    //   //             });
    //   //           }
    //   //         }
    //   //       }
    //   //     });
    //   //     if (minClostDist < 100) {
    //   //       // i++;
    //   //       if (resNoData[closetWall]) {
    //   //         resNoData[closetWall].push(item.TextString);
    //   //       } else {
    //   //         resNoData[closetWall] = [];
    //   //         resNoData[closetWall].push(item.TextString);
    //   //       }
    //   //     }
    //   //   }
    //   // }

    //   // // 判断是否还存在墙没有文本信息wallLineData
    //   // wallLineData.forEach((wall) => {
    //   //   if (!resNoData[wall.Guid]) {
    //   //     // 找到网格最近的文字
    //   //     let closestText = null;
    //   //     let minClostDist = 10000; // 文字到网格的最近距离
    //   //     let minMidDist = 10000; // 文字到网格终点的最小距离
    //   //     dataInfo.forEach((item) => {
    //   //       if (item.Layer == "13") {
    //   //         const position = new THREE.Vector3(
    //   //           item.Position[0],
    //   //           item.Position[1],
    //   //           item.Position[2]
    //   //         ); // 文字位置
    //   //         const Rotation = item.Rotation; // 文字角度
    //   //         if (
    //   //           areRadianEqual(
    //   //             wall.angle,
    //   //             Rotation
    //   //           ) /*Math.abs(wall.angle - Rotation) < 0.01*/
    //   //         ) {
    //   //           const InsectPt = wall.line.closestPointToPoint(position);
    //   //           const clostDistTmp = position.distanceTo(InsectPt);
    //   //           const stDist = position.distanceTo(wall.line.start);
    //   //           const edDist = position.distanceTo(wall.line.end);
    //   //           const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;

    //   //           if (Math.abs(minClostDist - clostDistTmp) < 10) {
    //   //             if (minMidDist > distTmp) {
    //   //               closestText = item.TextString;
    //   //               minClostDist = clostDistTmp;
    //   //               minMidDist = distTmp;
    //   //             }
    //   //           } else if (minClostDist > clostDistTmp) {
    //   //             closestText = item.TextString;
    //   //             minClostDist = clostDistTmp;
    //   //             minMidDist = distTmp;
    //   //           }
    //   //         }
    //   //       }
    //   //     });

    //   //     if (resNoData[wall.Guid]) {
    //   //       resNoData[wall.Guid].push(closestText);
    //   //     } else {
    //   //       resNoData[wall.Guid] = [];
    //   //       resNoData[wall.Guid].push(closestText);
    //   //     }
    //   //   }
    //   // });

    //   // //处理有墙洞的墙
    //   // Object.keys(resNoDataWithHole).forEach((wallGuid) => {
    //   //   let textDatas = resNoDataWithHole[wallGuid];
    //   //   //取距离最小的前两个文字
    //   //   if (textDatas && textDatas.length > 2) {
    //   //     textDatas.sort((a, b) => a.dist - b.dist);
    //   //     textDatas = textDatas.filter((item) => item.dist < 300);
    //   //     //再按水平距离排序，取前2个
    //   //     textDatas.sort((a, b) => a.minMidDist - b.minMidDist);
    //   //     textDatas = textDatas.slice(0, 2);
    //   //   }

    //   //   if (resNoData[wallGuid] && textDatas && textDatas.length > 1) {
    //   //     // console.log("textDatas", textDatas);
    //   //     //按左右排序，若都是左或都是右，按照textData.text的最后一位数字排序
    //   //     textDatas.sort((a, b) => a.isLeft - b.isLeft);
    //   //     if (textDatas[0].isLeft == textDatas[1].isLeft) {
    //   //       textDatas.sort(
    //   //         (a, b) =>
    //   //           Number(a.text.split("-")[1]) - Number(b.text.split("-")[1])
    //   //       );
    //   //     }

    //   //     resNoData[wallGuid] = [];
    //   //     for (const textData of textDatas) {
    //   //       resNoData[wallGuid].push(textData.text);
    //   //     }
    //   //   }
    //   // });

    //   // // console.log("resNoData", resNoData);
    //   // // 目前还存在墙上有洞，且能与左右的墙连接的数据缺失的问题---详情可查看项目《门卫》--待处理
    //   // return resNoData;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

// 读取dwg数据，将文本数据与砌体墙--高厚比数据绑定
export const NoDataBinding_PG = async (currStdFlrId, dataInfo, dwgtype) => {
  try {
    if (!dataInfo) {
      return;
    }

    // 墙
    const wallData = await getRlModules("rlWallSeg", currStdFlrId);
    if (!wallData) return null;

    // 节点
    const jointData = await getRlModules("rlJoint", currStdFlrId);

    if (!jointData) {
      return null;
    }
    //轴线
    const axisDatas = await getRlModules("rlAxis", currStdFlrId);
    if (!axisDatas) {
      return null;
    }

    const jointKeyValue = {}; // 节点顶点数据
    Object.keys(jointData).map((guid) => {
      const item = jointData[guid];
      jointKeyValue[item.Guid] = new THREE.Vector3(item.X, item.Y, 0);
    });

    // 网格
    const gridData = await getRlModules("rlGrid", currStdFlrId);
    if (!gridData) {
      return null;
    }
    //获取墙线数据
    const wallLineData = []; // 墙线计算
    for (const guid of Object.keys(wallData)) {
      const gridGuid = wallData[guid]["GridGuid"];
      const gridObj = gridData[gridGuid];
      if (!gridObj) continue;

      let stJointGuid = gridObj.Jt1Guid;
      let edJointGuid = gridObj.Jt2Guid;
      let stJtPoint = jointKeyValue[stJointGuid];
      let edJtPoint = jointKeyValue[edJointGuid];
      const line = new THREE.Line3(stJtPoint, edJtPoint);
      const vecDir = new THREE.Vector3();
      line.delta(vecDir);
      var angle = vecDir.angleTo(new THREE.Vector3(1, 0, 0)); // 计算两个向量之间的角度
      wallLineData.push({
        guid,
        angle: angle,
        line: new THREE.Line3(stJtPoint, edJtPoint),
      });
    }

    let resNoData = {};
    for (const item of dataInfo) {
      if (item.Layer == "13") {
        const position = new THREE.Vector3(
          item.Position[0],
          item.Position[1],
          item.Position[2]
        ); // 文字位置
        const Rotation = item.Rotation; // 文字角度
        let closetWall = null; // 给文本找一个最近的墙
        let minClostDist = 10000;
        let minMidDist = 10000;
        let testPos = null;

        wallLineData.forEach((wall) => {
          if (
            areRadianEqual(
              wall.angle,
              Rotation
            ) /*Math.abs(wall.angle - Rotation) < 0.01*/
          ) {
            const InsectPt = wall.line.closestPointToPoint(position);
            const clostDistTmp = position.distanceTo(InsectPt);
            const stDist = position.distanceTo(wall.line.start);
            const edDist = position.distanceTo(wall.line.end);
            const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;

            if (Math.abs(minClostDist - clostDistTmp) < 10) {
              if (minMidDist > distTmp) {
                closetWall = wall.guid;
                testPos = wall.line.start;
                minClostDist = clostDistTmp;
                minMidDist = distTmp;
              }
            } else if (minClostDist > clostDistTmp) {
              closetWall = wall.guid;
              testPos = wall.line.start;
              minClostDist = clostDistTmp;
              minMidDist = distTmp;
            }
          }
        });

        resNoData[closetWall] = {
          guid: closetWall,
          text: item.TextString,
          minClostDist,
          minMidDist,
        };
      }
    }

    //查找没有匹配到文本的构件，再次查找最近的文字
    wallLineData.forEach((wall) => {
      if (!resNoData[wall.guid]) {
        // debugger;
        let closetText = null; // 给墙找一个最近的文本
        let minClostDist = 10000;
        let minMidDist = 10000;

        for (const item of dataInfo) {
          if (item.Layer == "13") {
            const position = new THREE.Vector3(
              item.Position[0],
              item.Position[1],
              item.Position[2]
            ); // 文字位置
            const Rotation = item.Rotation; // 文字角度
            if (
              areRadianEqual(
                wall.angle,
                Rotation
              ) /*Math.abs(wall.angle - Rotation) < 0.01*/
            ) {
              const InsectPt = wall.line.closestPointToPoint(position);
              const clostDistTmp = position.distanceTo(InsectPt);
              const stDist = position.distanceTo(wall.line.start);
              const edDist = position.distanceTo(wall.line.end);
              const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;

              if (Math.abs(minClostDist - clostDistTmp) < 10) {
                if (minMidDist > distTmp) {
                  closetText = item;
                  minClostDist = clostDistTmp;
                  minMidDist = distTmp;
                }
              } else if (minClostDist > clostDistTmp) {
                closetText = item;
                minClostDist = clostDistTmp;
                minMidDist = distTmp;
              }
            }
          }
        }

        if (closetText) {
          resNoData[wall.guid] = {
            guid: wall.guid,
            text: closetText.TextString,
            minClostDist,
            minMidDist,
          };
        }
      }
    });

    console.log("resNoData1111", resNoData);

    //resNoData[wallGuid].push(textData.text);
    let returnNoData = {};
    for (const guid of Object.keys(resNoData)) {
      const element = resNoData[guid];
      returnNoData[guid] = [element.text];
    }

    console.log("returnNoData11111", returnNoData);
    return returnNoData;
    //   // const resNoDataWithHole = {}; // 有墙洞的墙--绑定的No数据
    //   // for (const item of dataInfo) {
    //   //   if (item.Layer == "13") {
    //   //     const position = new THREE.Vector3(
    //   //       item.Position[0],
    //   //       item.Position[1],
    //   //       item.Position[2]
    //   //     ); // 文字位置
    //   //     const Rotation = item.Rotation; // 文字角度
    //   //     let closetWall = null; // 给文本找一个最近的墙
    //   //     let minClostDist = 10000;
    //   //     let minMidDist = 10000;
    //   //     let testPos = null;

    //   //     wallLineData.forEach((wall) => {
    //   //       if (
    //   //         areRadianEqual(
    //   //           wall.angle,
    //   //           Rotation
    //   //         ) /*Math.abs(wall.angle - Rotation) < 0.01*/
    //   //       ) {
    //   //         const InsectPt = wall.line.closestPointToPoint(position);
    //   //         const clostDistTmp = position.distanceTo(InsectPt);
    //   //         const stDist = position.distanceTo(wall.line.start);
    //   //         const edDist = position.distanceTo(wall.line.end);
    //   //         const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;
    //   //         //判断position在wall.line.start的左侧还是右侧
    //   //         const isLeft =
    //   //           calculatePointPosition(wall.line.start, wall.line.end, position) >
    //   //           0;

    //   //         if (Math.abs(minClostDist - clostDistTmp) < 10) {
    //   //           if (minMidDist > distTmp) {
    //   //             closetWall = wall.Guid;
    //   //             testPos = wall.line.start;
    //   //             minClostDist = clostDistTmp;
    //   //             minMidDist = distTmp;
    //   //           }
    //   //         } else if (minClostDist > clostDistTmp) {
    //   //           closetWall = wall.Guid;
    //   //           testPos = wall.line.start;
    //   //           minClostDist = clostDistTmp;
    //   //           minMidDist = distTmp;
    //   //         }

    //   //         //处理有墙洞的墙:记录所有文字到墙线的距离
    //   //         if (wall.withHole) {
    //   //           if (resNoDataWithHole[wall.Guid]) {
    //   //             resNoDataWithHole[wall.Guid].push({
    //   //               dist: clostDistTmp,
    //   //               text: item.TextString,
    //   //               minMidDist: distTmp,
    //   //               isLeft: isLeft,
    //   //               stDist: stDist,
    //   //               edDist: edDist,
    //   //             });
    //   //           } else {
    //   //             resNoDataWithHole[wall.Guid] = [];
    //   //             resNoDataWithHole[wall.Guid].push({
    //   //               dist: clostDistTmp,
    //   //               text: item.TextString,
    //   //               minMidDist: distTmp,
    //   //               isLeft: isLeft,
    //   //               stDist: stDist,
    //   //               edDist: edDist,
    //   //             });
    //   //           }
    //   //         }
    //   //       }
    //   //     });
    //   //     if (minClostDist < 100) {
    //   //       // i++;
    //   //       if (resNoData[closetWall]) {
    //   //         resNoData[closetWall].push(item.TextString);
    //   //       } else {
    //   //         resNoData[closetWall] = [];
    //   //         resNoData[closetWall].push(item.TextString);
    //   //       }
    //   //     }
    //   //   }
    //   // }

    //   // // 判断是否还存在墙没有文本信息wallLineData
    //   // wallLineData.forEach((wall) => {
    //   //   if (!resNoData[wall.Guid]) {
    //   //     // 找到网格最近的文字
    //   //     let closestText = null;
    //   //     let minClostDist = 10000; // 文字到网格的最近距离
    //   //     let minMidDist = 10000; // 文字到网格终点的最小距离
    //   //     dataInfo.forEach((item) => {
    //   //       if (item.Layer == "13") {
    //   //         const position = new THREE.Vector3(
    //   //           item.Position[0],
    //   //           item.Position[1],
    //   //           item.Position[2]
    //   //         ); // 文字位置
    //   //         const Rotation = item.Rotation; // 文字角度
    //   //         if (
    //   //           areRadianEqual(
    //   //             wall.angle,
    //   //             Rotation
    //   //           ) /*Math.abs(wall.angle - Rotation) < 0.01*/
    //   //         ) {
    //   //           const InsectPt = wall.line.closestPointToPoint(position);
    //   //           const clostDistTmp = position.distanceTo(InsectPt);
    //   //           const stDist = position.distanceTo(wall.line.start);
    //   //           const edDist = position.distanceTo(wall.line.end);
    //   //           const distTmp = (stDist + edDist) / 2; // stDist > edDist ? edDist : stDist;

    //   //           if (Math.abs(minClostDist - clostDistTmp) < 10) {
    //   //             if (minMidDist > distTmp) {
    //   //               closestText = item.TextString;
    //   //               minClostDist = clostDistTmp;
    //   //               minMidDist = distTmp;
    //   //             }
    //   //           } else if (minClostDist > clostDistTmp) {
    //   //             closestText = item.TextString;
    //   //             minClostDist = clostDistTmp;
    //   //             minMidDist = distTmp;
    //   //           }
    //   //         }
    //   //       }
    //   //     });

    //   //     if (resNoData[wall.Guid]) {
    //   //       resNoData[wall.Guid].push(closestText);
    //   //     } else {
    //   //       resNoData[wall.Guid] = [];
    //   //       resNoData[wall.Guid].push(closestText);
    //   //     }
    //   //   }
    //   // });

    //   // //处理有墙洞的墙
    //   // Object.keys(resNoDataWithHole).forEach((wallGuid) => {
    //   //   let textDatas = resNoDataWithHole[wallGuid];
    //   //   //取距离最小的前两个文字
    //   //   if (textDatas && textDatas.length > 2) {
    //   //     textDatas.sort((a, b) => a.dist - b.dist);
    //   //     textDatas = textDatas.filter((item) => item.dist < 300);
    //   //     //再按水平距离排序，取前2个
    //   //     textDatas.sort((a, b) => a.minMidDist - b.minMidDist);
    //   //     textDatas = textDatas.slice(0, 2);
    //   //   }

    //   //   if (resNoData[wallGuid] && textDatas && textDatas.length > 1) {
    //   //     // console.log("textDatas", textDatas);
    //   //     //按左右排序，若都是左或都是右，按照textData.text的最后一位数字排序
    //   //     textDatas.sort((a, b) => a.isLeft - b.isLeft);
    //   //     if (textDatas[0].isLeft == textDatas[1].isLeft) {
    //   //       textDatas.sort(
    //   //         (a, b) =>
    //   //           Number(a.text.split("-")[1]) - Number(b.text.split("-")[1])
    //   //       );
    //   //     }

    //   //     resNoData[wallGuid] = [];
    //   //     for (const textData of textDatas) {
    //   //       resNoData[wallGuid].push(textData.text);
    //   //     }
    //   //   }
    //   // });

    //   // // console.log("resNoData", resNoData);
    //   // // 目前还存在墙上有洞，且能与左右的墙连接的数据缺失的问题---详情可查看项目《门卫》--待处理
    //   // return resNoData;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

//对共线网格排序
export const sortSameAxisGrids = (
  stJointGuid,
  edJointGuid,
  jointDatas,
  gridDatas,
  sortGrids
) => {
  if (!jointDatas[stJointGuid] || !jointDatas[edJointGuid]) {
    return sortGrids;
  }
  const ptSt = new THREE.Vector3(
    jointDatas[stJointGuid].X,
    jointDatas[stJointGuid].Y,
    0
  );
  const ptEd = new THREE.Vector3(
    jointDatas[edJointGuid].X,
    jointDatas[edJointGuid].Y,
    0
  );
  const ptMid = ptSt.clone().add(ptEd).multiplyScalar(0.5);
  sortGrids = sortGrids.sort((a, b) => {
    const ptA_St = new THREE.Vector3(
      jointDatas[gridDatas[a.GridGuid].Jt1Guid].X,
      jointDatas[gridDatas[a.GridGuid].Jt1Guid].Y,
      0
    );
    const ptA_Ed = new THREE.Vector3(
      jointDatas[gridDatas[a.GridGuid].Jt2Guid].X,
      jointDatas[gridDatas[a.GridGuid].Jt2Guid].Y,
      0
    );
    const ptA_Mid = ptA_St.clone().add(ptA_Ed).multiplyScalar(0.5);
    const ptB_St = new THREE.Vector3(
      jointDatas[gridDatas[b.GridGuid].Jt1Guid].X,
      jointDatas[gridDatas[b.GridGuid].Jt1Guid].Y,
      0
    );
    const ptB_Ed = new THREE.Vector3(
      jointDatas[gridDatas[b.GridGuid].Jt2Guid].X,
      jointDatas[gridDatas[b.GridGuid].Jt2Guid].Y,
      0
    );
    const ptB_Mid = ptB_St.clone().add(ptB_Ed).multiplyScalar(0.5);
    return ptA_Mid.distanceTo(ptSt) - ptB_Mid.distanceTo(ptSt);
  });
  return sortGrids;
};

const getWallLineData = (startPoint, endPoint, HoleId) => {
  // 获取所有线段
  let wallPoints = [];
  wallPoints.push({ pt: startPoint, dist: 0 });
  wallPoints.push({ pt: endPoint, dist: startPoint.distanceTo(endPoint) });

  let rlDoorsWindows = getEntityData({
    Guid: HoleId,
    classTypeName: "rlWallHole",
  });
  if (rlDoorsWindows) {
    let ptLongCenterStart = rlDoorsWindows.draw2dData.ptLongCenterStart;
    let ptLongCenterEnd = rlDoorsWindows.draw2dData.ptLongCenterEnd;
    //对比ptLongCenterStart和ptLongCenterEnd距离墙起点的距离
    let distStart = ptLongCenterStart.distanceTo(startPoint);
    let distEnd = ptLongCenterEnd.distanceTo(startPoint);
    //如果ptLongCenterStart距离墙起点的距离大于ptLongCenterEnd距离墙起点的距离，则交换ptLongCenterStart和ptLongCenterEnd
    if (distStart > distEnd) {
      [ptLongCenterStart, ptLongCenterEnd] = [
        ptLongCenterEnd,
        ptLongCenterStart,
      ];
    }
    wallPoints.push({
      pt: ptLongCenterStart,
      dist: ptLongCenterStart.distanceTo(startPoint),
    });
    wallPoints.push({
      pt: ptLongCenterEnd,
      dist: ptLongCenterEnd.distanceTo(startPoint),
    });
  }

  // 按照起点到墙起点的距离排序
  wallPoints.sort((a, b) => {
    return a.dist - b.dist;
  });

  let wallLines = [];
  for (let i = 0; i < wallPoints.length - 1; i++) {
    const pt1 = wallPoints[i];
    const pt2 = wallPoints[i + 1];
    if (!pt1.equals(pt2)) {
      wallLines.push({ pt1, pt2 });
    }
  }
  return wallLines;
};

//判断两个弧度是否相等或者相差整数倍的π
export function areRadianEqual(radian1, radian2, epsilon = 1e-2) {
  // Normalize radians to the range [0, 2π)
  const normalizedRadian1 =
    ((radian1 % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
  const normalizedRadian2 =
    ((radian2 % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);

  // Helper function to check if two numbers are approximately equal within a given tolerance
  const approximatelyEqual = (a, b, tol) => Math.abs(a - b) < tol;

  // Check if they are equal or differ by a multiple of π within the tolerance
  return (
    approximatelyEqual(normalizedRadian1, normalizedRadian2, epsilon) ||
    approximatelyEqual(
      Math.abs(normalizedRadian1 - normalizedRadian2),
      Math.PI,
      epsilon
    ) ||
    approximatelyEqual(
      Math.abs(normalizedRadian1 - normalizedRadian2),
      2 * Math.PI,
      epsilon
    )
  );
}

//判断两弧度是否垂直
export function areRadiansPerpendicular(rad1, rad2) {
  // Normalize radians to be between 0 and 2π
  const normalizedRad1 = rad1 % (2 * Math.PI);
  const normalizedRad2 = rad2 % (2 * Math.PI);

  // Calculate the absolute difference between the two angles
  const diff1 = Math.abs(normalizedRad1 - normalizedRad2);
  const diff2 = Math.abs(normalizedRad1 - (normalizedRad2 + Math.PI));

  // Check if the differences are approximately π/2
  return (
    Math.abs(diff1 - Math.PI / 2) < 1e-2 || Math.abs(diff2 - Math.PI / 2) < 1e-2
  );
}

// 验算结果--承载力显示
export const showCalData = async (showChooseObj) => {
  const colsegCalculate = await getCalData("colsegCalculate"); // 柱数据
  const beamsegCalculate = await getCalData("beamsegCalculate"); // 梁数据
  const masonryWallsegCalculate = await getCalData("masonryWallsegCalculate"); // 砌体墙数据
  const slabCalculate = await getCalData("masonrySlabCalculate"); // 楼板数据

  console.log(
    " store.state.cadModules.rlBuilding.No_",
    store.state.cadModules.rlBuilding.No_,
    store.state.globalData.rl_floor_arr
  );

  try {
    if (colsegCalculate && colsegCalculate.data) {
      // 查找当前画布中的柱子，绘制柱计算结果数据
      const colData = store.state.rlEntData.totalEntityData["rlColSeg"];
      colsegCalculate.data.forEach((cal) => {
        let objCol = colData.filter((item) => item.Guid == cal.ColSegGuid);
        if (objCol && objCol.length) {
          objCol = objCol[0];

          objCol.drawJcData(
            cal,
            showChooseObj["rlColSeg"] != 0,
            showChooseObj["rlColSeg"]
          );
        }
      });
    }

    if (beamsegCalculate && beamsegCalculate.data) {
      // 查找当前画布中的梁，绘制梁计算结果数据
      const beamData = store.state.rlEntData.totalEntityData["rlBeamSeg"];
      beamsegCalculate.data.forEach((cal) => {
        let objBeam = beamData.filter((item) => item.Guid == cal.BeamSegGuid);
        if (objBeam && objBeam.length) {
          objBeam = objBeam[0];
          objBeam.drawJcData(
            cal,
            showChooseObj["rlBeamSeg"] != 0,
            showChooseObj["rlBeamSeg"]
          );
        }
      });
    }

    if (masonryWallsegCalculate && masonryWallsegCalculate.data) {
      // console.log("masonryWallsegCalculate", showChooseObj["rlWallSeg"]);
      // 查找当前画布中的梁，绘制梁计算结果数据
      const wallData = store.state.rlEntData.totalEntityData["rlWallSeg"];
      for (let i = 0; i < wallData.length; i++) {
        const wall = wallData[i];
        if (wall) {
          let jcDatas = masonryWallsegCalculate.data.filter(
            (item) => item.WallSegGuid == wall.Guid
          );
          if (jcDatas && jcDatas.length) {
            wall.drawJcData(
              jcDatas,
              showChooseObj["rlWallSeg"] != 0,
              showChooseObj["rlWallSeg"]
            );
          }
        }
      }
      // masonryWallsegCalculate.data.forEach((cal) => {
      //   let objWall = wallData.filter((item) => item.Guid == cal.WallSegGuid);
      //   if (objWall && objWall.length) {
      //     objWall = objWall[0];
      //     objWall.drawJcData(
      //       cal,
      //       showChooseObj["rlWallSeg"] != 0,
      //       showChooseObj["rlWallSeg"]
      //     );
      //   }
      // });
    }

    if (slabCalculate && slabCalculate.data) {
      for (const slab of slabCalculate.data) {
        const objSlab = store.state.rlEntData.totalEntityData["rlSlab"];
        const slabObj = objSlab.filter((item) => item.Guid == slab.SlabGuid);
        if (slabObj && slabObj.length) {
          slabObj[0].drawJcData(
            slab.Rebar,
            slab.Support,
            showChooseObj["rlSlab"] == 2,
            slab.ProblemError
          );
        }
      }
    }
    rlAppObj.rlMxDrawObject.updateDisplay();
  } catch (error) {
    console.log("error", error);
  }
};

// 清空当前画布的验算结果
export const eraseCalData = async () => {
  const colData = store.state.rlEntData.totalEntityData["rlColSeg"];
  colData.forEach((objCol) => {
    if (objCol) {
      objCol.eraseJcData();
    }
  });

  const beamData = store.state.rlEntData.totalEntityData["rlBeamSeg"];
  beamData.forEach((objBeam) => {
    if (objBeam) {
      objBeam.eraseJcData();
    }
  });

  const wallData = store.state.rlEntData.totalEntityData["rlWallSeg"];
  wallData.forEach((objWall) => {
    if (objWall) {
      objWall.eraseJcData();
    }
  });

  const slabData = store.state.rlEntData.totalEntityData["rlSlab"];
  slabData.forEach((objSlab) => {
    if (objSlab) {
      if (objSlab) {
        objSlab.eraseJcData();
      }
    }
  });
};

// 根据截面批量删除构件
export const deleteJcBySection = async (guid) => {
  // 查找该截面下的构件
  const allMxEntity = getAllEntityData(true);
  const erasePromises = [];
  const delIds = [];
  allMxEntity.forEach((tmpEnt) => {
    if (
      tmpEnt &&
      tmpEnt.m_sectParamData &&
      tmpEnt.m_sectParamData.Guid == guid
    ) {
      // 获取关联的楼板
      const slabIds = [];
      if (
        tmpEnt.classTypeName == "rlWallSeg" &&
        !tmpEnt.m_gridData.m_beamId &&
        tmpEnt.m_slabIds &&
        tmpEnt.m_slabIds.length
      ) {
        slabIds.push(...tmpEnt.m_slabIds);
      } else if (
        tmpEnt.classTypeName == "rlBeamSeg" &&
        !tmpEnt.m_gridData.m_wallId &&
        tmpEnt.m_slabIds &&
        tmpEnt.m_slabIds.length
      ) {
        slabIds.push(...tmpEnt.m_slabIds);
      }

      if (slabIds.length) {
        delIds.push(...slabIds);
        for (let i = 0; i < slabIds.length; i++) {
          const obj = getEntityData({
            Guid: slabIds[i],
            classTypeName: "rlSlab",
          });
          if (obj) erasePromises.push(tmpEnt.erase());
        }
      }
      delIds.push(tmpEnt.Guid);
      // 将 erase 操作的 Promise 添加到数组中
      erasePromises.push(tmpEnt.erase());
    }
  });
  // 等待所有 erase 操作完成
  await Promise.all(erasePromises);
  await setDelModule(delIds);
  rlAppObj.rlMxDrawObject.updateDisplay();
  return delIds;
};

// 根据截面批量删除非结构构件
export const deleteNonStructuralBySection = async (guid) => {
  // 查找该截面下的构件
  const allMxEntity = getAllEntityData(true);
  const erasePromises = [];
  const delIds = [];
  allMxEntity.forEach((tmpEnt) => {
    if (
      tmpEnt &&
      tmpEnt.m_sectParamData &&
      tmpEnt.m_sectParamData.Guid == guid
    ) {
      delIds.push(tmpEnt.Guid);
      // 将 erase 操作的 Promise 添加到数组中
      erasePromises.push(tmpEnt.erase());
    }
  });
  // 等待所有 erase 操作完成
  await Promise.all(erasePromises);
  rlAppObj.rlMxDrawObject.updateDisplay();
  return delIds;
};

// 获取要删除的截面是否包含检测数据
export const getDetectionData = async (guid, typeId) => {
  let delRes = false;
  // 获取所有楼层
  const rlTotalFloor = await getrlFloor();
  // 是否存在被关联删除的楼板有检测数据
  let isDelSlab = false;
  // 遍历楼层，获取所有构件
  for (const floor of rlTotalFloor) {
    const floorData = await getrlStdFlr(floor.StdFlrGuid);
    if (floorData) {
      let floorModelData = null;
      switch (typeId) {
        // 301:柱
        case 301:
          floorModelData = floorData["rlColSeg"];
          break;
        // 302:梁
        case 302:
          floorModelData = floorData["rlBeamSeg"];
          break;
        // 303:墙
        case 303:
          floorModelData = floorData["rlWallSeg"];
          break;
        // 304:板
        case 304:
          floorModelData = floorData["rlSlab"];
          break;
        // 305:墙洞
        case 305:
          floorModelData = floorData["rlWallHole"];
          break;
        // 306:板洞
        case 306:
          floorModelData = floorData["rlSlabHole"];
          break;
        // 307:圈梁
        case 307:
          floorModelData = floorData["rlRingBeamSeg"];
          break;
        // 309:次梁
        case 309:
          floorModelData = floorData["rlSubBeam"];
          break;
        default:
          floorModelData = null;
          break;
      }
      if (floorModelData) {
        let slabDatas = null;
        let otherDatas = null;
        if (typeId == 303 || typeId == 302) {
          slabDatas = floorData["rlSlab"];
          otherDatas =
            typeId == 302 ? floorData["rlWallSeg"] : floorData["rlBeamSeg"];
        }
        var ids = [];
        Object.values(floorModelData).forEach((item) => {
          if (item.SectGuid == guid) {
            ids.push(item.Guid);
            // 若存在关联楼板，则查找关联楼板，并确定是否存在其他的墙/梁
            if (slabDatas) {
              const gridGuid = item.GridGuid;
              const otherObj = otherDatas
                ? Object.values(otherDatas).filter(
                    (item) => item.gridGuid == gridGuid
                  )
                : null;

              // 若不存在其他的墙/梁，则查找关联楼板
              if (!otherObj || otherObj.length == 0) {
                const slabObj = Object.values(slabDatas).filter((item) =>
                  item.GridsGuid.split(",").includes(gridGuid)
                );
                if (slabObj && slabObj.length) {
                  ids.push(slabObj[0].Guid);
                  isDelSlab = true;
                }
              }
            }
          }
        });

        delRes = await getDelText(ids, floor.Guid, floor.No_);
        if (delRes) {
          break;
        }
      }
    }
  }
  // console.log("ids", ids);
  // // 查找该截面下的构件
  // const allMxEntity = getAllEntityData(true);
  // var ids = [];
  // // 将forEach改为map，并返回一个Promise数组
  // const promises = allMxEntity.map((tmpEnt) => {
  //   return new Promise((resolve) => {
  //     if (
  //       tmpEnt &&
  //       tmpEnt.m_sectParamData &&
  //       tmpEnt.m_sectParamData.Guid == guid
  //     ) {
  //       ids.push(tmpEnt.Guid);

  //       if (
  //         tmpEnt.classTypeName == "rlWallSeg" &&
  //         !tmpEnt.m_gridData.m_beamId &&
  //         tmpEnt.m_slabIds &&
  //         tmpEnt.m_slabIds.length
  //       ) {
  //         ids.push(...tmpEnt.m_slabIds);
  //       } else if (
  //         tmpEnt.classTypeName == "rlBeamSeg" &&
  //         !tmpEnt.m_gridData.m_wallId &&
  //         tmpEnt.m_slabIds &&
  //         tmpEnt.m_slabIds.length
  //       ) {
  //         ids.push(...tmpEnt.m_slabIds);
  //       }
  //     }
  //     resolve();
  //   });
  // });
  // // 使用Promise.all等待所有Promise完成
  // await Promise.all(promises);
  // 掉接口获取是否有检测数据
  // var delRes = await getDelText(ids);
  return delRes && isDelSlab
    ? "该截面对应构件和关联楼板的检测数据已录，不能删除！"
    : delRes
    ? "该截面对应构件的检测数据已录，不能删除"
    : "该截面对应构件也将删除，请确认是否删除";
};

// 检测是否有检测数据
export const getDelText = async (ids, floorGuid, floorNo) => {
  // 掉接口获取是否有检测数据
  var res = await detection({
    project_id: store.state.cadModules.rlProject_id, // 是	int	项目id
    guids: ids, // 是	array、string	构件guids
    flr_guid: floorGuid || store.state.cadModules.rlBuilding.Guid, // 是	string	楼层guid
    flr_no: floorNo || store.state.cadModules.rlBuilding.No_, // 是	int	楼层号
  });
  return res.data.is_detection;
};

// 删除构件(接口)
export const setDelModule = async (ids) => {
  // 调用接口删除数据
  await confirmDelete({
    project_id: store.state.cadModules.rlProject_id, // 是	int	项目id
    guids: ids, // 是	array、string	构件guids
    flr_guid: store.state.cadModules.rlBuilding.Guid, // 是	string	楼层guid
    flr_no: store.state.cadModules.rlBuilding.No_, // 是	int	楼层号
  });
};

// 删除楼层中的检测数据
export const delFloorDetectionData = async (floorGuid, floorNo) => {
  try {
    const res = await delFloorDetection({
      project_id: store.state.cadModules.rlProject_id, // 是	int	项目id
      flr_guid: floorGuid, // 是	array、string	构件guids
      flr_no: floorNo, // 是	int	楼层号
    });

    return res.success;
  } catch (error) {
    return false;
  }
};

// 绘制测量
export const drawMeasure = async (type) => {
  // 删除对齐标注组
  del_entity_group("rlAlignedDimension");

  await new Promise((resolve, reject) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    // 实例化对齐标注
    const alignedDimension = new rlAlignedDimension();
    getPoint.go((status) => {
      if (status != 0) {
        // 改变底部按钮状态

        // 删除对齐标注组
        del_entity_group("rlAlignedDimension");
        return;
      }

      // 当前鼠标位置
      let pt1 = getPoint.value();

      // 启用捕捉优化
      const snapPoint = enableSnapCorrection(pt1);
      pt1 = snapPoint || pt1;

      // 设置第一个点位置
      alignedDimension.setPoint1(pt1);

      // 设置第一个点位置
      getPoint.setUserDraw((currentPoint, worldDrawComment) => {
        // 设置第二个点位置
        alignedDimension.setPoint2(currentPoint);
        // 绘制
        worldDrawComment.drawCustomEntity(alignedDimension);
      });
      // 第二次点击鼠标
      getPoint.go((status2) => {
        if (status2 !== 0) {
          // 改变底部按钮状态

          // 删除对齐标注组
          del_entity_group("rlAlignedDimension");
          return;
        }
        const pt2 = getPoint.value();
        alignedDimension.setPoint2(pt2);
        rlAppObj._rlMx.MxFun.getCurrentDraw().addMxEntity(alignedDimension);
        // 添加到对齐标注组
        const rlGroup = rlAppObj.rlMxDatabase.addGroup(
          alignedDimension.m_groupName
        );
        rlGroup.append(alignedDimension);
        resolve(this);
      });
    });
  });
};

// 获取选中的实体
export const getSelectEntity = (point, filter) => {
  // 检查是否能直接找到实体
  const findId = rlAppObj.rlMxCpp.MxCADUtility.findEntAtPoint(
    point.x,
    point.y,
    point.z,
    -1,
    filter
  );

  // 如果直接找到实体并且能获取到对应实体数据，直接返回
  // 避免查询前提前清除高亮 - 延迟到确实需要高亮时才清除，减少不必要操作
  if (findId) {
    try {
      const finObj = findId.getMcDbEntity();
      if (finObj) {
        const findGuid = finObj.getxDataString("Guid").val;
        const findName = finObj.getxDataString("classTypeName").val;
        if (findGuid && findName) {
          return findId;
        }
      }
    } catch (e) {
      // 静默处理错误，继续查找其他实体
    }
  }

  // 按优先级和通常使用频率排序
  // 将最常被点击的构件类型放在前面，可以提高命中率
  const componentTypes = [
    "rlColSeg", // 柱构件 - 常用
    "rlWallSeg", // 墙构件 - 常用
    "rlBeamSeg", // 梁构件 - 常用
    "rlSlab", // 板构件 - 常用
    "rlCantiSlab", // 悬挑板 - 常用
    "rlWallHole", // 墙洞 - 次常用
    "rlDoorsWindows", // 门窗 - 次常用
    "rlPartitionWallSeg", // 隔墙 - 次常用
    "rlSlabHole", // 板洞 - 较少用
  ];

  // 预先获取totalEntityData，避免在循环中重复访问
  const totalEntityData = store.state.rlEntData.totalEntityData;

  // 针对点选位置创建一个简单的包围盒检查，用于快速筛选
  // 这可以在进行更详细的多边形检查前快速排除许多构件
  const checkPointX = point.x;
  const checkPointY = point.y;
  const checkDistance = 5.0; // 点选容差范围

  // 使用for循环替代多次重复的代码块，提高性能和可维护性
  for (let i = 0; i < componentTypes.length; i++) {
    const type = componentTypes[i];
    const modelGroup = totalEntityData[type];

    // 如果该类型的模型组存在，检查点是否在其中
    if (modelGroup && modelGroup.length > 0) {
      // 使用快速预筛选优化 - 首先检查哪些构件可能在点选区域内
      let potentialMatches = [];

      // 第一阶段：快速粗筛选
      for (let j = 0; j < modelGroup.length; j++) {
        const item = modelGroup[j];
        if (!item || !item.mcDbId) continue;

        // 获取构件的基本包围盒信息
        // 这里可以从对象缓存中获取或直接计算一个粗略边界
        try {
          const objDraw = item.mcDbId.getMcDbEntity();
          if (!objDraw || !objDraw.visible) continue;

          // 简单检查构件是否可能包含选择点
          // 仅检查第一个和最后一个点，得到大致范围
          if (objDraw.numVerts() < 3) continue;

          // 计算粗略的包围盒
          let minX = Infinity,
            minY = Infinity;
          let maxX = -Infinity,
            maxY = -Infinity;

          // 只采样少量点来加速检查
          const numVerts = objDraw.numVerts();
          const sampleStep =
            numVerts > 20 ? 2 : Math.max(1, Math.floor(numVerts / 4)); //针对弧形构件做特殊处理
          for (let k = 0; k < numVerts; k += sampleStep) {
            const pt = objDraw.getPointAt(k).val;
            minX = Math.min(minX, pt.x);
            minY = Math.min(minY, pt.y);
            maxX = Math.max(maxX, pt.x);
            maxY = Math.max(maxY, pt.y);
          }

          // 扩展包围盒以容纳点选误差
          minX -= checkDistance;
          minY -= checkDistance;
          maxX += checkDistance;
          maxY += checkDistance;

          // 快速检查点是否在包围盒内
          if (
            checkPointX >= minX &&
            checkPointX <= maxX &&
            checkPointY >= minY &&
            checkPointY <= maxY
          ) {
            potentialMatches.push(item);
          }
        } catch (e) {
          continue; // 出错时跳过此项
        }
      }

      // 第二阶段：对潜在匹配项进行精确检查
      for (let j = 0; j < potentialMatches.length; j++) {
        const item = potentialMatches[j];
        const objDraw = item.mcDbId.getMcDbEntity();

        // 获取多边形点
        const numVerts = objDraw.numVerts();
        const polygonPoints = [];
        for (let k = numVerts - 1; k >= 0; k--) {
          polygonPoints.push(objDraw.getPointAt(k).val);
        }

        // 使用优化的点在多边形内检测
        if (isPointInPolygon(point, polygonPoints)) {
          return item.mcDbId;
        }
      }
    }
  }

  // 没有找到任何匹配项，返回原始findId（可能为null或undefined）
  return findId;
};

// 优化isPointInModel函数，提高性能
export const isPointInModel = (point, ModelGroup) => {
  if (!ModelGroup || ModelGroup.length === 0) {
    return false;
  }

  // 使用缓存减少反复获取多边形点
  for (let i = 0; i < ModelGroup.length; i++) {
    const item = ModelGroup[i];
    if (!item || !item.mcDbId) continue;

    const objDraw = item.mcDbId.getMcDbEntity();
    if (!objDraw || !objDraw.visible) continue;

    // 快速预检查：如果多边形顶点太少，跳过
    const numVerts = objDraw.numVerts();
    if (numVerts < 3) continue;

    // 获取多边形点
    const polygonPoints = [];
    for (let j = numVerts - 1; j >= 0; j--) {
      polygonPoints.push(objDraw.getPointAt(j).val);
    }

    // 使用优化的点在多边形内检测
    if (isPointInPolygon(point, polygonPoints)) {
      return item.mcDbId;
    }
  }

  return false;
};

// 优化isPointInPolygon函数，提高点在多边形内的检测性能
export const isPointInPolygon = (point, polygonPoints, epsilon = 0.0001) => {
  if (!polygonPoints || polygonPoints.length < 3) {
    return false;
  }

  const x = point.x;
  const y = point.y;

  // 首先进行包围盒快速检查，如果点不在包围盒内，立即返回false
  let minX = Infinity,
    minY = Infinity;
  let maxX = -Infinity,
    maxY = -Infinity;

  // 计算多边形的包围盒
  for (let i = 0; i < polygonPoints.length; i++) {
    const pt = polygonPoints[i];
    minX = Math.min(minX, pt.x);
    minY = Math.min(minY, pt.y);
    maxX = Math.max(maxX, pt.x);
    maxY = Math.max(maxY, pt.y);
  }

  // 扩展包围盒，考虑浮点误差
  minX -= epsilon;
  minY -= epsilon;
  maxX += epsilon;
  maxY += epsilon;

  // 如果点不在包围盒内，直接返回false
  if (x < minX || x > maxX || y < minY || y > maxY) {
    return false;
  }

  // 边界情况：检查点是否在任何边上
  for (
    let i = 0, j = polygonPoints.length - 1;
    i < polygonPoints.length;
    j = i++
  ) {
    const xi = polygonPoints[i].x;
    const yi = polygonPoints[i].y;
    const xj = polygonPoints[j].x;
    const yj = polygonPoints[j].y;

    // 检查点是否在边上 - 使用优化的线检测
    if (isPointOnLineSegment(x, y, xi, yi, xj, yj, epsilon)) {
      return true;
    }
  }

  // 射线法检查点是否在多边形内部 - 使用偶奇规则
  let inside = false;
  for (
    let i = 0, j = polygonPoints.length - 1;
    i < polygonPoints.length;
    j = i++
  ) {
    const xi = polygonPoints[i].x;
    const yi = polygonPoints[i].y;
    const xj = polygonPoints[j].x;
    const yj = polygonPoints[j].y;

    // 优化的射线算法，避免不必要的计算
    const intersect =
      yi > y !== yj > y && // 一个点在射线上方，一个在下方
      x < ((xj - xi) * (y - yi)) / (yj - yi) + xi; // 交点在射线右侧

    if (intersect) inside = !inside;
  }

  return inside;
};

// 辅助函数:检查点是否在线段上
const isPointOnLineSegment = (px, py, x1, y1, x2, y2, epsilon) => {
  // 检查点是否在线段的包围盒内
  const minX = Math.min(x1, x2) - epsilon;
  const maxX = Math.max(x1, x2) + epsilon;
  const minY = Math.min(y1, y2) - epsilon;
  const maxY = Math.max(y1, y2) + epsilon;

  if (px < minX || px > maxX || py < minY || py > maxY) {
    return false;
  }

  // 处理垂直线段
  if (Math.abs(x1 - x2) < epsilon) {
    return Math.abs(px - x1) < epsilon;
  }

  // 处理水平线段
  if (Math.abs(y1 - y2) < epsilon) {
    return Math.abs(py - y1) < epsilon;
  }

  // 使用叉积检查点是否在线段上
  const crossProduct = Math.abs((py - y1) * (x2 - x1) - (px - x1) * (y2 - y1));
  return crossProduct < epsilon;
};

// 清空测量绘制数据
export const clearMeasureDrawData = async () => {
  const measureDrawDataArray = store.state.rlEntData.MeasureDrawData;
  if (measureDrawDataArray) {
    measureDrawDataArray.forEach((item) => {
      item?.getMcDbEntity().erase();
    });
  }
};

// 显示构件强度
export const showComponentStrength = (visible) => {
  // 获取构件数据
  const colModelData = store.state.rlEntData.totalEntityData["rlColSeg"];
  const wallModelData = store.state.rlEntData.totalEntityData["rlWallSeg"];
  const beamModelData = store.state.rlEntData.totalEntityData["rlBeamSeg"];
  const slabModelData = store.state.rlEntData.totalEntityData["rlSlab"];
  if (colModelData) {
    colModelData.forEach((item) => {
      item.createStrengthText(visible);
    });
  }

  if (wallModelData) {
    wallModelData.forEach((item) => {
      item.createStrengthText(visible);
    });
  }
  if (beamModelData) {
    beamModelData.forEach((item) => {
      item.createStrengthText(visible);
    });
  }
  if (slabModelData) {
    slabModelData.forEach((item) => {
      item.createStrengthText(visible);
    });
  }
};

// 更新构件强度
export const updateComponentStrength = async () => {
  // 从数据库中获取构件强度数据
  const rlInitFloorData = await getRlInitFloorData(
    store.state.cadModules.rlBuilding.StdFlrGuid
  );

  const stdFlrData = rlInitFloorData.stdFlrData;
  const beamData = stdFlrData["rlBeamSeg"];
  const colData = stdFlrData["rlColSeg"];
  const wallData = stdFlrData["rlWallSeg"];
  const slabData = stdFlrData["rlSlab"];

  for (const key in beamData) {
    const beam = getEntityData({ Guid: key, classTypeName: "rlBeamSeg" });
    if (beam) {
      beam.Strength = beamData[key].Strength;
      store.commit("rlEntData/editEntityData", beam);
      beam.createStrengthText(true);
    }
  }

  for (const key in colData) {
    const col = getEntityData({ Guid: key, classTypeName: "rlColSeg" });
    if (col) {
      col.Strength = colData[key].Strength;
      store.commit("rlEntData/editEntityData", col);
      col.createStrengthText(true);
    }
  }

  for (const key in wallData) {
    const wall = getEntityData({ Guid: key, classTypeName: "rlWallSeg" });
    if (wall) {
      wall.Strength = wallData[key].Strength;
      store.commit("rlEntData/editEntityData", wall);
      wall.createStrengthText(true);
    }
  }

  for (const key in slabData) {
    const slab = getEntityData({ Guid: key, classTypeName: "rlSlab" });
    if (slab) {
      slab.Strength = slabData[key].Strength;
      store.commit("rlEntData/editEntityData", slab);
      slab.createStrengthText(true);
    }
  }
};

// 将操作步骤下的所有数据更新到数据库中
export const saveDatabaseStore = async () => {
  // 清除所有高亮
  clearAllHighLight();
  if (store.state.globalData.databaseStore) {
    try {
      const res = await dealRlModulesData(
        store.state.globalData.rl_stdFlr_id,
        store.state.globalData.databaseStore
      );
      // 若保存失败，则回滚画布数据
      if (!res) rollbackErrorData();

      store.commit("globalData/setDatabaseStore", {});

      if (
        res &&
        !store.state.globalData.isReDo &&
        store.state.globalData.canAddRawStep
      ) {
        try {
          //若同时是新增和删除，则从新增和删除中删除
          let dataStore = store.state.globalData.revokeDataStore;
          if (dataStore.add && dataStore.delete) {
            // 创建guid集合用于快速查找
            const addGuids = new Set(dataStore.add.map((item) => item.Guid));
            const deleteGuids = new Set(
              dataStore.delete.map((item) => item.Guid)
            );

            // 过滤掉同时存在于add和delete中的项
            dataStore.delete = dataStore.delete.filter(
              (item) => !addGuids.has(item.Guid)
            );
            dataStore.add = dataStore.add.filter(
              (item) => !deleteGuids.has(item.Guid)
            );
          }

          if (await saveStepRevokeData(dataStore)) {
            store.commit("globalData/setCanAddRawStep", false);
          }
        } catch (error) {
          console.error("保存撤销数据失败:", error);
          // 如果保存失败，可以在这里添加重试逻辑或其他处理
        }
        store.commit("globalData/setRevokeDataStore", {});
      }

      return true;
    } catch (error) {
      console.error("保存数据库存储失败:", error);
      // 异常情况下处理存储数据的画布显示--确保数据库与画布数据一致
      deleteErrorData();
      return false;
    }
  }
};

// 异常情况下数据回滚--确保数据库与画布数据一致
export const rollbackErrorData = async () => {
  try {
    const datas = store.state.globalData.databaseStore;
    if (datas) {
      if (datas["add"]) {
        restoreAddData(drawDatas);
      }

      if (datas["delete"]) {
      }

      if (datas["edit_after"] && datas["edit_before"]) {
      }
    }
  } catch (error) {
    return false;
  }
};

// 存储数据中的新增数据回滚,只需要处理画布数据
const restoreAddData = (addData) => {
  for (let i = 0; i < addData.length; i++) {
    const item = addData[i];
    item.rollbackAdd();
  }
};
// 存储数据中的编辑数据回滚
const restoreEditData = (edit_afterDatas, edit_beforeDatas) => {};

// 添加在store变更时清除缓存的方法
export const clearEntityCache = () => {
  entityCache.clear();
};

// 当实体数据被修改时清除缓存的方法
export const invalidateEntityCache = (classTypeName, guid) => {
  if (guid) {
    // 如果提供了具体的guid，只清除特定实体的缓存
    const cacheKey = `${classTypeName}:${guid}`;
    if (entityCache.cache.has(cacheKey)) {
      entityCache.cache.delete(cacheKey);
    }
  } else if (classTypeName) {
    // 如果只提供了类型，清除该类型的所有缓存
    for (const key of entityCache.cache.keys()) {
      if (key.startsWith(`${classTypeName}:`)) {
        entityCache.cache.delete(key);
      }
    }
  } else {
    // 如果没有提供参数，清除所有缓存
    entityCache.clear();
  }
};

//更新构件检查状态
export const updateComponentCheckStatus = async (currentItem) => {
  if (
    store.state.cadModules.rlProject_detail.businessTypePermission !==
      "investigate" &&
    (currentItem.classTypeName == "rlBeamSeg" ||
      currentItem.classTypeName == "rlColSeg" ||
      currentItem.classTypeName == "rlWallSeg" ||
      currentItem.classTypeName == "rlSlab")
  ) {
    const { data: checkData } = await getpickstatus({
      project_id: store.state.cadModules.rlProject_id,
      flr_guid: store.state.cadModules.rlBuilding.Guid,
      guid: currentItem.Guid,
    });
    let checkStatus = store.state.inspectionStore.checkStatus;
    if (checkData) {
      if (currentItem.classTypeName == "rlWallSeg") {
        let find = checkStatus.find((item) => item.guid == currentItem.Guid);
        console.log("find", find);
        if (find) {
          find.content = checkData.content;
        } else {
          checkStatus.push({
            guid: currentItem.Guid,
            status: checkData.status,
            content: checkData.content,
          });
        }
      } else if (currentItem.classTypeName == "rlBeamSeg") {
        let find = checkStatus.find((item) => item.guid == currentItem.Guid);
        if (find) {
          find.content = checkData.content;
        } else {
          checkStatus.push({
            guid: currentItem.Guid,
            status: checkData.status,
            content: checkData.content,
          });
        }
      } else if (currentItem.classTypeName == "rlSlab") {
        let find = checkStatus.find((item) => item.guid == currentItem.Guid);
        if (find) {
          find.content = checkData.content;
        } else {
          checkStatus.push({
            guid: currentItem.Guid,
            status: checkData.status,
            content: checkData.content,
          });
        }
      } else if (currentItem.classTypeName == "rlColSeg") {
        let find = checkStatus.find((item) => item.guid == currentItem.Guid);
        if (find) {
          find.content = checkData.content;
        } else {
          checkStatus.push({
            guid: currentItem.Guid,
            status: checkData.status,
            content: checkData.content,
          });
        }
      }
    }
    if (checkStatus) {
      store.commit("inspectionStore/setCheckStatus", checkStatus);
    }
    //修改构件已检测文字
    if (
      currentItem.classTypeName == "rlWallSeg" ||
      currentItem.classTypeName == "rlBeamSeg"
    ) {
      await currentItem.m_gridData.drawCheckText();
    } else {
      await currentItem.drawCheckText();
    }

    // 更新显示
    await rlAppObj.rlMxDrawObject.updateDisplay();
  }
};

// 判断是否存在墙梁柱未转正
export const isCorrectedWallBeamCol = async () => {
  try {
    let floorGuids = [];
    //获取所有楼层的Guid
    for (
      let index = 0;
      index < store.state.globalData.rl_floor_arr.length;
      index++
    ) {
      const floor = store.state.globalData.rl_floor_arr[index];
      floorGuids.push(floor.StdFlrGuid);
    }
    for (let i_guid = 0; i_guid < floorGuids.length; i_guid++) {
      const floorGuid = floorGuids[i_guid];

      let floorModelData = await getrlStdFlr(floorGuid);
      if (!floorModelData) continue;
      let currJointData = floorModelData["rlJoint"];
      let currColData = floorModelData["rlColSeg"];
      if (currColData) {
        for (let i_col = 0; i_col < Object.keys(currColData).length; i_col++) {
          const col = currColData[Object.keys(currColData)[i_col]];
          if (!currJointData || !currJointData[col.JtGuid]) {
            return false;
          }
        }
      }

      let currGridData = floorModelData["rlGrid"];
      let currBeamData = floorModelData["rlBeamSeg"];
      if (currBeamData) {
        for (
          let i_beam = 0;
          i_beam < Object.keys(currBeamData).length;
          i_beam++
        ) {
          const beam = currBeamData[Object.keys(currBeamData)[i_beam]];
          if (!currGridData || !currGridData[beam.GridGuid]) {
            return false;
          }
        }
      }

      let currWallData = floorModelData["rlWallSeg"];
      if (currWallData) {
        for (
          let i_wall = 0;
          i_wall < Object.keys(currWallData).length;
          i_wall++
        ) {
          const wall = currWallData[Object.keys(currWallData)[i_wall]];
          if (!currGridData || !currGridData[wall.GridGuid]) {
            return false;
          }
        }
      }
    }
    return true;
  } catch (error) {
    console.log("判断是否存在墙梁柱未转正出现异常", error);
    return true;
  }
};

// 将缓存函数挂载到window对象上，以便store可以使用
window.clearEntityCache = clearEntityCache;
window.invalidateEntityCache = invalidateEntityCache;
